import { rest } from 'msw';

export const getCampaigns = [
	rest.get('http://localhost:4000/api/products/campaigns', (req, res, ctx) => {
		return res(
			ctx.status(200),
			ctx.json(
				[
					{
						'id': '05614299-d4af-44bc-865a-65c12df03cac',
						'badge': {
							'nl': "Délices d'Alexine",
							'fr': "Délices d'Alexine",
							'color': {
								'text': '#000000',
								'bg': '#f6bcbc'
							}
						},
						'filter': {
							'nl': "Délices d'Alexine",
							'fr': "Délices d'Alexine"
						},
						'articles': [
							26380,
							26381,
							26382,
							26383,
							26384,
							26385,
							26386,
							26387,
							26388,
							26321,
							26322,
							26323,
							26324,
							26325,
							26326,
							26376
						],
						'start': '2024-09-25T22:00:00.000Z',
						'end': '2024-12-30T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '05614299-d4af-44bc-865a-65c12df03cac',
							'name': {
								'nl': "Délices d'Alexine",
								'fr': "Délices d'Alexine"
							},
							'start': '2024-09-25T22:00:00.000Z',
							'end': '2024-12-30T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': "Délices d'Alexine",
										'fr': "Délices d'Alexine"
									}
								},
								'badge': {
									'text': {
										'nl': "Délices d'Alexine",
										'fr': "Délices d'Alexine"
									},
									'color': {
										'text': '#000000',
										'background': '#f6bcbc'
									}
								},
								'ids': [
									26380,
									26381,
									26382,
									26383,
									26384,
									26385,
									26386,
									26387,
									26388,
									26321,
									26322,
									26323,
									26324,
									26325,
									26326,
									26376
								]
							},
							'banners': [
								{
									'id': '32e1d458-6427-4438-9133-9773f00cf633',
									'image': {
										'multilingual': true,
										'nl': 'https://portal.charles.eu/resources/campaigns/05614299-d4af-44bc-865a-65c12df03cac/yogpfvexqsihnawrbtlm43581.Banners_delice_alexine.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '10'
								}
							]
						}
					},
					{
						'id': '06c610ba-146e-410d-88e5-499e623b686e',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2024-09-21T22:00:00.000Z',
						'end': '2025-09-29T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '06c610ba-146e-410d-88e5-499e623b686e',
							'name': {
								'nl': 'Folder spaaractie 2024-2025',
								'fr': "Action d'épargne 2024-2025"
							},
							'start': '2024-09-21T22:00:00.000Z',
							'end': '2025-09-29T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/06c610ba-146e-410d-88e5-499e623b686e/tvjdisohlkexgurcbfap26431.Charles_Spaaractie_cover.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'Spaar voor ultieme belevenissen',
									'fr': 'épargnez pour des expériences ultimes\n'
								},
								'items': [
									{
										'id': 'b8735878-a860-4102-bb90-169b77a162a8',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/06c610ba-146e-410d-88e5-499e623b686e/dofxauzkvjbesctqhwrn72038.Charles_Spaaractie_NL.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/06c610ba-146e-410d-88e5-499e623b686e/gwkqmtrzbixvljncafpy05685.Charles_Spaaractie_FR.pdf'
										},
										'description': {
											'nl': 'Klik hier om de spaarfolder te bekijken - deelnemend assortiment',
											'fr': "Cliquez ici pour consulter la brochure d'épargne - gamme participante"
										}
									}
								]
							}
						}
					},
					{
						'id': '07a707e6-cd87-4d39-81c3-f11af5ee805e',
						'badge': {
							'nl': 'Folder 05',
							'fr': 'Dépliant 05',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 05',
							'fr': 'Dépliant 05'
						},
						'articles': [
							26435,
							26436,
							26437,
							26438,
							26439,
							26440,
							1682,
							1688,
							1722,
							247,
							130,
							19009,
							21493,
							21499,
							201,
							21466,
							2111,
							2106,
							18343,
							25566,
							24022,
							26456,
							7773,
							2361,
							2366,
							31564,
							2350,
							2301,
							2308,
							26086,
							1155,
							2520,
							26380,
							26381,
							26382,
							26383,
							26384,
							26385,
							26386,
							26387,
							3139,
							25290,
							3197,
							24660,
							26301,
							26302,
							7524,
							7527,
							7559,
							7589,
							7034,
							26142,
							26199,
							23378,
							7514,
							2084,
							7014,
							2256,
							5619,
							21978,
							5622,
							26524,
							2212,
							5608,
							19518,
							19517,
							8503,
							23742,
							22188,
							2074,
							8596,
							7862,
							7821,
							7819,
							7820,
							7845,
							7803,
							7833,
							7854,
							7809,
							7811,
							7810,
							7830,
							7829,
							7843,
							7824,
							7852,
							7835,
							7873,
							7801,
							7804,
							7834,
							2056,
							7815,
							7816,
							2055,
							7817,
							7825,
							7297,
							7812,
							7813,
							23204,
							32256,
							32205,
							7100,
							19709,
							4301,
							4302,
							23266,
							24045,
							19820,
							31858
						],
						'start': '2025-02-22T23:00:00.000Z',
						'end': '2025-03-08T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '07a707e6-cd87-4d39-81c3-f11af5ee805e',
							'name': {
								'nl': 'Folder 05 - W09-10',
								'fr': 'Dépliant 05 - S09-10'
							},
							'start': '2025-02-22T23:00:00.000Z',
							'end': '2025-03-08T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 05',
										'fr': 'Dépliant 05'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 05',
										'fr': 'Dépliant 05'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									26435,
									26436,
									26437,
									26438,
									26439,
									26440,
									1682,
									1688,
									1722,
									247,
									130,
									19009,
									21493,
									21499,
									201,
									21466,
									2111,
									2106,
									18343,
									25566,
									24022,
									26456,
									7773,
									2361,
									2366,
									31564,
									2350,
									2301,
									2308,
									26086,
									1155,
									2520,
									26380,
									26381,
									26382,
									26383,
									26384,
									26385,
									26386,
									26387,
									3139,
									25290,
									3197,
									24660,
									26301,
									26302,
									7524,
									7527,
									7559,
									7589,
									7034,
									26142,
									26199,
									23378,
									7514,
									2084,
									7014,
									2256,
									5619,
									21978,
									5622,
									26524,
									2212,
									5608,
									19518,
									19517,
									8503,
									23742,
									22188,
									2074,
									8596,
									7862,
									7821,
									7819,
									7820,
									7845,
									7803,
									7833,
									7854,
									7809,
									7811,
									7810,
									7830,
									7829,
									7843,
									7824,
									7852,
									7835,
									7873,
									7801,
									7804,
									7834,
									2056,
									7815,
									7816,
									2055,
									7817,
									7825,
									7297,
									7812,
									7813,
									23204,
									32256,
									32205,
									7100,
									19709,
									4301,
									4302,
									23266,
									24045,
									19820,
									31858
								]
							},
							'documents': {
								'cover': {
									'weight': '100',
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/07a707e6-cd87-4d39-81c3-f11af5ee805e/facezrhibodgxnluvtmj92389.Charles_Folder_05 cover portal.jpg'
								},
								'copy': {
									'nl': 'Ontdek onze folderpromoties hier',
									'fr': 'Cliquez ici pour consultez le dépliant'
								},
								'items': [
									{
										'id': 'e24294c0-9f3f-49ff-997a-eeadafd2f930',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/07a707e6-cd87-4d39-81c3-f11af5ee805e/qmujkyefsaxhtclgbvwn62266.Charles_Folder_05.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consultez le dépliant'
										}
									},
									{
										'id': '941f2207-27a7-47c9-95a8-6d43697fe525',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/07a707e6-cd87-4d39-81c3-f11af5ee805e/tqjronvhugalefbipsyd21091.Charles_Folder_05_spread.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/07a707e6-cd87-4d39-81c3-f11af5ee805e/tjhlebycpwoxrvfsgqiz84629.Charles_Folder_05_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': '891a16d2-59c0-494c-8eea-219537462e6d',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/07a707e6-cd87-4d39-81c3-f11af5ee805e/ohjsalxvidefbctynkwu29440.Banners_Folder_05 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/07a707e6-cd87-4d39-81c3-f11af5ee805e/ivxkftawnjsozlqdebhp07258.Banners_Folder_05 FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': '08a3887e-ccf2-4bc4-b589-01a569c3da8f',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							129
						],
						'start': '2025-06-23T22:00:00.000Z',
						'end': '2025-06-28T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '08a3887e-ccf2-4bc4-b589-01a569c3da8f',
							'name': {
								'nl': 'Parmahammen',
								'fr': ''
							},
							'start': '2025-06-23T22:00:00.000Z',
							'end': '2025-06-28T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									129
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c',
						'badge': {
							'nl': 'Folder 07',
							'fr': 'Dépliant 07',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 07',
							'fr': 'Dépliant 07'
						},
						'articles': [
							25456,
							462,
							456,
							28,
							29,
							26536,
							23656,
							23986,
							23977,
							2108,
							4454,
							4692,
							557,
							705,
							714,
							729,
							22060,
							25959,
							1530,
							1533,
							8366,
							23352,
							25194,
							83,
							8035,
							196,
							18170,
							25680,
							25683,
							2043,
							2065,
							2081,
							8547,
							24752,
							24774,
							25025,
							19351,
							4638,
							24247,
							7549,
							2502,
							26043,
							30007,
							6632,
							4675,
							6648,
							4544,
							6650,
							6172,
							2749,
							2838,
							2840,
							2845,
							2847,
							2875,
							2923,
							19645,
							18664,
							26036,
							26039,
							3341,
							3162,
							25288,
							26406,
							3091,
							3242,
							7033,
							70,
							55,
							69,
							79,
							92,
							1527,
							1566,
							1567,
							1570,
							1584,
							1580,
							1579,
							1581,
							7525,
							7544,
							23646,
							19847,
							7615,
							23379,
							19406,
							8502,
							2253,
							2146,
							2255,
							26525,
							5621,
							30991,
							5615,
							22770,
							5607,
							23077,
							22771,
							5603,
							5600,
							5604,
							5602,
							22769,
							5601,
							5620,
							5613,
							5619,
							5618,
							5608,
							5616,
							22059,
							5612,
							5610,
							5611,
							5609,
							5606,
							5614,
							19238,
							25040,
							23707,
							18539,
							30877,
							8582,
							22191,
							8554,
							8601,
							8075,
							5281,
							32288,
							2808,
							32286,
							22555,
							2721,
							23336,
							5283,
							5230,
							32295,
							2720,
							22128,
							32302,
							32292,
							22127,
							7442,
							32287,
							7443,
							32289,
							2731,
							21381,
							8985,
							26217,
							26111,
							32304,
							7795,
							26112,
							7396,
							2783,
							7113,
							7300,
							7303,
							7304,
							7301,
							7302,
							23400,
							23483,
							23365,
							26153,
							21719,
							21720,
							19486,
							26756,
							26751,
							26752,
							26753,
							26754
						],
						'start': '2025-03-22T23:00:00.000Z',
						'end': '2025-04-05T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c',
							'name': {
								'nl': 'Folder 07 - W13-14',
								'fr': 'Dépliant 07 - S13-14'
							},
							'start': '2025-03-22T23:00:00.000Z',
							'end': '2025-04-05T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 07',
										'fr': 'Dépliant 07'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 07',
										'fr': 'Dépliant 07'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									25456,
									462,
									456,
									28,
									29,
									26536,
									23656,
									23986,
									23977,
									2108,
									4454,
									4692,
									557,
									705,
									714,
									729,
									22060,
									25959,
									1530,
									1533,
									8366,
									23352,
									25194,
									83,
									8035,
									196,
									18170,
									25680,
									25683,
									2043,
									2065,
									2081,
									8547,
									24752,
									24774,
									25025,
									19351,
									4638,
									24247,
									7549,
									2502,
									26043,
									30007,
									6632,
									4675,
									6648,
									4544,
									6650,
									6172,
									2749,
									2838,
									2840,
									2845,
									2847,
									2875,
									2923,
									19645,
									18664,
									26036,
									26039,
									3341,
									3162,
									25288,
									26406,
									3091,
									3242,
									7033,
									70,
									55,
									69,
									79,
									92,
									1527,
									1566,
									1567,
									1570,
									1584,
									1580,
									1579,
									1581,
									7525,
									7544,
									23646,
									19847,
									7615,
									23379,
									19406,
									8502,
									2253,
									2146,
									2255,
									26525,
									5621,
									30991,
									5615,
									22770,
									5607,
									23077,
									22771,
									5603,
									5600,
									5604,
									5602,
									22769,
									5601,
									5620,
									5613,
									5619,
									5618,
									5608,
									5616,
									22059,
									5612,
									5610,
									5611,
									5609,
									5606,
									5614,
									19238,
									25040,
									23707,
									18539,
									30877,
									8582,
									22191,
									8554,
									8601,
									8075,
									5281,
									32288,
									2808,
									32286,
									22555,
									2721,
									23336,
									5283,
									5230,
									32295,
									2720,
									22128,
									32302,
									32292,
									22127,
									7442,
									32287,
									7443,
									32289,
									2731,
									21381,
									8985,
									26217,
									26111,
									32304,
									7795,
									26112,
									7396,
									2783,
									7113,
									7300,
									7303,
									7304,
									7301,
									7302,
									23400,
									23483,
									23365,
									26153,
									21719,
									21720,
									19486,
									26756,
									26751,
									26752,
									26753,
									26754
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c/dztuivpmyqksleojwahb66723.Charles_Folder_07 cover portal.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'Ontdek onze folderpromoties hier',
									'fr': 'Découvrez nos promotions ici'
								},
								'items': [
									{
										'id': 'f6ad5357-d45c-4f65-9724-631de453461b',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c/qodaxktezjsypnhlcruw11486.Charles_Folder_07.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': '4f3c8da2-7b07-4194-ada1-f1849100a820',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c/eymhjvokqtiscfzupdwx76932.Charles_Folder_07_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': '73366444-24d0-4294-869f-bf62c2914983',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c/pelgbvoiqczrsyknxtum31689.Banners_Folder_07 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c/tiygfluvmbkacejrxhzs76048.Banners_Folder_07 FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '80'
								},
								{
									'id': 'b1ea495c-7042-45a4-9476-5b5e43d29217',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c/weanjpxfoqkbrvghcism55660.Banner nieuwe dagschotels NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/09dd8b2a-efe2-43a3-8e57-f0c06fc8f12c/uwxhdgopknbfciejqtvz12339.Banner nieuwe dagschotels FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': '0b76d88b-7ff1-48ad-8291-cb0096f277ce',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26205,
							26206,
							26207,
							26208,
							26209,
							26210
						],
						'start': '2025-04-13T22:00:00.000Z',
						'end': '2025-04-18T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '0b76d88b-7ff1-48ad-8291-cb0096f277ce',
							'name': {
								'nl': "D'arta",
								'fr': ''
							},
							'start': '2025-04-13T22:00:00.000Z',
							'end': '2025-04-18T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26205,
									26206,
									26207,
									26208,
									26209,
									26210
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '13ad3802-4eeb-4ca8-83f0-162f23cff159',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25649,
							25646,
							25641,
							25642
						],
						'start': '2023-10-15T22:00:00.000Z',
						'end': '2023-10-19T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '13ad3802-4eeb-4ca8-83f0-162f23cff159',
							'name': {
								'nl': 'De Laet-Van Haver',
								'fr': ''
							},
							'start': '2023-10-15T22:00:00.000Z',
							'end': '2023-10-19T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25649,
									25646,
									25641,
									25642
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '16b9aa37-1bf7-4839-9435-43ad98e60309',
						'badge': {
							'nl': 'Nieuw in assortiment',
							'fr': "Nouveau dans l'assortiment",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26002
						],
						'start': '2024-04-14T22:00:00.000Z',
						'end': '2024-04-25T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '16b9aa37-1bf7-4839-9435-43ad98e60309',
							'name': {
								'nl': 'Nieuw in assortiment',
								'fr': 'Nouveau en assortiment'
							},
							'start': '2024-04-14T22:00:00.000Z',
							'end': '2024-04-25T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "Nouveau dans l'assortiment",
										'nl': 'Nieuw in assortiment'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26002
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '1b941dc8-2b03-42b4-ba6c-a3ffa61534a8',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							4794,
							4752,
							4795,
							4626,
							4637
						],
						'start': '2023-01-19T23:00:00.000Z',
						'end': '2023-01-26T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '1b941dc8-2b03-42b4-ba6c-a3ffa61534a8',
							'name': {
								'nl': 'Overstock wildgerechten 2023',
								'fr': ''
							},
							'start': '2023-01-19T23:00:00.000Z',
							'end': '2023-01-26T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4794,
									4752,
									4795,
									4626,
									4637
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '1d2c7d53-cea8-4ddf-9957-4b031aaa9a0d',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							23986
						],
						'start': '2023-08-21T12:36:04.672Z',
						'end': '2023-08-21T12:36:04.672Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '1d2c7d53-cea8-4ddf-9957-4b031aaa9a0d',
							'name': {
								'nl': 'Limoncello pate',
								'fr': ''
							},
							'start': '2023-08-21T12:36:04.672Z',
							'end': '2023-08-21T12:36:04.672Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									23986
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '1fe6e0bf-a20b-4e44-acaf-51faa79d6e92',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							28,
							24920,
							2153,
							4795
						],
						'start': '2022-10-20T22:00:00.000Z',
						'end': '2022-10-27T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '1fe6e0bf-a20b-4e44-acaf-51faa79d6e92',
							'name': {
								'nl': 'Extra promo week 43',
								'fr': ''
							},
							'start': '2022-10-20T22:00:00.000Z',
							'end': '2022-10-27T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									28,
									24920,
									2153,
									4795
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '222465e3-87e9-47a3-ae75-f79cab3804e7',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24441,
							26095,
							25455
						],
						'start': '2024-06-25T22:00:00.000Z',
						'end': '2024-07-04T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '222465e3-87e9-47a3-ae75-f79cab3804e7',
							'name': {
								'nl': 'Overstock in de kijker week 26',
								'fr': ''
							},
							'start': '2024-06-25T22:00:00.000Z',
							'end': '2024-07-04T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24441,
									26095,
									25455
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '238e7cf3-17b7-4328-9f05-d57b41a9c882',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-03-06T23:00:00.000Z',
						'end': '2025-03-30T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '238e7cf3-17b7-4328-9f05-d57b41a9c882',
							'name': {
								'nl': 'Affiche 1+1 gratis dagschotels',
								'fr': 'Affiche 1+1 gratuit plats cuisinés'
							},
							'start': '2025-03-06T23:00:00.000Z',
							'end': '2025-03-30T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/238e7cf3-17b7-4328-9f05-d57b41a9c882/gvltnbzpujefihsykcdx25010.Affiche dagschotels cover.jpg',
									'weight': '80'
								},
								'copy': {
									'nl': 'Download hier de affiche en hang ze op in uw zaak',
									'fr': "Téléchargez l'affiche ici et accrochez-la dans votre entreprise."
								},
								'items': [
									{
										'id': '6ef17a17-0e29-4c3b-b591-751cc3a9f4b5',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/238e7cf3-17b7-4328-9f05-d57b41a9c882/dasxfewqmbpjgoikvzcn14918.Affiche dagschotels NL.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/238e7cf3-17b7-4328-9f05-d57b41a9c882/vhfqonrliajdgwcsbzkt26722.Affiche dagschotels FR.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche en hang ze op in uw zaak',
											'fr': "Téléchargez l'affiche ici et accrochez-la dans votre entreprise."
										}
									}
								]
							}
						}
					},
					{
						'id': '28e0a50c-f7c3-4373-9641-b6bdb31ce0b7',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'start': '2024-09-11T22:00:00.000Z',
						'end': '2024-09-19T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '28e0a50c-f7c3-4373-9641-b6bdb31ce0b7',
							'name': {
								'nl': 'Nieuwe pitabroodjes',
								'fr': ''
							},
							'start': '2024-09-11T22:00:00.000Z',
							'end': '2024-09-19T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								}
							},
							'inThePicture': true
						}
					},
					{
						'id': '28ee2fd0-3fe6-467e-909b-c49fbda9e877',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							4554
						],
						'start': '2023-09-19T22:00:00.000Z',
						'end': '2023-09-21T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '28ee2fd0-3fe6-467e-909b-c49fbda9e877',
							'name': {
								'nl': 'Lasagne ',
								'fr': ''
							},
							'start': '2023-09-19T22:00:00.000Z',
							'end': '2023-09-21T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4554
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '299699c1-ff02-458d-8adc-9bf2f00d85b9',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24792,
							25641,
							25642
						],
						'start': '2024-09-30T22:00:00.000Z',
						'end': '2024-10-03T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '299699c1-ff02-458d-8adc-9bf2f00d85b9',
							'name': {
								'nl': 'Halloweenpate overstock',
								'fr': ''
							},
							'start': '2024-09-30T22:00:00.000Z',
							'end': '2024-10-03T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24792,
									25641,
									25642
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '29a2c02e-fb4c-40f1-a0c9-a802da2377de',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24792
						],
						'start': '2024-09-11T22:00:00.000Z',
						'end': '2024-09-19T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '29a2c02e-fb4c-40f1-a0c9-a802da2377de',
							'name': {
								'nl': 'Halloweenpate',
								'fr': ''
							},
							'start': '2024-09-11T22:00:00.000Z',
							'end': '2024-09-19T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24792
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '2d1c7899-9520-4d2f-955c-83f6c14b83e7',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26431
						],
						'start': '2025-05-27T22:00:00.000Z',
						'end': '2025-06-03T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '2d1c7899-9520-4d2f-955c-83f6c14b83e7',
							'name': {
								'nl': 'Biloute',
								'fr': ''
							},
							'start': '2025-05-27T22:00:00.000Z',
							'end': '2025-06-03T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26431
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '2e32b984-e1bf-4a85-a63e-7f985ad5b00d',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							4584,
							4585
						],
						'start': '2023-11-12T23:00:00.000Z',
						'end': '2023-11-18T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '2e32b984-e1bf-4a85-a63e-7f985ad5b00d',
							'name': {
								'nl': "Mini Snacks en Mini pizza's",
								'fr': ''
							},
							'start': '2023-11-12T23:00:00.000Z',
							'end': '2023-11-18T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4584,
									4585
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '31893912-7483-4296-b6d9-c42d8e509ef8',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							1475,
							23656
						],
						'start': '2023-05-02T22:00:00.000Z',
						'end': '2023-05-04T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '31893912-7483-4296-b6d9-c42d8e509ef8',
							'name': {
								'nl': 'Overstock bruschetta en appelpate',
								'fr': ''
							},
							'start': '2023-05-02T22:00:00.000Z',
							'end': '2023-05-04T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									1475,
									23656
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '31fd01ec-c458-40f4-a5c1-933a7268b82b',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-04-03T22:00:00.000Z',
						'end': '2025-05-30T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '31fd01ec-c458-40f4-a5c1-933a7268b82b',
							'name': {
								'nl': 'Affiches BBQ-worst tuinkruiden & Varkensgrillworst',
								'fr': 'Affiches BBQ-worst tuinkruiden & Varkensgrillworst'
							},
							'start': '2025-04-03T22:00:00.000Z',
							'end': '2025-05-30T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'multilingual': false,
									'nl': 'https://portal.charles.eu/resources/campaigns/31fd01ec-c458-40f4-a5c1-933a7268b82b/lwgzurqbempxftiaockn11830.Affiches cover BBQ worst varkensgrillworst.jpg'
								},
								'copy': {
									'nl': 'Affiches BBQ-worst tuinkruiden & Varkensgrillworst',
									'fr': 'Affiches BBQ-worst tuinkruiden & Varkensgrillworst'
								},
								'items': [
									{
										'id': '43773e9b-2ca4-4afe-a61f-b18a47e16dd6',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/31fd01ec-c458-40f4-a5c1-933a7268b82b/uksmlizgdcqnetxfjaoy00736.Affiche BBQ worst tuinkruiden.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche BBQ-worst tuinkruiden en hang ze op in uw zaak.',
											'fr': ''
										}
									},
									{
										'id': '1b78ed42-adc4-40ad-bd0e-0d20c72cb68f',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/31fd01ec-c458-40f4-a5c1-933a7268b82b/zjityrekacqxdvgmbhsu55613.Affiche varkensgrillworst.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche varkensgrillworst en hang ze op in uw zaak.',
											'fr': ''
										}
									}
								]
							}
						}
					},
					{
						'id': '3278a55d-66da-47aa-a7b8-89ecf116f55e',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							1212
						],
						'start': '2024-12-19T23:00:00.000Z',
						'end': '2024-12-30T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '3278a55d-66da-47aa-a7b8-89ecf116f55e',
							'name': {
								'nl': 'Gevulde kip ',
								'fr': ''
							},
							'start': '2024-12-19T23:00:00.000Z',
							'end': '2024-12-30T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									1212
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '352e3b70-5f53-46b9-9017-f2f20b37840f',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							1511,
							42,
							485,
							24904,
							23659
						],
						'start': '2022-11-17T23:00:00.000Z',
						'end': '2022-11-24T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '352e3b70-5f53-46b9-9017-f2f20b37840f',
							'name': {
								'nl': 'Extra promo week 47',
								'fr': ''
							},
							'start': '2022-11-17T23:00:00.000Z',
							'end': '2022-11-24T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									1511,
									42,
									485,
									24904,
									23659
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '354ea608-462c-4997-9d95-b4d72f4f56c7',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26002
						],
						'start': '2024-05-14T22:00:00.000Z',
						'end': '2024-05-29T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '354ea608-462c-4997-9d95-b4d72f4f56c7',
							'name': {
								'nl': 'Varkensgrillworst ',
								'fr': ''
							},
							'start': '2024-05-14T22:00:00.000Z',
							'end': '2024-05-29T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26002
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '37ca01f7-c0cf-4787-8c48-4318c28dfaee',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							22016,
							23968,
							2848,
							31806,
							25105,
							25104
						],
						'start': '2022-12-15T23:00:00.000Z',
						'end': '2022-12-22T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '37ca01f7-c0cf-4787-8c48-4318c28dfaee',
							'name': {
								'nl': 'Overstock week 51',
								'fr': ''
							},
							'start': '2022-12-15T23:00:00.000Z',
							'end': '2022-12-22T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									22016,
									23968,
									2848,
									31806,
									25105,
									25104
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '3840e118-583d-4a79-8ade-11d31136bfd0',
						'badge': {
							'nl': 'NIEUW',
							'fr': 'NOUVEAU',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Nieuwigheden',
							'fr': 'Nouveautés'
						},
						'articles': [
							26347,
							26348,
							26349,
							26350,
							26329,
							26158,
							26160,
							26203,
							26290,
							26288,
							26289,
							26410,
							26411,
							26412,
							26413,
							26414,
							26415,
							26416,
							26417,
							26418,
							26419,
							26420,
							26421,
							26422,
							26423,
							26424,
							26425,
							26426,
							26427,
							26264,
							26265,
							26266,
							26267,
							26268,
							26215,
							26184,
							26185,
							26186,
							26187,
							26188,
							26239,
							26240,
							26241,
							26435,
							26436,
							26437,
							26438,
							26439,
							26440,
							26441,
							26442,
							26443,
							26445,
							26447,
							26449,
							26451,
							26282,
							26331,
							26332,
							26333,
							26334,
							26335,
							26224,
							26225,
							26330,
							26250,
							26251,
							26252,
							26253,
							26254,
							26284,
							26285,
							26286,
							26287,
							26337,
							26338,
							26339,
							26340,
							26081,
							26226,
							26227,
							26430,
							26431,
							26304,
							26305,
							26306,
							26307,
							26308,
							26309,
							26310,
							26311,
							26312,
							26313,
							26314,
							26315,
							26316,
							26317,
							26318,
							26319,
							26320,
							26362,
							26389,
							26390,
							26391,
							26392,
							26393,
							26394,
							26395,
							26396,
							26397,
							26398,
							26399,
							26400,
							26401,
							26402,
							26403,
							26404,
							26405,
							26406,
							26407,
							26408,
							26409,
							26299,
							26300,
							26301,
							26302,
							26303,
							26380,
							26381,
							26382,
							26383,
							26384,
							26385,
							26386,
							26387,
							26388,
							26321,
							26322,
							26323,
							26324,
							26325,
							26326,
							26376,
							26269,
							26270,
							26296,
							26297,
							26298,
							26259,
							26293,
							26294,
							26273,
							26274,
							26275,
							26276,
							26277,
							26278,
							26245,
							26246,
							26247,
							26248,
							26374,
							26375,
							26281
						],
						'start': '2024-09-25T22:00:00.000Z',
						'end': '2025-01-30T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '3840e118-583d-4a79-8ade-11d31136bfd0',
							'name': {
								'nl': 'Nieuwigheden EOY 2024',
								'fr': 'Nouveauté EOY 2024'
							},
							'start': '2024-09-25T22:00:00.000Z',
							'end': '2025-01-30T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Nieuwigheden',
										'fr': 'Nouveautés'
									}
								},
								'badge': {
									'text': {
										'nl': 'NIEUW',
										'fr': 'NOUVEAU'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									26347,
									26348,
									26349,
									26350,
									26329,
									26158,
									26160,
									26203,
									26290,
									26288,
									26289,
									26410,
									26411,
									26412,
									26413,
									26414,
									26415,
									26416,
									26417,
									26418,
									26419,
									26420,
									26421,
									26422,
									26423,
									26424,
									26425,
									26426,
									26427,
									26264,
									26265,
									26266,
									26267,
									26268,
									26215,
									26184,
									26185,
									26186,
									26187,
									26188,
									26239,
									26240,
									26241,
									26435,
									26436,
									26437,
									26438,
									26439,
									26440,
									26441,
									26442,
									26443,
									26445,
									26447,
									26449,
									26451,
									26282,
									26331,
									26332,
									26333,
									26334,
									26335,
									26224,
									26225,
									26330,
									26250,
									26251,
									26252,
									26253,
									26254,
									26284,
									26285,
									26286,
									26287,
									26337,
									26338,
									26339,
									26340,
									26081,
									26226,
									26227,
									26430,
									26431,
									26304,
									26305,
									26306,
									26307,
									26308,
									26309,
									26310,
									26311,
									26312,
									26313,
									26314,
									26315,
									26316,
									26317,
									26318,
									26319,
									26320,
									26362,
									26389,
									26390,
									26391,
									26392,
									26393,
									26394,
									26395,
									26396,
									26397,
									26398,
									26399,
									26400,
									26401,
									26402,
									26403,
									26404,
									26405,
									26406,
									26407,
									26408,
									26409,
									26299,
									26300,
									26301,
									26302,
									26303,
									26380,
									26381,
									26382,
									26383,
									26384,
									26385,
									26386,
									26387,
									26388,
									26321,
									26322,
									26323,
									26324,
									26325,
									26326,
									26376,
									26269,
									26270,
									26296,
									26297,
									26298,
									26259,
									26293,
									26294,
									26273,
									26274,
									26275,
									26276,
									26277,
									26278,
									26245,
									26246,
									26247,
									26248,
									26374,
									26375,
									26281
								]
							}
						}
					},
					{
						'id': '386f8e45-746a-4fd2-a3a2-7aa139e98ed8',
						'badge': {
							'nl': 'THT 13/12/2024',
							'fr': 'DLC 13/12/2024',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'start': '2024-12-01T23:00:00.000Z',
						'end': '2024-12-05T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '386f8e45-746a-4fd2-a3a2-7aa139e98ed8',
							'name': {
								'nl': 'Eindejaar pate',
								'fr': ''
							},
							'start': '2024-12-01T23:00:00.000Z',
							'end': '2024-12-05T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'DLC 13/12/2024',
										'nl': 'THT 13/12/2024'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								}
							},
							'inThePicture': true
						}
					},
					{
						'id': '39f9a6a8-b9a0-438c-b6af-e1a2e0351324',
						'badge': {
							'nl': 'Terug beschikbaar ',
							'fr': 'À nouveau disponible',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							446,
							26002
						],
						'start': '2025-04-01T22:00:00.000Z',
						'end': '2025-04-05T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '39f9a6a8-b9a0-438c-b6af-e1a2e0351324',
							'name': {
								'nl': 'BBQ Worst',
								'fr': ''
							},
							'start': '2025-04-01T22:00:00.000Z',
							'end': '2025-04-05T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'À nouveau disponible',
										'nl': 'Terug beschikbaar '
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									446,
									26002
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '3bf0a693-c9c6-4167-833c-1173b074cb36',
						'badge': {
							'nl': 'THT 05/02/2025',
							'fr': 'DLC 05/02/2025',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25338
						],
						'start': '2025-01-16T23:00:00.000Z',
						'end': '2025-01-23T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '3bf0a693-c9c6-4167-833c-1173b074cb36',
							'name': {
								'nl': 'Cadeaubox',
								'fr': ''
							},
							'start': '2025-01-16T23:00:00.000Z',
							'end': '2025-01-23T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'DLC 05/02/2025',
										'nl': 'THT 05/02/2025'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25338
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '3f2f6de6-5c9b-4007-bfe6-661aab69da8d',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24441,
							26095
						],
						'start': '2024-07-04T22:00:00.000Z',
						'end': '2024-07-11T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '3f2f6de6-5c9b-4007-bfe6-661aab69da8d',
							'name': {
								'nl': 'Overstock in de kijker week 28',
								'fr': ''
							},
							'start': '2024-07-04T22:00:00.000Z',
							'end': '2024-07-11T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24441,
									26095
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '409e1e45-7a6a-47e8-9887-dfc49e8f845e',
						'badge': {
							'nl': 'Nieuw: Alternatief voor Brugse Blomme',
							'fr': 'Nouveau : Alternative à la Brugge Fleuron',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25952
						],
						'start': '2023-12-14T23:00:00.000Z',
						'end': '2023-12-21T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '409e1e45-7a6a-47e8-9887-dfc49e8f845e',
							'name': {
								'nl': 'Charleston',
								'fr': ''
							},
							'start': '2023-12-14T23:00:00.000Z',
							'end': '2023-12-21T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'Nouveau : Alternative à la Brugge Fleuron',
										'nl': 'Nieuw: Alternatief voor Brugse Blomme'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25952
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '43806dd5-3103-4dd5-af5d-56dcc5e23bee',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							24995,
							23656,
							2132,
							2343,
							44,
							1337,
							24258
						],
						'start': '2022-07-03T22:00:00.000Z',
						'end': '2022-07-07T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '43806dd5-3103-4dd5-af5d-56dcc5e23bee',
							'name': {
								'nl': 'Kruidenham en zomerpate',
								'fr': 'Kruidenham en zomerpate'
							},
							'start': '2022-07-03T22:00:00.000Z',
							'end': '2022-07-07T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24995,
									23656,
									2132,
									2343,
									44,
									1337,
									24258
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '44f1eaa2-f3cb-45a2-ab0c-2bfed7934b8b',
						'badge': {
							'nl': 'Sint-Actie',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							456
						],
						'start': '2023-11-12T23:00:00.000Z',
						'end': '2023-11-17T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '44f1eaa2-f3cb-45a2-ab0c-2bfed7934b8b',
							'name': {
								'nl': 'Sint-actie',
								'fr': ''
							},
							'start': '2023-11-12T23:00:00.000Z',
							'end': '2023-11-17T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'Sint-Actie'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									456
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '450dda05-0b81-462d-be4c-7132b1d7ad86',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'start': '2022-11-17T23:00:00.000Z',
						'end': '2022-11-24T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '450dda05-0b81-462d-be4c-7132b1d7ad86',
							'name': {
								'nl': 'Overstock week 47',
								'fr': ''
							},
							'start': '2022-11-17T23:00:00.000Z',
							'end': '2022-11-24T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								}
							},
							'inThePicture': true
						}
					},
					{
						'id': '468f1679-0519-40bc-ace7-fd562db6a8cf',
						'badge': {
							'nl': 'Lente-zomer catalogus 2024',
							'fr': 'Catalogue printemps-été 2024',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Lente-zomer catalogus 2024',
							'fr': 'Catalogue printemps-été 2024'
						},
						'articles': [
							1674,
							1676,
							1677,
							1675,
							1682,
							1722,
							21489,
							25667,
							25668,
							25856,
							1028,
							25574,
							25575,
							23273,
							2521,
							2069,
							2051,
							30840,
							30884,
							2184,
							4880,
							31034,
							31037,
							21678,
							18889,
							18891,
							30998,
							19384,
							24494,
							24495,
							25793,
							23498,
							23499,
							23500,
							23502,
							25035,
							25036,
							22493,
							22495,
							25028,
							24465,
							24466,
							24467,
							24469,
							24471,
							24473,
							24474,
							24475,
							2049,
							2072,
							25945,
							23875,
							25034,
							25026,
							25027,
							25029,
							25032,
							25037,
							25030,
							25031,
							25885,
							25886,
							25881,
							25870,
							25884,
							25882,
							25883,
							25887,
							25663,
							25501,
							26024,
							26025,
							26026,
							25715,
							25641,
							25642,
							183,
							184,
							8738,
							196,
							132,
							129,
							21500,
							21493,
							21513,
							148,
							130,
							18899,
							19009,
							21506,
							23180,
							26059,
							26060,
							120,
							1391,
							1324,
							25973,
							23123,
							23078,
							25972,
							25971,
							26027,
							26044,
							26045,
							1067,
							23656,
							1687,
							1686,
							22060,
							1118,
							24692,
							24913,
							25426,
							352,
							21502,
							25630,
							2123,
							24245,
							2084,
							2122,
							2108,
							2106,
							25911,
							25912,
							25910,
							23780,
							2148,
							30880,
							2280,
							2041,
							8971,
							22319,
							22257,
							22188,
							25680,
							25681,
							25683,
							25685,
							25682,
							25684,
							25686,
							25687,
							3209,
							3218,
							3223,
							19850,
							21842,
							25932,
							25925,
							25929,
							3219,
							3197,
							3426,
							19332,
							26011,
							26008,
							3245,
							25767,
							3125,
							3444,
							25924,
							33015,
							3355,
							3479,
							3341,
							3210,
							24387,
							3094,
							21547,
							26012,
							26006,
							26007,
							26009,
							24805,
							3538,
							24428,
							24332,
							23589,
							3563,
							3547,
							25898,
							22185,
							21307,
							3091,
							3571,
							3560,
							32919,
							33033,
							3557,
							3539,
							6537,
							33038,
							7375,
							21395,
							3559,
							3540,
							3541,
							24607,
							25941,
							6536,
							24277,
							3558,
							19705,
							25435,
							25436,
							25437,
							25438,
							25439,
							25440,
							25441,
							25525,
							21879,
							4217,
							2031,
							2043,
							2296,
							30915,
							24483,
							2293,
							8555,
							23090,
							25222,
							8547,
							21864,
							2163,
							23832,
							2090,
							8560,
							8452,
							2082,
							24944,
							25985,
							2079,
							2080,
							2078,
							2081,
							2065,
							2295,
							24943,
							2066,
							2064,
							2070,
							2092,
							30903,
							8550,
							24484,
							24485,
							24486,
							24487,
							25053,
							8519,
							8581,
							21798,
							30993,
							2278,
							25211,
							22192,
							25210,
							8582,
							22066,
							30936,
							30994,
							30992,
							25521,
							25212,
							2033,
							25213,
							8993,
							22191,
							2032,
							7778,
							7582,
							7581,
							25518,
							19639,
							22078,
							23742,
							24393,
							18489,
							23647,
							25519,
							4541,
							7759,
							23176,
							4417,
							4418,
							4415,
							4421,
							18658,
							23096,
							23728,
							21432,
							31317,
							25986,
							22015,
							21718,
							22793,
							2622,
							19385,
							25207,
							25056,
							32758,
							19236,
							22016,
							24417,
							25445,
							24581,
							21364,
							21948,
							23489,
							23816,
							8704,
							8708,
							4920,
							4914,
							4911,
							4913,
							8688,
							8703,
							2363,
							2301,
							8701,
							2302,
							7869,
							8716,
							8705,
							2315,
							2325,
							8717,
							31565,
							7868,
							2380,
							2365,
							25975,
							25976,
							25982,
							25979,
							25978,
							25980,
							25981,
							25977,
							26015,
							26016,
							26017,
							26021,
							26022,
							7607,
							2364,
							2394,
							7510,
							7511,
							22075,
							22076,
							6572,
							1013,
							21716,
							19604,
							19603,
							426,
							961,
							26002,
							8968,
							18120,
							368,
							1174,
							446,
							476,
							24952,
							8428,
							18235,
							25546,
							25547,
							25548,
							25549,
							25550,
							31274,
							22077,
							22067,
							31470,
							25646,
							25599,
							25605,
							25597,
							25598,
							25600,
							25604,
							25602,
							25603,
							25606,
							19750,
							19763,
							19760,
							19779,
							23711,
							23724,
							19768,
							19789,
							26056,
							26057,
							26058,
							26050,
							26051,
							26052,
							26053,
							26054,
							26055,
							23183,
							31454,
							31463,
							31464,
							31465,
							31467,
							31468,
							31471,
							31472,
							25858,
							25859,
							25860,
							25861,
							25862,
							8398,
							22367,
							21783,
							32703,
							21717,
							25434,
							26036,
							26039,
							26040,
							26041,
							26042,
							8087,
							8742,
							19903,
							2339,
							21391,
							31697,
							7786,
							21381,
							32286,
							7443,
							32287,
							32288,
							32289,
							8985,
							7442,
							22127,
							22128,
							32292,
							32293,
							32294,
							32295,
							2731,
							5230,
							2721,
							5281,
							2720,
							5283,
							32302,
							22555,
							22556,
							7396,
							7113,
							32304,
							2783,
							7795,
							26037,
							26038,
							25871,
							18686,
							2564,
							18678,
							18676,
							2563,
							2583,
							32733,
							32718,
							18684,
							32755,
							22939,
							21858,
							32728,
							32714,
							21813,
							32706,
							21814,
							22957,
							25559,
							32709,
							6407,
							32720,
							32736,
							21756,
							32711,
							18680,
							25592,
							25590,
							22132,
							21763,
							32869,
							32871,
							32870,
							24997,
							25098,
							22747,
							25267,
							25268,
							21772,
							21812,
							23338,
							22175,
							24897,
							23065,
							25989,
							25990,
							4681,
							24319,
							6412,
							25206,
							25076,
							23646,
							19257,
							18601,
							8386,
							23645,
							25492,
							25988,
							25994,
							25998,
							25991,
							26000,
							4801,
							32693,
							24678,
							4545,
							4546,
							4609,
							25577,
							26043,
							25702,
							6172,
							24707,
							21703,
							22045,
							7834,
							25987,
							4739,
							8620,
							21355,
							23199,
							26028,
							26029,
							26030,
							26031,
							26032,
							26033,
							22234,
							22235,
							22236,
							22237,
							22238,
							22239,
							22240,
							22242,
							22243,
							22652,
							22655,
							23649,
							25018,
							25019,
							25020,
							25021,
							25857,
							24911,
							26034,
							26035,
							6305,
							23783,
							25831,
							24828,
							24829,
							24830,
							24831
						],
						'start': '2024-03-14T23:00:00.000Z',
						'end': '2024-07-30T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '468f1679-0519-40bc-ace7-fd562db6a8cf',
							'name': {
								'nl': 'Lente-zomer catalogus 2024',
								'fr': 'Catalogue printemps-été 2024'
							},
							'start': '2024-03-14T23:00:00.000Z',
							'end': '2024-07-30T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Lente-zomer catalogus 2024',
										'fr': 'Catalogue printemps-été 2024'
									}
								},
								'badge': {
									'text': {
										'nl': 'Lente-zomer catalogus 2024',
										'fr': 'Catalogue printemps-été 2024'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									1674,
									1676,
									1677,
									1675,
									1682,
									1722,
									21489,
									25667,
									25668,
									25856,
									1028,
									25574,
									25575,
									23273,
									2521,
									2069,
									2051,
									30840,
									30884,
									2184,
									4880,
									31034,
									31037,
									21678,
									18889,
									18891,
									30998,
									19384,
									24494,
									24495,
									25793,
									23498,
									23499,
									23500,
									23502,
									25035,
									25036,
									22493,
									22495,
									25028,
									24465,
									24466,
									24467,
									24469,
									24471,
									24473,
									24474,
									24475,
									2049,
									2072,
									25945,
									23875,
									25034,
									25026,
									25027,
									25029,
									25032,
									25037,
									25030,
									25031,
									25885,
									25886,
									25881,
									25870,
									25884,
									25882,
									25883,
									25887,
									25663,
									25501,
									26024,
									26025,
									26026,
									25715,
									25641,
									25642,
									183,
									184,
									8738,
									196,
									132,
									129,
									21500,
									21493,
									21513,
									148,
									130,
									18899,
									19009,
									21506,
									23180,
									26059,
									26060,
									120,
									1391,
									1324,
									25973,
									23123,
									23078,
									25972,
									25971,
									26027,
									26044,
									26045,
									1067,
									23656,
									1687,
									1686,
									22060,
									1118,
									24692,
									24913,
									25426,
									352,
									21502,
									25630,
									2123,
									24245,
									2084,
									2122,
									2108,
									2106,
									25911,
									25912,
									25910,
									23780,
									2148,
									30880,
									2280,
									2041,
									8971,
									22319,
									22257,
									22188,
									25680,
									25681,
									25683,
									25685,
									25682,
									25684,
									25686,
									25687,
									3209,
									3218,
									3223,
									19850,
									21842,
									25932,
									25925,
									25929,
									3219,
									3197,
									3426,
									19332,
									26011,
									26008,
									3245,
									25767,
									3125,
									3444,
									25924,
									33015,
									3355,
									3479,
									3341,
									3210,
									24387,
									3094,
									21547,
									26012,
									26006,
									26007,
									26009,
									24805,
									3538,
									24428,
									24332,
									23589,
									3563,
									3547,
									25898,
									22185,
									21307,
									3091,
									3571,
									3560,
									32919,
									33033,
									3557,
									3539,
									6537,
									33038,
									7375,
									21395,
									3559,
									3540,
									3541,
									24607,
									25941,
									6536,
									24277,
									3558,
									19705,
									25435,
									25436,
									25437,
									25438,
									25439,
									25440,
									25441,
									25525,
									21879,
									4217,
									2031,
									2043,
									2296,
									30915,
									24483,
									2293,
									8555,
									23090,
									25222,
									8547,
									21864,
									2163,
									23832,
									2090,
									8560,
									8452,
									2082,
									24944,
									25985,
									2079,
									2080,
									2078,
									2081,
									2065,
									2295,
									24943,
									2066,
									2064,
									2070,
									2092,
									30903,
									8550,
									24484,
									24485,
									24486,
									24487,
									25053,
									8519,
									8581,
									21798,
									30993,
									2278,
									25211,
									22192,
									25210,
									8582,
									22066,
									30936,
									30994,
									30992,
									25521,
									25212,
									2033,
									25213,
									8993,
									22191,
									2032,
									7778,
									7582,
									7581,
									25518,
									19639,
									22078,
									23742,
									24393,
									18489,
									23647,
									25519,
									4541,
									7759,
									23176,
									4417,
									4418,
									4415,
									4421,
									18658,
									23096,
									23728,
									21432,
									31317,
									25986,
									22015,
									21718,
									22793,
									2622,
									19385,
									25207,
									25056,
									32758,
									19236,
									22016,
									24417,
									25445,
									24581,
									21364,
									21948,
									23489,
									23816,
									8704,
									8708,
									4920,
									4914,
									4911,
									4913,
									8688,
									8703,
									2363,
									2301,
									8701,
									2302,
									7869,
									8716,
									8705,
									2315,
									2325,
									8717,
									31565,
									7868,
									2380,
									2365,
									25975,
									25976,
									25982,
									25979,
									25978,
									25980,
									25981,
									25977,
									26015,
									26016,
									26017,
									26021,
									26022,
									7607,
									2364,
									2394,
									7510,
									7511,
									22075,
									22076,
									6572,
									1013,
									21716,
									19604,
									19603,
									426,
									961,
									26002,
									8968,
									18120,
									368,
									1174,
									446,
									476,
									24952,
									8428,
									18235,
									25546,
									25547,
									25548,
									25549,
									25550,
									31274,
									22077,
									22067,
									31470,
									25646,
									25599,
									25605,
									25597,
									25598,
									25600,
									25604,
									25602,
									25603,
									25606,
									19750,
									19763,
									19760,
									19779,
									23711,
									23724,
									19768,
									19789,
									26056,
									26057,
									26058,
									26050,
									26051,
									26052,
									26053,
									26054,
									26055,
									23183,
									31454,
									31463,
									31464,
									31465,
									31467,
									31468,
									31471,
									31472,
									25858,
									25859,
									25860,
									25861,
									25862,
									8398,
									22367,
									21783,
									32703,
									21717,
									25434,
									26036,
									26039,
									26040,
									26041,
									26042,
									8087,
									8742,
									19903,
									2339,
									21391,
									31697,
									7786,
									21381,
									32286,
									7443,
									32287,
									32288,
									32289,
									8985,
									7442,
									22127,
									22128,
									32292,
									32293,
									32294,
									32295,
									2731,
									5230,
									2721,
									5281,
									2720,
									5283,
									32302,
									22555,
									22556,
									7396,
									7113,
									32304,
									2783,
									7795,
									26037,
									26038,
									25871,
									18686,
									2564,
									18678,
									18676,
									2563,
									2583,
									32733,
									32718,
									18684,
									32755,
									22939,
									21858,
									32728,
									32714,
									21813,
									32706,
									21814,
									22957,
									25559,
									32709,
									6407,
									32720,
									32736,
									21756,
									32711,
									18680,
									25592,
									25590,
									22132,
									21763,
									32869,
									32871,
									32870,
									24997,
									25098,
									22747,
									25267,
									25268,
									21772,
									21812,
									23338,
									22175,
									24897,
									23065,
									25989,
									25990,
									4681,
									24319,
									6412,
									25206,
									25076,
									23646,
									19257,
									18601,
									8386,
									23645,
									25492,
									25988,
									25994,
									25998,
									25991,
									26000,
									4801,
									32693,
									24678,
									4545,
									4546,
									4609,
									25577,
									26043,
									25702,
									6172,
									24707,
									21703,
									22045,
									7834,
									25987,
									4739,
									8620,
									21355,
									23199,
									26028,
									26029,
									26030,
									26031,
									26032,
									26033,
									22234,
									22235,
									22236,
									22237,
									22238,
									22239,
									22240,
									22242,
									22243,
									22652,
									22655,
									23649,
									25018,
									25019,
									25020,
									25021,
									25857,
									24911,
									26034,
									26035,
									6305,
									23783,
									25831,
									24828,
									24829,
									24830,
									24831
								]
							},
							'documents': {
								'cover': {
									'multilingual': false,
									'nl': 'https://portal.charles.eu/resources/campaigns/468f1679-0519-40bc-ace7-fd562db6a8cf/mcagzuqikdpnrhetxosw89072.Lente_Zomer_2024_NL-1.jpg',
									'weight': '100',
									'fr': 'https://portal.charles.eu/resources/campaigns/468f1679-0519-40bc-ace7-fd562db6a8cf/cedifsgrwtlhupvbaznx90200.Lente_Zomer_2024_FR-1.jpg'
								},
								'copy': {
									'nl': 'Ontdek hier onze Lente-zomer catalogus 2024',
									'fr': 'Découvrez notre Catalogue printemps-été 2024 ici'
								},
								'items': [
									{
										'id': 'de78daa1-4833-412f-8816-6473ef4e5694',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/468f1679-0519-40bc-ace7-fd562db6a8cf/myghlisrdwvezjbnxpof68691.Lente_Zomer_2024_NL.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/468f1679-0519-40bc-ace7-fd562db6a8cf/zxhklpvctdwesjqfugnb83662.Lente_Zomer_2024_FR.pdf'
										},
										'description': {
											'nl': 'Bekijk hier de catalogus',
											'fr': 'Consultez le catalogue ici'
										}
									}
								]
							},
							'banners': [
								{
									'id': '13f3fb5c-7142-4259-aa6f-fd60178f9c1c',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/468f1679-0519-40bc-ace7-fd562db6a8cf/anpwxhrcvdsogbujtqye88792.Banner_Lente2024 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/468f1679-0519-40bc-ace7-fd562db6a8cf/nlgoctdurkazxpvsihfj45917.Banner_Lente2024 FR.jpg'
									},
									'action': {
										'type': 'document',
										'doc': 'de78daa1-4833-412f-8816-6473ef4e5694'
									},
									'weight': '90'
								}
							]
						}
					},
					{
						'id': '4d59aee5-8d3b-414b-9b40-c527dc034682',
						'badge': {
							'nl': 'Nationale promoties zomer',
							'fr': 'Promotions nationale été',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Nationale promoties zomer',
							'fr': 'Promotions nationale été'
						},
						'articles': [
							1571,
							1573,
							1575,
							1564,
							1563,
							2195,
							26576,
							2198,
							2118,
							5618,
							23090,
							2293,
							8555,
							24944,
							24249,
							25576,
							2092,
							7778,
							26894,
							26526,
							24252,
							2133,
							26524,
							2102,
							22185,
							24012,
							7524,
							7527,
							7581,
							23646,
							25491,
							7615,
							23379,
							26346,
							7532,
							24768,
							22078,
							7557,
							25492,
							7605,
							23378,
							22077,
							7525,
							7526,
							19639,
							7582,
							7607,
							7510,
							8971,
							26135,
							2048,
							23744,
							6613,
							26809,
							26167,
							22559,
							25493,
							23817,
							25062,
							7458,
							23196,
							24393,
							32347,
							19495,
							7471,
							8966,
							23133,
							19473,
							25422,
							7116,
							6634,
							2674,
							18678,
							18686,
							21858,
							32709,
							32714,
							3548,
							7300,
							7303,
							7304,
							7301,
							7302,
							26899,
							32798,
							23265,
							23264,
							164,
							169,
							187,
							165
						],
						'start': '2025-06-27T22:00:00.000Z',
						'end': '2025-08-30T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '4d59aee5-8d3b-414b-9b40-c527dc034682',
							'name': {
								'nl': 'Nationale promoties zomer W27-35',
								'fr': 'Promotions nationale été S27-35'
							},
							'start': '2025-06-27T22:00:00.000Z',
							'end': '2025-08-30T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Nationale promoties zomer',
										'fr': 'Promotions nationale été'
									}
								},
								'badge': {
									'text': {
										'nl': 'Nationale promoties zomer',
										'fr': 'Promotions nationale été'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									1571,
									1573,
									1575,
									1564,
									1563,
									2195,
									26576,
									2198,
									2118,
									5618,
									23090,
									2293,
									8555,
									24944,
									24249,
									25576,
									2092,
									7778,
									26894,
									26526,
									24252,
									2133,
									26524,
									2102,
									22185,
									24012,
									7524,
									7527,
									7581,
									23646,
									25491,
									7615,
									23379,
									26346,
									7532,
									24768,
									22078,
									7557,
									25492,
									7605,
									23378,
									22077,
									7525,
									7526,
									19639,
									7582,
									7607,
									7510,
									8971,
									26135,
									2048,
									23744,
									6613,
									26809,
									26167,
									22559,
									25493,
									23817,
									25062,
									7458,
									23196,
									24393,
									32347,
									19495,
									7471,
									8966,
									23133,
									19473,
									25422,
									7116,
									6634,
									2674,
									18678,
									18686,
									21858,
									32709,
									32714,
									3548,
									7300,
									7303,
									7304,
									7301,
									7302,
									26899,
									32798,
									23265,
									23264,
									164,
									169,
									187,
									165
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/4d59aee5-8d3b-414b-9b40-c527dc034682/pjshdknoyiewculagqfz51574.Zomer 2025 Nationale promoties.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'Nationale promoties zomer W27-35',
									'fr': 'Promotions nationale été S27-35'
								},
								'items': [
									{
										'id': '904ed738-2a53-41b6-9deb-3c95ca8e5053',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/4d59aee5-8d3b-414b-9b40-c527dc034682/fsnayluxqghkrcbvdzwp24478.Zomer 2025 Nationale promoties.pdf'
										},
										'description': {
											'nl': 'Nationale promoties zomer W27-35',
											'fr': 'Promotions nationale été S27-35'
										}
									}
								]
							}
						}
					},
					{
						'id': '4e24c30b-e610-4508-a407-376627f72602',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26328
						],
						'start': '2025-07-15T22:00:00.000Z',
						'end': '2025-07-18T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '4e24c30b-e610-4508-a407-376627f72602',
							'name': {
								'nl': 'Kipfilet sam',
								'fr': ''
							},
							'start': '2025-07-15T22:00:00.000Z',
							'end': '2025-07-18T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26328
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '4f53533e-c855-44a6-a2b9-8c7ed80dd7ea',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							23661
						],
						'start': '2023-01-11T23:00:00.000Z',
						'end': '2023-01-19T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '4f53533e-c855-44a6-a2b9-8c7ed80dd7ea',
							'name': {
								'nl': 'Overstock Zuiderse bacon',
								'fr': ''
							},
							'start': '2023-01-11T23:00:00.000Z',
							'end': '2023-01-19T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									23661
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '52ef5768-0388-49ea-b70e-0cf64ec4d4e9',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							4569
						],
						'start': '2024-05-05T22:00:00.000Z',
						'end': '2024-05-09T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '52ef5768-0388-49ea-b70e-0cf64ec4d4e9',
							'name': {
								'nl': 'Overstock Witloofgratin',
								'fr': ''
							},
							'start': '2024-05-05T22:00:00.000Z',
							'end': '2024-05-09T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4569
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '53ece37d-2b11-4aae-9169-ec0491fd0093',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							21716
						],
						'start': '2025-08-07T22:00:00.000Z',
						'end': '2025-08-21T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '53ece37d-2b11-4aae-9169-ec0491fd0093',
							'name': {
								'nl': 'Grillfakkels',
								'fr': ''
							},
							'start': '2025-08-07T22:00:00.000Z',
							'end': '2025-08-21T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									21716
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '5582a14e-a232-4963-9f7e-0c85f49b0e10',
						'badge': {
							'nl': 'Terug in assortiment de asperge producten',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2123,
							24245,
							24615,
							1067,
							1391
						],
						'start': '2024-02-08T23:00:00.000Z',
						'end': '2024-02-22T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '5582a14e-a232-4963-9f7e-0c85f49b0e10',
							'name': {
								'nl': 'Asperge producten',
								'fr': ''
							},
							'start': '2024-02-08T23:00:00.000Z',
							'end': '2024-02-22T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'Terug in assortiment de asperge producten'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2123,
									24245,
									24615,
									1067,
									1391
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '5592e23b-3758-452b-bd45-3d3889347c7f',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							1638,
							1,
							2151,
							25257,
							4606
						],
						'start': '2022-11-24T23:00:00.000Z',
						'end': '2022-12-01T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '5592e23b-3758-452b-bd45-3d3889347c7f',
							'name': {
								'nl': 'Extra promo week 48',
								'fr': ''
							},
							'start': '2022-11-24T23:00:00.000Z',
							'end': '2022-12-01T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									1638,
									1,
									2151,
									25257,
									4606
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '5677a867-4c38-47df-9675-5417e073cbd3',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25025,
							25030,
							25031,
							25033,
							25034,
							25035,
							25036,
							25038,
							25026,
							25027,
							25028,
							25029,
							25032,
							25037
						],
						'start': '2023-06-11T22:00:00.000Z',
						'end': '2023-06-17T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '5677a867-4c38-47df-9675-5417e073cbd3',
							'name': {
								'nl': 'Gran Tapas',
								'fr': ''
							},
							'start': '2023-06-11T22:00:00.000Z',
							'end': '2023-06-17T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25025,
									25030,
									25031,
									25033,
									25034,
									25035,
									25036,
									25038,
									25026,
									25027,
									25028,
									25029,
									25032,
									25037
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '583775c9-b4f7-42a6-b5a9-63867aa13a84',
						'badge': {
							'nl': 'Gratis pakket ',
							'fr': 'Pacquet gratuit ',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24091,
							24125
						],
						'start': '2023-09-24T22:00:00.000Z',
						'end': '2023-10-05T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '583775c9-b4f7-42a6-b5a9-63867aa13a84',
							'name': {
								'nl': 'Gratis pakket kazen van bij ons',
								'fr': 'Gratis pakket kazen van bij ons'
							},
							'start': '2023-09-24T22:00:00.000Z',
							'end': '2023-10-05T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'Pacquet gratuit ',
										'nl': 'Gratis pakket '
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24091,
									24125
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '58ccd02a-e139-405a-8b7f-fc2c76ff3636',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26016,
							26017,
							26020,
							26015
						],
						'start': '2025-04-06T22:00:00.000Z',
						'end': '2025-04-17T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '58ccd02a-e139-405a-8b7f-fc2c76ff3636',
							'name': {
								'nl': 'Diknek',
								'fr': ''
							},
							'start': '2025-04-06T22:00:00.000Z',
							'end': '2025-04-17T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26016,
									26017,
									26020,
									26015
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '5914699c-69b7-424a-b9e9-0ea2a62f9f2f',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-08-09T22:00:00.000Z',
						'end': '2025-08-23T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '5914699c-69b7-424a-b9e9-0ea2a62f9f2f',
							'name': {
								'nl': 'Affiches Back 2 school Charles de Beer ',
								'fr': 'Affiches Back 2 school Charles de Beer'
							},
							'start': '2025-08-09T22:00:00.000Z',
							'end': '2025-08-23T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/5914699c-69b7-424a-b9e9-0ea2a62f9f2f/sektfmnhvgxiwdqbuzcy40114.CDB_Koekendozen_pen_affiches.jpg'
								},
								'copy': {
									'fr': "Téléchargez l'affiche ici et accrochez-la dans votre entreprise ",
									'nl': 'Download hier de affiche en hang ze op in uw zaak'
								},
								'items': [
									{
										'id': 'f6ad3100-54a3-4031-8d23-f4f3498fda4e',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/5914699c-69b7-424a-b9e9-0ea2a62f9f2f/dkqjwpcmurehbtnyofsz03373.CDB_Koekendozen_affiche_NL.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/5914699c-69b7-424a-b9e9-0ea2a62f9f2f/mkjsgubclfxohqenripy49350.CDB_Koekendozen_affiche_FR.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche en hang ze op in uw zaak - Koekendoosje',
											'fr': "Téléchargez l'affiche ici et accrochez-la dans votre entreprise - Boîte à biscuits"
										}
									},
									{
										'id': '77d72e88-dd04-4772-8bcb-e0578dd2ee6e',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/5914699c-69b7-424a-b9e9-0ea2a62f9f2f/ytbaslfmrwezkjncvhqd06750.CDB_Pen_affiche_NL.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/5914699c-69b7-424a-b9e9-0ea2a62f9f2f/igmvpjwqekftluyaszhr74204.CDB_Pen_affiche_FR.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche en hang ze op in uw zaak - Pen',
											'fr': "Téléchargez l'affiche ici et accrochez-la dans votre entreprise - Stylo"
										}
									}
								]
							}
						}
					},
					{
						'id': '591dad73-6f1a-488b-b42d-890760c4cd50',
						'badge': {
							'nl': 'Slicing palen',
							'fr': 'Les piquets slicing',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Slicing palen',
							'fr': 'Les piquets slicing'
						},
						'articles': [
							24527,
							26534,
							26535,
							26532,
							26533,
							26536,
							26537,
							26538,
							26539,
							26540,
							26541,
							26542,
							5522,
							26543,
							26544,
							26545,
							26546,
							26547,
							26548,
							26549,
							24528,
							26771,
							5537,
							5538,
							63,
							22693,
							22694,
							68,
							26158,
							25674,
							26,
							1267,
							1269,
							26157,
							26174,
							26328,
							26378,
							26571,
							26572,
							26574,
							26573,
							26575,
							385,
							412,
							425,
							402,
							403,
							1331,
							1311,
							210,
							23661,
							323,
							324,
							103,
							1514,
							1515,
							1637,
							1638,
							1517,
							26145,
							26146,
							26521,
							21493,
							21513,
							6503,
							21327,
							22749,
							22750,
							22785,
							3100,
							3306
						],
						'start': '2025-04-03T22:00:00.000Z',
						'end': '2025-06-29T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '591dad73-6f1a-488b-b42d-890760c4cd50',
							'name': {
								'nl': 'Slicing palen van Charles',
								'fr': 'Les piquets de Charles'
							},
							'start': '2025-04-03T22:00:00.000Z',
							'end': '2025-06-29T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'fr': 'Les piquets slicing',
										'nl': 'Slicing palen'
									}
								},
								'badge': {
									'text': {
										'nl': 'Slicing palen',
										'fr': 'Les piquets slicing'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									24527,
									26534,
									26535,
									26532,
									26533,
									26536,
									26537,
									26538,
									26539,
									26540,
									26541,
									26542,
									5522,
									26543,
									26544,
									26545,
									26546,
									26547,
									26548,
									26549,
									24528,
									26771,
									5537,
									5538,
									63,
									22693,
									22694,
									68,
									26158,
									25674,
									26,
									1267,
									1269,
									26157,
									26174,
									26328,
									26378,
									26571,
									26572,
									26574,
									26573,
									26575,
									385,
									412,
									425,
									402,
									403,
									1331,
									1311,
									210,
									23661,
									323,
									324,
									103,
									1514,
									1515,
									1637,
									1638,
									1517,
									26145,
									26146,
									26521,
									21493,
									21513,
									6503,
									21327,
									22749,
									22750,
									22785,
									3100,
									3306
								]
							}
						}
					},
					{
						'id': '595adb01-3b4f-4cce-b1a5-605dde9195ea',
						'badge': {
							'nl': 'THT 07-07-2022',
							'fr': 'THT 07-07-2022',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							2128
						],
						'start': '2022-06-21T22:00:00.000Z',
						'end': '2022-06-23T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '595adb01-3b4f-4cce-b1a5-605dde9195ea',
							'name': {
								'nl': 'Kip andalouse 28/06',
								'fr': ''
							},
							'start': '2022-06-21T22:00:00.000Z',
							'end': '2022-06-23T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'THT 07-07-2022',
										'nl': 'THT 07-07-2022'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2128
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '5cb386a5-25d0-4769-ab54-1a707ec10a0c',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							24258,
							24930
						],
						'start': '2022-08-15T22:00:00.000Z',
						'end': '2022-08-25T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '5cb386a5-25d0-4769-ab54-1a707ec10a0c',
							'name': {
								'nl': 'Kruidenham overstock ',
								'fr': ''
							},
							'start': '2022-08-15T22:00:00.000Z',
							'end': '2022-08-25T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24258,
									24930
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '5cb6ce90-082c-44f3-9600-cd2569552fe4',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2151,
							2174
						],
						'start': '2023-07-17T22:00:00.000Z',
						'end': '2023-07-20T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '5cb6ce90-082c-44f3-9600-cd2569552fe4',
							'name': {
								'nl': 'Kipbal bbq en Ei spek',
								'fr': ''
							},
							'start': '2023-07-17T22:00:00.000Z',
							'end': '2023-07-20T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2151,
									2174
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '5ed59be0-f4bc-49d7-b6b0-c40371cad989',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							4626,
							24792
						],
						'start': '2023-11-05T23:00:00.000Z',
						'end': '2023-11-09T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '5ed59be0-f4bc-49d7-b6b0-c40371cad989',
							'name': {
								'nl': 'Halloweenpate',
								'fr': ''
							},
							'start': '2023-11-05T23:00:00.000Z',
							'end': '2023-11-09T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4626,
									24792
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '5ef5a5d1-7f82-4c6b-9f37-11b949eeff78',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-07-13T22:00:00.000Z',
						'end': '2025-08-23T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '5ef5a5d1-7f82-4c6b-9f37-11b949eeff78',
							'name': {
								'nl': 'Banners nieuwigheden',
								'fr': 'Banners nieuwigheden'
							},
							'start': '2025-07-13T22:00:00.000Z',
							'end': '2025-08-23T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'banners': [
								{
									'id': 'e1888ece-2352-4184-a26c-0e8054bad199',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/5ef5a5d1-7f82-4c6b-9f37-11b949eeff78/uhznexijfgdrkvpcsqyw07425.Banner granoliva NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/5ef5a5d1-7f82-4c6b-9f37-11b949eeff78/trzdyfeqbopjuvklaxgi28113.Banner granoliva FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '20'
								},
								{
									'id': 'd2c3ea86-2c4b-480a-a340-aaf3f6ae23bb',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/5ef5a5d1-7f82-4c6b-9f37-11b949eeff78/strqgfhoaywimxndvjlp41865.Banner camps NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/5ef5a5d1-7f82-4c6b-9f37-11b949eeff78/msrztwlvdkuineopfbqh20042.Banner camps FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '38'
								},
								{
									'id': '8c0ce950-b569-4311-a319-e20c9f50b0b3',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/5ef5a5d1-7f82-4c6b-9f37-11b949eeff78/pyltmrkugfbqdiwsaeoc31054.Banner braai BBQ NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/5ef5a5d1-7f82-4c6b-9f37-11b949eeff78/ezdthkfrgmsbjcivqoxl28639.Banner braai BBQ FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '30'
								}
							]
						}
					},
					{
						'id': '6182d1fc-e7a6-42f8-bf84-8632687de317',
						'badge': {
							'nl': 'Ideaal bij uw kaasplank',
							'fr': 'Idéalement pour votre plateau de fromage',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							25056,
							25205
						],
						'start': '2022-12-07T23:00:00.000Z',
						'end': '2022-12-12T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '6182d1fc-e7a6-42f8-bf84-8632687de317',
							'name': {
								'nl': 'Diepvries bij kaasplank',
								'fr': ''
							},
							'start': '2022-12-07T23:00:00.000Z',
							'end': '2022-12-12T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'Idéalement pour votre plateau de fromage',
										'nl': 'Ideaal bij uw kaasplank'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25056,
									25205
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '6287726d-513a-4189-ab1c-f60f2442e32e',
						'badge': {
							'nl': 'THT 22/08/2025',
							'fr': 'DLC 22/08/2025',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							1623
						],
						'start': '2025-08-03T22:00:00.000Z',
						'end': '2025-08-07T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '6287726d-513a-4189-ab1c-f60f2442e32e',
							'name': {
								'nl': 'Peperbocksbeutel',
								'fr': ''
							},
							'start': '2025-08-03T22:00:00.000Z',
							'end': '2025-08-07T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'DLC 22/08/2025',
										'nl': 'THT 22/08/2025'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									1623
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '63491510-ef43-4669-8ed0-3b1fa090c521',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26105
						],
						'start': '2025-03-31T22:00:00.000Z',
						'end': '2025-04-10T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '63491510-ef43-4669-8ed0-3b1fa090c521',
							'name': {
								'nl': 'Paasieren ',
								'fr': ''
							},
							'start': '2025-03-31T22:00:00.000Z',
							'end': '2025-04-10T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26105
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '661a922b-97ac-4dc2-8d4a-e834c186882f',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25952
						],
						'start': '2024-01-25T23:00:00.000Z',
						'end': '2024-02-01T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '661a922b-97ac-4dc2-8d4a-e834c186882f',
							'name': {
								'nl': 'Charleston',
								'fr': ''
							},
							'start': '2024-01-25T23:00:00.000Z',
							'end': '2024-02-01T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25952
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '66a7e9f9-96c9-4b6b-b175-9ed39235aeff',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-05-01T22:00:00.000Z',
						'end': '2025-05-17T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '66a7e9f9-96c9-4b6b-b175-9ed39235aeff',
							'name': {
								'nl': 'Nieuwigheden',
								'fr': 'Nieuwigheden'
							},
							'start': '2025-05-01T22:00:00.000Z',
							'end': '2025-05-17T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'banners': [
								{
									'id': '5c732128-88c9-462a-a0bb-0ec7977358d4',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/66a7e9f9-96c9-4b6b-b175-9ed39235aeff/drvtmgcwsuzqoejkpfyl54889.Banner juicy NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/66a7e9f9-96c9-4b6b-b175-9ed39235aeff/ubfsovqlnzkjxeaprmhc42580.Banner juicy NL.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '30'
								},
								{
									'id': 'cf1d8628-ea25-4b62-8fe3-9c6345beaac7',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/66a7e9f9-96c9-4b6b-b175-9ed39235aeff/hkdroqyfwgcpeubjzlvx49021.Banner juicy koeltasjes NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/66a7e9f9-96c9-4b6b-b175-9ed39235aeff/khtsrgfxcpwlqyobevnd74231.Banner juicy koeltasjes FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '47'
								},
								{
									'id': 'e19cfac9-8a46-4711-908a-3392b3d8c166',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/66a7e9f9-96c9-4b6b-b175-9ed39235aeff/nopyqbcegumfkdjzhiva14532.Banner snowdonia NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/66a7e9f9-96c9-4b6b-b175-9ed39235aeff/ftwsyierogmucbnjplhd20572.Banner snowdonia FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '40'
								}
							]
						}
					},
					{
						'id': '67c7bd2e-784b-41cc-b5f6-cfa7f4c59c61',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25019,
							25020,
							25021
						],
						'start': '2023-06-29T22:00:00.000Z',
						'end': '2023-07-06T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '67c7bd2e-784b-41cc-b5f6-cfa7f4c59c61',
							'name': {
								'nl': 'Zomerdesserten',
								'fr': ''
							},
							'start': '2023-06-29T22:00:00.000Z',
							'end': '2023-07-06T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25019,
									25020,
									25021
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '68dc846e-22dd-4869-a16f-c70dd1d42582',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26441,
							26442
						],
						'start': '2025-01-29T23:00:00.000Z',
						'end': '2025-02-06T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '68dc846e-22dd-4869-a16f-c70dd1d42582',
							'name': {
								'nl': 'Boschi',
								'fr': ''
							},
							'start': '2025-01-29T23:00:00.000Z',
							'end': '2025-02-06T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26441,
									26442
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '69135ac0-f408-4816-85c3-391cfad13186',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25857,
							26896
						],
						'start': '2025-08-18T22:00:00.000Z',
						'end': '2025-08-28T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '69135ac0-f408-4816-85c3-391cfad13186',
							'name': {
								'nl': 'Donuts',
								'fr': ''
							},
							'start': '2025-08-18T22:00:00.000Z',
							'end': '2025-08-28T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25857,
									26896
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '6ad6d02f-228b-4c43-95a7-6fd60d4faeb5',
						'badge': {
							'color': []
						},
						'filter': [],
						'start': '2022-09-19T22:00:00.000Z',
						'end': '2022-12-30T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '6ad6d02f-228b-4c43-95a7-6fd60d4faeb5',
							'name': {
								'nl': 'Charles Food Event - Kaasfiches ',
								'fr': 'Charles Food Event - Les fiches fromages'
							},
							'start': '2022-09-19T22:00:00.000Z',
							'end': '2022-12-30T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'nl': 'https://portal.charles.eu/resources/campaigns/6ad6d02f-228b-4c43-95a7-6fd60d4faeb5/mzpvysbljwhixctfqnau78783.Kaaskaartjes_portal.jpg',
									'weight': '100',
									'multilingual': true
								},
								'copy': {
									'nl': 'Wil je de kazen van Charles Food Event aanprijzen in jouw kaastoog? ',
									'fr': 'Souhaitez-vous promouvoir des fromages du Charles Food Event dans votre magasin ?'
								},
								'items': [
									{
										'id': 'ac9ad5d7-0fa2-43cb-998d-2c1e50d19cd2',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/6ad6d02f-228b-4c43-95a7-6fd60d4faeb5/pemhzjnlrgqvdocsykaf98177.Kaaskaartjes Food Event A6.pdf'
										},
										'description': {
											'nl': 'Download hier de kaasfiches van alle kazen.',
											'fr': ' Télécharchez ici les fiches fromages pour tous les fromages.'
										}
									}
								]
							}
						}
					},
					{
						'id': '6b810b99-4e26-45d0-8805-6c146e7d0502',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26157,
							26328,
							26378,
							26174
						],
						'start': '2024-10-20T22:00:00.000Z',
						'end': '2024-10-25T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '6b810b99-4e26-45d0-8805-6c146e7d0502',
							'name': {
								'nl': 'Sam producten',
								'fr': ''
							},
							'start': '2024-10-20T22:00:00.000Z',
							'end': '2024-10-25T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26157,
									26328,
									26378,
									26174
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '6bdc839b-7373-41ba-be8c-a1aeaf56381a',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							4606,
							24704,
							23476,
							4794
						],
						'start': '2023-12-26T23:00:00.000Z',
						'end': '2024-01-04T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '6bdc839b-7373-41ba-be8c-a1aeaf56381a',
							'name': {
								'nl': 'Eindejaar',
								'fr': ''
							},
							'start': '2023-12-26T23:00:00.000Z',
							'end': '2024-01-04T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4606,
									24704,
									23476,
									4794
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '6c8a8f5a-30f4-421a-a188-d9b2fac479fb',
						'badge': {
							'nl': 'Folder 12',
							'fr': 'Dépliant 12',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 12',
							'fr': 'Dépliant 12'
						},
						'articles': [
							26002,
							385,
							413,
							1513,
							1517,
							869,
							14,
							15,
							101,
							104,
							102,
							103,
							353,
							24919,
							2167,
							2127,
							2174,
							24899,
							4630,
							4646,
							22234,
							22235,
							22236,
							22237,
							22238,
							22239,
							22240,
							22242,
							22243,
							22652,
							22655,
							25018,
							25019,
							25020,
							25021,
							1145,
							1172,
							1106,
							1296,
							352,
							371,
							372,
							25531,
							25533,
							8660,
							1502,
							23742,
							2040,
							2163,
							23816,
							21716,
							31470,
							25858,
							25859,
							25860,
							25861,
							25862,
							31471,
							23711,
							23724,
							25598,
							25600,
							25603,
							25606,
							26050,
							26051,
							26052,
							26053,
							26054,
							26055,
							4880,
							26763,
							26213,
							26214,
							23516,
							4622,
							4623,
							23641,
							23642,
							23643,
							26816,
							25657,
							31170,
							31172,
							1133,
							1143,
							1098,
							4699,
							25402,
							26721,
							26722,
							26723,
							26724,
							26725,
							26726,
							26727,
							26728,
							26729,
							26730,
							26731,
							26732,
							26733,
							26734,
							26735,
							26736,
							26737,
							26738,
							26740,
							26741,
							26742,
							26743,
							26744,
							3161,
							23613,
							3235,
							23489,
							26393,
							26394,
							26395,
							3557,
							3558,
							3559,
							3560,
							23730,
							3273,
							3055,
							21879,
							26359,
							26305,
							26306,
							7033,
							70,
							55,
							69,
							79,
							92,
							25888,
							386,
							1121,
							1125,
							1063,
							7763,
							1127,
							1122,
							7525,
							7544,
							7582,
							7558,
							7603,
							23374,
							22075,
							7783,
							19424,
							25291,
							22185,
							24012,
							2209,
							5601,
							2161,
							5611,
							2217,
							2227,
							24694,
							19566,
							22192,
							23818,
							2280,
							22319,
							25064,
							25063,
							23176,
							19257,
							4331,
							4309,
							23124,
							7467,
							26467,
							2672,
							26468,
							32193
						],
						'start': '2025-05-31T22:00:00.000Z',
						'end': '2025-06-13T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '6c8a8f5a-30f4-421a-a188-d9b2fac479fb',
							'name': {
								'nl': 'Folder 12 - W23-24',
								'fr': 'Dépliant 12 - S23-24'
							},
							'start': '2025-05-31T22:00:00.000Z',
							'end': '2025-06-13T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 12',
										'fr': 'Dépliant 12'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 12',
										'fr': 'Dépliant 12'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									26002,
									385,
									413,
									1513,
									1517,
									869,
									14,
									15,
									101,
									104,
									102,
									103,
									353,
									24919,
									2167,
									2127,
									2174,
									24899,
									4630,
									4646,
									22234,
									22235,
									22236,
									22237,
									22238,
									22239,
									22240,
									22242,
									22243,
									22652,
									22655,
									25018,
									25019,
									25020,
									25021,
									1145,
									1172,
									1106,
									1296,
									352,
									371,
									372,
									25531,
									25533,
									8660,
									1502,
									23742,
									2040,
									2163,
									23816,
									21716,
									31470,
									25858,
									25859,
									25860,
									25861,
									25862,
									31471,
									23711,
									23724,
									25598,
									25600,
									25603,
									25606,
									26050,
									26051,
									26052,
									26053,
									26054,
									26055,
									4880,
									26763,
									26213,
									26214,
									23516,
									4622,
									4623,
									23641,
									23642,
									23643,
									26816,
									25657,
									31170,
									31172,
									1133,
									1143,
									1098,
									4699,
									25402,
									26721,
									26722,
									26723,
									26724,
									26725,
									26726,
									26727,
									26728,
									26729,
									26730,
									26731,
									26732,
									26733,
									26734,
									26735,
									26736,
									26737,
									26738,
									26740,
									26741,
									26742,
									26743,
									26744,
									3161,
									23613,
									3235,
									23489,
									26393,
									26394,
									26395,
									3557,
									3558,
									3559,
									3560,
									23730,
									3273,
									3055,
									21879,
									26359,
									26305,
									26306,
									7033,
									70,
									55,
									69,
									79,
									92,
									25888,
									386,
									1121,
									1125,
									1063,
									7763,
									1127,
									1122,
									7525,
									7544,
									7582,
									7558,
									7603,
									23374,
									22075,
									7783,
									19424,
									25291,
									22185,
									24012,
									2209,
									5601,
									2161,
									5611,
									2217,
									2227,
									24694,
									19566,
									22192,
									23818,
									2280,
									22319,
									25064,
									25063,
									23176,
									19257,
									4331,
									4309,
									23124,
									7467,
									26467,
									2672,
									26468,
									32193
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/jkesfbqogctxirlzunva27807.Charles_Folder_12 cover portal.jpg'
								},
								'copy': {
									'fr': 'Découvrez nos promotions ici',
									'nl': 'Ontdek hier onze folderpromoties'
								},
								'items': [
									{
										'id': 'cf9ab4c1-e4e1-41bc-b093-47f08dff8948',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/xzjwqyblntmksvugchae69304.Charles_Folder_12.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': '5001e8f6-d55f-4b49-95f3-bbffae72ae81',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/xzjwqyblntmksvugchae19119.Charles_Folder_12_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': '98d86fd1-97ae-4f1c-a82c-980852bf8876',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/kambrcdvlqwijtohsnzy67627.Banners_Folder_12 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/laefrticqonxwmjskgzu18366.Banners_Folder_12 FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								},
								{
									'id': 'cdf3f23e-43ce-45bb-aeb0-090a80591a58',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/gxcipufsrnbaeowkhmyl69790.Banner xavies skyr NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/dlnwzebctxyaufgmhkpo19169.Banner xavies skyr FR.jpg'
									},
									'action': {
										'type': 'none'
									}
								},
								{
									'id': 'bf273b14-d4ca-4c6f-b15a-0207e1f078d6',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/aipsrlbdgyfcemjxuvzo69976.Banners_Folder_13 maatjes NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/6c8a8f5a-30f4-421a-a188-d9b2fac479fb/iwsvtapxrekjdnhcuogm75655.Banners_Folder_13 maatjes FR.jpg'
									},
									'action': {
										'type': 'none'
									}
								}
							]
						}
					},
					{
						'id': '6d9d7a06-4a79-4bee-bbf5-72c217a59415',
						'badge': {
							'nl': 'EOY 2024',
							'fr': 'EOY 2024',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'EOY 2024',
							'fr': 'EOY 2024'
						},
						'articles': [
							25025,
							25030,
							25031,
							25700,
							25701,
							25703,
							25704,
							26329,
							25702,
							132,
							133,
							24963,
							24964,
							24965,
							4868,
							1455,
							6595,
							6596,
							6597,
							6599,
							19348,
							6663,
							183,
							184,
							8738,
							1027,
							1194,
							1247,
							26290,
							30423,
							7325,
							7326,
							7328,
							7329,
							7330,
							19408,
							23419,
							26410,
							26411,
							26412,
							26413,
							26414,
							26415,
							26416,
							26417,
							26418,
							26419,
							26420,
							26421,
							26422,
							26423,
							26424,
							26425,
							26426,
							26427,
							2095,
							2162,
							19951,
							23279,
							18710,
							21454,
							25189,
							4546,
							4609,
							4880,
							19266,
							25651,
							26264,
							26265,
							26266,
							26267,
							26268,
							2183,
							2383,
							25896,
							25897,
							25953,
							26215,
							30850,
							2381,
							6607,
							8679,
							25571,
							30818,
							4400,
							4402,
							4405,
							4407,
							4408,
							4409,
							4412,
							19089,
							19090,
							23351,
							25337,
							31298,
							31301,
							31303,
							31307,
							4590,
							4591,
							6590,
							6632,
							31304,
							31305,
							7291,
							2200,
							2280,
							2291,
							4827,
							6653,
							6655,
							6657,
							7456,
							7458,
							7463,
							7736,
							8066,
							8510,
							18541,
							19128,
							19396,
							19449,
							19465,
							19675,
							19990,
							19999,
							21522,
							21524,
							21888,
							23405,
							23423,
							23780,
							23993,
							24785,
							24834,
							25500,
							25705,
							26108,
							26109,
							30866,
							30880,
							2041,
							7465,
							7751,
							7752,
							19677,
							20002,
							20003,
							21880,
							24117,
							24118,
							24739,
							31694,
							1090,
							1098,
							1137,
							21309,
							21645,
							24575,
							26279,
							26280,
							26282,
							26331,
							26332,
							26334,
							26335,
							4699,
							22316,
							4422,
							4670,
							4671,
							4674,
							6647,
							6649,
							31306,
							31309,
							18668,
							21737,
							21738,
							21944,
							21945,
							25656,
							26330,
							31099,
							31100,
							31170,
							31379,
							32657,
							26250,
							26251,
							26252,
							26253,
							26254,
							26284,
							26285,
							26286,
							26287,
							26337,
							26338,
							26339,
							26340,
							3061,
							26260,
							3048,
							19873,
							7341,
							3197,
							3227,
							25305,
							26430,
							26431,
							26304,
							26305,
							26306,
							26307,
							26308,
							26309,
							26310,
							26311,
							26312,
							26313,
							26314,
							26315,
							26316,
							26317,
							26318,
							26319,
							26320,
							26362,
							3508,
							24354,
							24660,
							26389,
							26390,
							26391,
							26392,
							26393,
							26394,
							26395,
							26396,
							26397,
							26398,
							26399,
							26400,
							26401,
							26402,
							26403,
							26404,
							26405,
							26406,
							26407,
							26408,
							26409,
							21314,
							23812,
							19237,
							25056,
							23489,
							26299,
							26300,
							26301,
							26302,
							26303,
							26380,
							26381,
							26382,
							26383,
							26384,
							26385,
							26386,
							26387,
							26388,
							26321,
							26322,
							26323,
							26324,
							26325,
							26326,
							26376,
							22234,
							22235,
							22236,
							22237,
							22238,
							22239,
							22240,
							22242,
							22243,
							22652,
							22655,
							25018,
							25019,
							25020,
							25021,
							961,
							963,
							23214,
							23215,
							23216,
							23217,
							23218,
							23219,
							23220,
							23221,
							23223,
							24234,
							24235,
							22376,
							22378,
							22379,
							22380,
							22381,
							22382,
							22383,
							22384,
							22385,
							22387,
							22389,
							22390,
							22391,
							22392,
							22393,
							22394,
							22396,
							22397,
							22399,
							22401,
							22404,
							22405,
							22407,
							22411,
							22412,
							22414,
							22415,
							22417,
							22419,
							22420,
							22421,
							22423,
							22424,
							22425,
							22426,
							24874,
							22427,
							22428,
							22429,
							22430,
							26429,
							22377,
							23555,
							23556,
							23557,
							23558,
							23559,
							23560,
							23562,
							23563,
							23564,
							23565,
							23566,
							23567,
							23568,
							23569,
							23570,
							23571,
							23572,
							23573,
							23574,
							23575,
							23576,
							23577,
							23578,
							23579,
							23580,
							23581,
							24320,
							24321,
							24322,
							24323,
							24324,
							24325,
							24327,
							24399,
							24400,
							24868,
							25483,
							25484,
							26162,
							26180,
							26181,
							24105,
							24106,
							24107,
							24164,
							1959,
							1961,
							1962,
							1963,
							1964,
							1965,
							1966,
							1967,
							1968,
							1969,
							1971,
							1972,
							1974,
							1975,
							1976,
							1977,
							1979,
							1982,
							23473,
							23475,
							24195,
							24845,
							24900,
							25868,
							25911,
							24582,
							24583,
							24584,
							24585,
							24586,
							24593,
							24594,
							24613,
							24614,
							24616,
							24617,
							24618,
							24619,
							24622,
							24623,
							24627,
							24846,
							24901,
							25869,
							25912,
							24213,
							24214,
							24229,
							24217,
							24218,
							24216,
							24226,
							24227,
							24228,
							24215,
							24221,
							24225,
							24219,
							24223,
							24220,
							24224,
							24222,
							24197,
							24199,
							24196,
							24198,
							23479,
							23658,
							23660,
							23974,
							23973,
							23976,
							24504,
							24722,
							24921,
							24800,
							24931,
							25872,
							25915,
							25916,
							25917,
							26161,
							26257,
							25082,
							25262,
							24201,
							25261,
							24231,
							24723,
							23360,
							23361,
							22689,
							30,
							22688,
							5500,
							5516,
							5532,
							5518,
							5519,
							5515,
							26174,
							5520,
							22692,
							22691,
							5513,
							5503,
							5501,
							5502,
							5536,
							26157,
							5509,
							1267,
							5508,
							1269,
							5527,
							1330,
							22690,
							5512,
							5511,
							24766,
							1233,
							1232,
							24764,
							22766,
							24765,
							24763,
							5528,
							26378,
							5506,
							26328,
							5507,
							5534,
							5531,
							5530,
							25292,
							5521,
							5524,
							5525,
							24341,
							5514,
							2167,
							19343,
							26269,
							26270,
							3226,
							19941,
							24073,
							24507,
							26296,
							26297,
							26298,
							3064,
							3094,
							3182,
							3463,
							3500,
							3549,
							6524,
							6700,
							19672,
							19855,
							22767,
							23936,
							23940,
							23959,
							24242,
							24650,
							24652,
							24653,
							24654,
							25653,
							25671,
							25672,
							25673,
							26259,
							3235,
							3265,
							3305,
							3444,
							7214,
							33050,
							3183,
							3513,
							3535,
							19850,
							19968,
							21842,
							24440,
							26293,
							26294,
							3073,
							3074,
							26273,
							26274,
							26275,
							26276,
							26277,
							26278,
							26281,
							23884,
							23957,
							23836,
							23958,
							24998,
							1,
							8,
							3,
							28,
							29,
							14,
							15,
							16,
							17,
							11,
							10,
							18,
							19,
							20,
							42,
							33,
							49,
							26,
							44,
							1511,
							1514,
							1515,
							1524,
							1513,
							1517,
							869,
							1611,
							1519,
							1521,
							1595,
							1610,
							1615,
							1623,
							1637,
							1638,
							401,
							402,
							422,
							403,
							421,
							385,
							413,
							456,
							412,
							425,
							426,
							25456,
							1253,
							1257,
							1258,
							1252,
							1259,
							23987,
							1301,
							1311,
							5510,
							1331,
							1380,
							1471,
							1458,
							1457,
							1327,
							1475,
							1339,
							1476,
							24792,
							1370,
							1465,
							1467,
							1466,
							1468,
							25105,
							25106,
							25104,
							353,
							1074,
							1075,
							1080,
							1076,
							101,
							104,
							102,
							103,
							321,
							323,
							327,
							324,
							322,
							328,
							24318,
							1013,
							202,
							203,
							205,
							210,
							212,
							214,
							227,
							307,
							23661,
							24919,
							311,
							317,
							346,
							2154,
							2010,
							8575,
							2174,
							23977,
							23472,
							2148,
							2128,
							24844,
							2343,
							2132,
							2140,
							23474,
							2142,
							2131,
							2139,
							2134,
							2344,
							2171,
							2424,
							2423,
							24899,
							2421,
							2125,
							2175,
							2153,
							2109,
							25867,
							25910,
							2108,
							24703,
							24704,
							4753,
							4454,
							4692,
							4630,
							4633,
							4634,
							4693,
							4790,
							4707,
							23980,
							4752,
							4794,
							4795,
							4606,
							4710,
							4798,
							4635,
							4598,
							4681,
							23659,
							4626,
							4524,
							4569,
							4529,
							4536,
							4522,
							4554,
							4555,
							4637,
							2326,
							4646,
							4521,
							4584,
							4585,
							25715,
							19925,
							26292,
							26295,
							24568,
							24569,
							31084,
							32649,
							32652,
							23296,
							23297,
							25711,
							25712,
							25713,
							25714,
							4738,
							4739,
							19453,
							1496,
							23885,
							24581,
							4583,
							6667,
							7202,
							7203,
							7204,
							7205,
							7206,
							19462,
							19463,
							19464,
							19665,
							19461,
							3576,
							3577,
							19552,
							23730,
							22342,
							22343,
							22344,
							22345,
							22346,
							22347,
							24135,
							24996,
							25467,
							26261,
							26262,
							26263,
							26291,
							18425,
							26271,
							26272,
							25544,
							25692,
							32975,
							32979,
							21913,
							21914,
							8708,
							24093,
							25304,
							24490,
							6696,
							6697,
							19615,
							21624,
							21847,
							24172,
							25351,
							25387,
							25914,
							25956,
							26102,
							31702,
							31715,
							31716,
							31719,
							31720,
							31721,
							25641,
							25642,
							25646,
							25649,
							3044,
							3092,
							3209,
							3516,
							3530,
							3564,
							6701,
							21547,
							33051,
							19820,
							31856,
							18891,
							4622,
							4623,
							23273,
							23516,
							24423,
							24426,
							21717,
							24828,
							24829,
							24830,
							24831,
							64,
							1109,
							25888,
							21879,
							19435,
							19436,
							21912,
							32792,
							6061,
							6062,
							3808,
							3821,
							3824,
							2569,
							24036,
							24038,
							24039,
							19298,
							507,
							8910,
							31454,
							477,
							1434,
							1436,
							6615,
							25652,
							32664,
							4416,
							4421,
							4425,
							18663,
							19324,
							6578,
							7307,
							7308,
							7345,
							7550,
							7552,
							7554,
							7564,
							7569,
							7587,
							7605,
							7611,
							7613,
							7615,
							7616,
							7622,
							19933,
							21462,
							23371,
							26142,
							26199,
							3181,
							3236,
							3426,
							19550,
							21548,
							21549,
							21551,
							21552,
							23932,
							23934,
							23935,
							3280,
							3282,
							3428,
							3526,
							6522,
							6566,
							19681,
							19864,
							19872,
							21446,
							21629,
							24644,
							24655,
							25486,
							33053,
							1211,
							1212,
							1216,
							7275,
							22501,
							4801,
							5004,
							3495,
							6584,
							22367,
							22370,
							22371,
							22372,
							22373,
							23276,
							21563,
							21564,
							21565,
							21568,
							2727,
							7467,
							8337,
							19476,
							1422
						],
						'start': '2024-09-21T22:00:00.000Z',
						'end': '2024-12-30T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '6d9d7a06-4a79-4bee-bbf5-72c217a59415',
							'name': {
								'nl': 'Eindejaarscatalogus 2024',
								'fr': "Catalogue fin d'année 2024"
							},
							'start': '2024-09-21T22:00:00.000Z',
							'end': '2024-12-30T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'EOY 2024',
										'fr': 'EOY 2024'
									}
								},
								'badge': {
									'text': {
										'nl': 'EOY 2024',
										'fr': 'EOY 2024'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									25025,
									25030,
									25031,
									25700,
									25701,
									25703,
									25704,
									26329,
									25702,
									132,
									133,
									24963,
									24964,
									24965,
									4868,
									1455,
									6595,
									6596,
									6597,
									6599,
									19348,
									6663,
									183,
									184,
									8738,
									1027,
									1194,
									1247,
									26290,
									30423,
									7325,
									7326,
									7328,
									7329,
									7330,
									19408,
									23419,
									26410,
									26411,
									26412,
									26413,
									26414,
									26415,
									26416,
									26417,
									26418,
									26419,
									26420,
									26421,
									26422,
									26423,
									26424,
									26425,
									26426,
									26427,
									2095,
									2162,
									19951,
									23279,
									18710,
									21454,
									25189,
									4546,
									4609,
									4880,
									19266,
									25651,
									26264,
									26265,
									26266,
									26267,
									26268,
									2183,
									2383,
									25896,
									25897,
									25953,
									26215,
									30850,
									2381,
									6607,
									8679,
									25571,
									30818,
									4400,
									4402,
									4405,
									4407,
									4408,
									4409,
									4412,
									19089,
									19090,
									23351,
									25337,
									31298,
									31301,
									31303,
									31307,
									4590,
									4591,
									6590,
									6632,
									31304,
									31305,
									7291,
									2200,
									2280,
									2291,
									4827,
									6653,
									6655,
									6657,
									7456,
									7458,
									7463,
									7736,
									8066,
									8510,
									18541,
									19128,
									19396,
									19449,
									19465,
									19675,
									19990,
									19999,
									21522,
									21524,
									21888,
									23405,
									23423,
									23780,
									23993,
									24785,
									24834,
									25500,
									25705,
									26108,
									26109,
									30866,
									30880,
									2041,
									7465,
									7751,
									7752,
									19677,
									20002,
									20003,
									21880,
									24117,
									24118,
									24739,
									31694,
									1090,
									1098,
									1137,
									21309,
									21645,
									24575,
									26279,
									26280,
									26282,
									26331,
									26332,
									26334,
									26335,
									4699,
									22316,
									4422,
									4670,
									4671,
									4674,
									6647,
									6649,
									31306,
									31309,
									18668,
									21737,
									21738,
									21944,
									21945,
									25656,
									26330,
									31099,
									31100,
									31170,
									31379,
									32657,
									26250,
									26251,
									26252,
									26253,
									26254,
									26284,
									26285,
									26286,
									26287,
									26337,
									26338,
									26339,
									26340,
									3061,
									26260,
									3048,
									19873,
									7341,
									3197,
									3227,
									25305,
									26430,
									26431,
									26304,
									26305,
									26306,
									26307,
									26308,
									26309,
									26310,
									26311,
									26312,
									26313,
									26314,
									26315,
									26316,
									26317,
									26318,
									26319,
									26320,
									26362,
									3508,
									24354,
									24660,
									26389,
									26390,
									26391,
									26392,
									26393,
									26394,
									26395,
									26396,
									26397,
									26398,
									26399,
									26400,
									26401,
									26402,
									26403,
									26404,
									26405,
									26406,
									26407,
									26408,
									26409,
									21314,
									23812,
									19237,
									25056,
									23489,
									26299,
									26300,
									26301,
									26302,
									26303,
									26380,
									26381,
									26382,
									26383,
									26384,
									26385,
									26386,
									26387,
									26388,
									26321,
									26322,
									26323,
									26324,
									26325,
									26326,
									26376,
									22234,
									22235,
									22236,
									22237,
									22238,
									22239,
									22240,
									22242,
									22243,
									22652,
									22655,
									25018,
									25019,
									25020,
									25021,
									961,
									963,
									23214,
									23215,
									23216,
									23217,
									23218,
									23219,
									23220,
									23221,
									23223,
									24234,
									24235,
									22376,
									22378,
									22379,
									22380,
									22381,
									22382,
									22383,
									22384,
									22385,
									22387,
									22389,
									22390,
									22391,
									22392,
									22393,
									22394,
									22396,
									22397,
									22399,
									22401,
									22404,
									22405,
									22407,
									22411,
									22412,
									22414,
									22415,
									22417,
									22419,
									22420,
									22421,
									22423,
									22424,
									22425,
									22426,
									24874,
									22427,
									22428,
									22429,
									22430,
									26429,
									22377,
									23555,
									23556,
									23557,
									23558,
									23559,
									23560,
									23562,
									23563,
									23564,
									23565,
									23566,
									23567,
									23568,
									23569,
									23570,
									23571,
									23572,
									23573,
									23574,
									23575,
									23576,
									23577,
									23578,
									23579,
									23580,
									23581,
									24320,
									24321,
									24322,
									24323,
									24324,
									24325,
									24327,
									24399,
									24400,
									24868,
									25483,
									25484,
									26162,
									26180,
									26181,
									24105,
									24106,
									24107,
									24164,
									1959,
									1961,
									1962,
									1963,
									1964,
									1965,
									1966,
									1967,
									1968,
									1969,
									1971,
									1972,
									1974,
									1975,
									1976,
									1977,
									1979,
									1982,
									23473,
									23475,
									24195,
									24845,
									24900,
									25868,
									25911,
									24582,
									24583,
									24584,
									24585,
									24586,
									24593,
									24594,
									24613,
									24614,
									24616,
									24617,
									24618,
									24619,
									24622,
									24623,
									24627,
									24846,
									24901,
									25869,
									25912,
									24213,
									24214,
									24229,
									24217,
									24218,
									24216,
									24226,
									24227,
									24228,
									24215,
									24221,
									24225,
									24219,
									24223,
									24220,
									24224,
									24222,
									24197,
									24199,
									24196,
									24198,
									23479,
									23658,
									23660,
									23974,
									23973,
									23976,
									24504,
									24722,
									24921,
									24800,
									24931,
									25872,
									25915,
									25916,
									25917,
									26161,
									26257,
									25082,
									25262,
									24201,
									25261,
									24231,
									24723,
									23360,
									23361,
									22689,
									30,
									22688,
									5500,
									5516,
									5532,
									5518,
									5519,
									5515,
									26174,
									5520,
									22692,
									22691,
									5513,
									5503,
									5501,
									5502,
									5536,
									26157,
									5509,
									1267,
									5508,
									1269,
									5527,
									1330,
									22690,
									5512,
									5511,
									24766,
									1233,
									1232,
									24764,
									22766,
									24765,
									24763,
									5528,
									26378,
									5506,
									26328,
									5507,
									5534,
									5531,
									5530,
									25292,
									5521,
									5524,
									5525,
									24341,
									5514,
									2167,
									19343,
									26269,
									26270,
									3226,
									19941,
									24073,
									24507,
									26296,
									26297,
									26298,
									3064,
									3094,
									3182,
									3463,
									3500,
									3549,
									6524,
									6700,
									19672,
									19855,
									22767,
									23936,
									23940,
									23959,
									24242,
									24650,
									24652,
									24653,
									24654,
									25653,
									25671,
									25672,
									25673,
									26259,
									3235,
									3265,
									3305,
									3444,
									7214,
									33050,
									3183,
									3513,
									3535,
									19850,
									19968,
									21842,
									24440,
									26293,
									26294,
									3073,
									3074,
									26273,
									26274,
									26275,
									26276,
									26277,
									26278,
									26281,
									23884,
									23957,
									23836,
									23958,
									24998,
									1,
									8,
									3,
									28,
									29,
									14,
									15,
									16,
									17,
									11,
									10,
									18,
									19,
									20,
									42,
									33,
									49,
									26,
									44,
									1511,
									1514,
									1515,
									1524,
									1513,
									1517,
									869,
									1611,
									1519,
									1521,
									1595,
									1610,
									1615,
									1623,
									1637,
									1638,
									401,
									402,
									422,
									403,
									421,
									385,
									413,
									456,
									412,
									425,
									426,
									25456,
									1253,
									1257,
									1258,
									1252,
									1259,
									23987,
									1301,
									1311,
									5510,
									1331,
									1380,
									1471,
									1458,
									1457,
									1327,
									1475,
									1339,
									1476,
									24792,
									1370,
									1465,
									1467,
									1466,
									1468,
									25105,
									25106,
									25104,
									353,
									1074,
									1075,
									1080,
									1076,
									101,
									104,
									102,
									103,
									321,
									323,
									327,
									324,
									322,
									328,
									24318,
									1013,
									202,
									203,
									205,
									210,
									212,
									214,
									227,
									307,
									23661,
									24919,
									311,
									317,
									346,
									2154,
									2010,
									8575,
									2174,
									23977,
									23472,
									2148,
									2128,
									24844,
									2343,
									2132,
									2140,
									23474,
									2142,
									2131,
									2139,
									2134,
									2344,
									2171,
									2424,
									2423,
									24899,
									2421,
									2125,
									2175,
									2153,
									2109,
									25867,
									25910,
									2108,
									24703,
									24704,
									4753,
									4454,
									4692,
									4630,
									4633,
									4634,
									4693,
									4790,
									4707,
									23980,
									4752,
									4794,
									4795,
									4606,
									4710,
									4798,
									4635,
									4598,
									4681,
									23659,
									4626,
									4524,
									4569,
									4529,
									4536,
									4522,
									4554,
									4555,
									4637,
									2326,
									4646,
									4521,
									4584,
									4585,
									25715,
									19925,
									26292,
									26295,
									24568,
									24569,
									31084,
									32649,
									32652,
									23296,
									23297,
									25711,
									25712,
									25713,
									25714,
									4738,
									4739,
									19453,
									1496,
									23885,
									24581,
									4583,
									6667,
									7202,
									7203,
									7204,
									7205,
									7206,
									19462,
									19463,
									19464,
									19665,
									19461,
									3576,
									3577,
									19552,
									23730,
									22342,
									22343,
									22344,
									22345,
									22346,
									22347,
									24135,
									24996,
									25467,
									26261,
									26262,
									26263,
									26291,
									18425,
									26271,
									26272,
									25544,
									25692,
									32975,
									32979,
									21913,
									21914,
									8708,
									24093,
									25304,
									24490,
									6696,
									6697,
									19615,
									21624,
									21847,
									24172,
									25351,
									25387,
									25914,
									25956,
									26102,
									31702,
									31715,
									31716,
									31719,
									31720,
									31721,
									25641,
									25642,
									25646,
									25649,
									3044,
									3092,
									3209,
									3516,
									3530,
									3564,
									6701,
									21547,
									33051,
									19820,
									31856,
									18891,
									4622,
									4623,
									23273,
									23516,
									24423,
									24426,
									21717,
									24828,
									24829,
									24830,
									24831,
									64,
									1109,
									25888,
									21879,
									19435,
									19436,
									21912,
									32792,
									6061,
									6062,
									3808,
									3821,
									3824,
									2569,
									24036,
									24038,
									24039,
									19298,
									507,
									8910,
									31454,
									477,
									1434,
									1436,
									6615,
									25652,
									32664,
									4416,
									4421,
									4425,
									18663,
									19324,
									6578,
									7307,
									7308,
									7345,
									7550,
									7552,
									7554,
									7564,
									7569,
									7587,
									7605,
									7611,
									7613,
									7615,
									7616,
									7622,
									19933,
									21462,
									23371,
									26142,
									26199,
									3181,
									3236,
									3426,
									19550,
									21548,
									21549,
									21551,
									21552,
									23932,
									23934,
									23935,
									3280,
									3282,
									3428,
									3526,
									6522,
									6566,
									19681,
									19864,
									19872,
									21446,
									21629,
									24644,
									24655,
									25486,
									33053,
									1211,
									1212,
									1216,
									7275,
									22501,
									4801,
									5004,
									3495,
									6584,
									22367,
									22370,
									22371,
									22372,
									22373,
									23276,
									21563,
									21564,
									21565,
									21568,
									2727,
									7467,
									8337,
									19476,
									1422
								]
							},
							'documents': {
								'cover': {
									'nl': 'https://portal.charles.eu/resources/campaigns/6d9d7a06-4a79-4bee-bbf5-72c217a59415/izvpwemclrkuhyabsnox79872.EOY_2024_NL_cover.jpg',
									'fr': 'https://portal.charles.eu/resources/campaigns/6d9d7a06-4a79-4bee-bbf5-72c217a59415/rhlsviaejnoyfbqcwztx41633.EOY_2024_FR_cover.jpg'
								},
								'copy': {
									'nl': 'Ontdek hier onze eindejaarcatalogus 2024',
									'fr': "Découvrez notre catalogue de fin d'année 2024 ici"
								},
								'items': [
									{
										'id': '8c97fc9c-68ee-496c-8c84-d63fc2c24293',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/6d9d7a06-4a79-4bee-bbf5-72c217a59415/ualkzovepnixfshbtdcy86528.EOY_2024_NL.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/6d9d7a06-4a79-4bee-bbf5-72c217a59415/lzufjnmbapyicwvqoser44770.EOY_2024_FR.pdf'
										},
										'description': {
											'nl': 'Bekijk hier de catalogus',
											'fr': 'Consultez le catalogue ici'
										}
									}
								]
							},
							'banners': [
								{
									'id': 'a8f4ecfb-527c-411a-8918-032bed41e7ce',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/6d9d7a06-4a79-4bee-bbf5-72c217a59415/ghjqovfnayedsimctpxu32088.Banner_EOY2024_NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/6d9d7a06-4a79-4bee-bbf5-72c217a59415/bsgqedmpfxwjitkvzchn19908.Banner_EOY2024 FR.jpg'
									},
									'action': {
										'type': 'document',
										'doc': '8c97fc9c-68ee-496c-8c84-d63fc2c24293'
									},
									'weight': '10'
								}
							]
						}
					},
					{
						'id': '6dbae0f9-bbd9-49a0-a46b-124621b98a7f',
						'badge': {
							'nl': 'Nieuwigheden',
							'fr': 'Nouveauté',
							'color': {
								'text': '#FFFFFF',
								'bg': '#C1222F'
							}
						},
						'filter': {
							'nl': 'Nieuwigheden',
							'fr': 'Nouveauté'
						},
						'articles': [
							26721,
							26722,
							26723,
							26724,
							26725,
							26726,
							26727,
							26728,
							26729,
							26730,
							26731,
							26732,
							26733,
							26734,
							26735,
							26736,
							26737,
							26738,
							26739,
							26740,
							26741,
							26742,
							26743,
							26744
						],
						'start': '2025-06-19T22:00:00.000Z',
						'end': '2025-07-12T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '6dbae0f9-bbd9-49a0-a46b-124621b98a7f',
							'name': {
								'nl': 'Banners nieuwigheden',
								'fr': 'Banners nieuwigheden'
							},
							'start': '2025-06-19T22:00:00.000Z',
							'end': '2025-07-12T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'banners': [
								{
									'id': '9540c76f-831c-47db-a09c-ca049239b621',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/6dbae0f9-bbd9-49a0-a46b-124621b98a7f/punwybevktiqogaslmxc02401.Banner think tomato NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/6dbae0f9-bbd9-49a0-a46b-124621b98a7f/hvcjtwlqexrugdafpimk16480.Banner think tomato FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '20'
								},
								{
									'id': '94498462-79b8-4ca3-ac56-995ba8d45d0e',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/6dbae0f9-bbd9-49a0-a46b-124621b98a7f/klbhoptevnxmdcwsazqy89915.Banner braai BBQ NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/6dbae0f9-bbd9-49a0-a46b-124621b98a7f/dprwtqxbzivlfojymegu24937.Banner braai BBQ FR.jpg'
									},
									'action': {
										'type': 'none'
									}
								},
								{
									'id': 'a2a8fa2f-502e-4c92-bc3f-b77438a3ca7b',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/6dbae0f9-bbd9-49a0-a46b-124621b98a7f/punwybevktiqogaslmxc96014.Banner granoliva NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/6dbae0f9-bbd9-49a0-a46b-124621b98a7f/fwqxcmrhnpevlzudjotk33164.Banner granoliva FR.jpg'
									},
									'action': {
										'type': 'none'
									}
								}
							]
						}
					},
					{
						'id': '71f88dc4-b456-42d9-b43c-3e267838f518',
						'badge': {
							'nl': 'Nieuw in assortiment',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26120,
							26121,
							26088,
							26250,
							26251,
							26252,
							26253,
							26254,
							26284,
							26285,
							26286,
							26287,
							26337,
							26338,
							26339,
							26340
						],
						'start': '2024-10-11T22:00:00.000Z',
						'end': '2024-10-18T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '71f88dc4-b456-42d9-b43c-3e267838f518',
							'name': {
								'nl': 'Nieuw in assortiment - Vanderhaegen',
								'fr': 'Nouveau en assortiment'
							},
							'start': '2024-10-11T22:00:00.000Z',
							'end': '2024-10-18T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'Nieuw in assortiment'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26120,
									26121,
									26088,
									26250,
									26251,
									26252,
									26253,
									26254,
									26284,
									26285,
									26286,
									26287,
									26337,
									26338,
									26339,
									26340
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '72117d30-deee-4a5a-8229-897813628787',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							19236,
							21720
						],
						'start': '2022-12-12T23:00:00.000Z',
						'end': '2022-12-15T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '72117d30-deee-4a5a-8229-897813628787',
							'name': {
								'nl': 'Pistoletjes',
								'fr': ''
							},
							'start': '2022-12-12T23:00:00.000Z',
							'end': '2022-12-15T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									19236,
									21720
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '725ae76f-2d3a-4a98-aede-3f5cab960946',
						'badge': {
							'nl': 'Nationale promoties  december',
							'fr': 'Promotions nationale décembre',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Nationale promoties  december',
							'fr': 'Promotions nationale décembre'
						},
						'articles': [
							1716,
							1571,
							1575,
							1573,
							1564,
							1563,
							111,
							185,
							112,
							2200,
							21880,
							8066,
							25528,
							25891,
							23818,
							2291,
							7526,
							24768,
							7345,
							25492,
							25491,
							23371,
							7587,
							6578,
							7308,
							7611,
							7605,
							23374,
							7545,
							7525,
							23646,
							7558,
							7549,
							7616,
							23372,
							19406,
							4572,
							4658,
							4564,
							6182,
							4567,
							31145,
							23279,
							2227,
							2217,
							5613,
							2205,
							5616,
							2101,
							5615,
							2207,
							5610,
							2095,
							6689,
							19517,
							19543,
							26469,
							2941,
							19898,
							32369,
							19474,
							32278,
							23266,
							25748
						],
						'start': '2024-11-30T23:00:00.000Z',
						'end': '2024-12-27T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '725ae76f-2d3a-4a98-aede-3f5cab960946',
							'name': {
								'nl': 'Nationale promoties  december',
								'fr': 'Promotions nationale décembre'
							},
							'start': '2024-11-30T23:00:00.000Z',
							'end': '2024-12-27T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Nationale promoties  december',
										'fr': 'Promotions nationale décembre'
									}
								},
								'badge': {
									'text': {
										'nl': 'Nationale promoties  december',
										'fr': 'Promotions nationale décembre'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									1716,
									1571,
									1575,
									1573,
									1564,
									1563,
									111,
									185,
									112,
									2200,
									21880,
									8066,
									25528,
									25891,
									23818,
									2291,
									7526,
									24768,
									7345,
									25492,
									25491,
									23371,
									7587,
									6578,
									7308,
									7611,
									7605,
									23374,
									7545,
									7525,
									23646,
									7558,
									7549,
									7616,
									23372,
									19406,
									4572,
									4658,
									4564,
									6182,
									4567,
									31145,
									23279,
									2227,
									2217,
									5613,
									2205,
									5616,
									2101,
									5615,
									2207,
									5610,
									2095,
									6689,
									19517,
									19543,
									26469,
									2941,
									19898,
									32369,
									19474,
									32278,
									23266,
									25748
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/725ae76f-2d3a-4a98-aede-3f5cab960946/vuxnkqcefptodjhrgalb60839.Winter 2024 Nationale promoties.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'Ontdek onze folderpromoties hier',
									'fr': 'Découvrez nos promotions ici'
								},
								'items': [
									{
										'id': '1b657684-44c4-4874-b9d1-741b680fe32d',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/725ae76f-2d3a-4a98-aede-3f5cab960946/qzjbawvnxdsctkgiuoem44540.Winter 2024 Nationale promoties.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': 'ce1d2f99-5327-469b-a352-089ece514a6a',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/725ae76f-2d3a-4a98-aede-3f5cab960946/jfzpcwdlsrvamioyguht58181.Winter 2024 Nationale promoties.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': '266068a6-2ed9-4100-b4c6-7fa437bc33de',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/725ae76f-2d3a-4a98-aede-3f5cab960946/jfzpcwdlsrvamioyguht14220.Banners_December_nationale_promoties.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/725ae76f-2d3a-4a98-aede-3f5cab960946/joesbnuhxazqmlwgrdfk68640.Banners_December_nationale_promoties FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': '73145a3b-8c37-4a0b-8dbb-c11ef7726266',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							24844,
							4569
						],
						'start': '2022-05-29T22:00:00.000Z',
						'end': '2022-06-02T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '73145a3b-8c37-4a0b-8dbb-c11ef7726266',
							'name': {
								'nl': 'Kip Bearnaise',
								'fr': ''
							},
							'start': '2022-05-29T22:00:00.000Z',
							'end': '2022-06-02T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24844,
									4569
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '76d1b2e5-65b1-4781-b352-b6227ed0ab9a',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							22158
						],
						'start': '2025-08-06T22:00:00.000Z',
						'end': '2025-08-14T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '76d1b2e5-65b1-4781-b352-b6227ed0ab9a',
							'name': {
								'nl': 'Tomatino',
								'fr': ''
							},
							'start': '2025-08-06T22:00:00.000Z',
							'end': '2025-08-14T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									22158
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '77627e08-bceb-464d-bbcb-e2dc7e2874fa',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24901,
							4536,
							25082
						],
						'start': '2025-03-13T23:00:00.000Z',
						'end': '2025-03-20T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '77627e08-bceb-464d-bbcb-e2dc7e2874fa',
							'name': {
								'nl': 'Spicy grilled chicken ',
								'fr': ''
							},
							'start': '2025-03-13T23:00:00.000Z',
							'end': '2025-03-20T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24901,
									4536,
									25082
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '788ec526-fce9-42b4-ab4a-10bdc988e72b',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2108,
							2122
						],
						'start': '2024-03-07T23:00:00.000Z',
						'end': '2024-03-21T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '788ec526-fce9-42b4-ab4a-10bdc988e72b',
							'name': {
								'nl': 'Smossalade terug in assortiment',
								'fr': ''
							},
							'start': '2024-03-07T23:00:00.000Z',
							'end': '2024-03-21T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2108,
									2122
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '7bf00fbc-6165-4c78-8f45-3e2c0c0750a6',
						'badge': {
							'nl': 'Terug in assortiment de asperge producten',
							'fr': 'Retour en assortiment',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2123,
							24319,
							1067,
							1391,
							24245
						],
						'start': '2025-02-09T23:00:00.000Z',
						'end': '2025-02-20T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '7bf00fbc-6165-4c78-8f45-3e2c0c0750a6',
							'name': {
								'nl': 'Asperge producten',
								'fr': ''
							},
							'start': '2025-02-09T23:00:00.000Z',
							'end': '2025-02-20T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'Retour en assortiment',
										'nl': 'Terug in assortiment de asperge producten'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2123,
									24319,
									1067,
									1391,
									24245
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '802ef208-23a9-408e-b012-eb3c46fd49f3',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25456
						],
						'start': '2025-01-12T23:00:00.000Z',
						'end': '2025-01-16T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '802ef208-23a9-408e-b012-eb3c46fd49f3',
							'name': {
								'nl': 'Lookworsten',
								'fr': ''
							},
							'start': '2025-01-12T23:00:00.000Z',
							'end': '2025-01-16T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25456
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '840e204a-c013-44e1-a064-da5b10fcf45e',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25413
						],
						'start': '2023-05-14T22:00:00.000Z',
						'end': '2023-05-19T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '840e204a-c013-44e1-a064-da5b10fcf45e',
							'name': {
								'nl': 'Fakkelbrood',
								'fr': ''
							},
							'start': '2023-05-14T22:00:00.000Z',
							'end': '2023-05-19T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25413
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '8487a0c3-2bbb-42d0-a475-327ece75801d',
						'badge': {
							'nl': 'Folder 06',
							'fr': 'Dépliant 06',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 06',
							'fr': 'Dépliant 06'
						},
						'articles': [
							1324,
							26504,
							2122,
							24213,
							24214,
							24229,
							24217,
							24218,
							24216,
							24226,
							24227,
							24228,
							24215,
							24221,
							24225,
							24219,
							24223,
							24220,
							24224,
							24222,
							24197,
							24199,
							24196,
							24198,
							23479,
							23658,
							23660,
							23974,
							23973,
							23976,
							24504,
							24722,
							24921,
							24723,
							24800,
							24931,
							25872,
							25916,
							26161,
							26257,
							24319,
							22235,
							7049,
							23078,
							1422,
							234,
							19558,
							21989,
							1287,
							183,
							184,
							8738,
							166,
							2127,
							2280,
							7567,
							4562,
							4563,
							22560,
							2516,
							18666,
							21944,
							21945,
							31177,
							8708,
							2372,
							31558,
							2362,
							31563,
							2363,
							2357,
							2393,
							2355,
							2356,
							2359,
							3268,
							26506,
							25544,
							33015,
							33051,
							21547,
							3231,
							3055,
							26310,
							111,
							185,
							112,
							566,
							314,
							305,
							106,
							107,
							156,
							157,
							1571,
							1575,
							1573,
							1564,
							1563,
							24478,
							1372,
							1340,
							23088,
							8470,
							8479,
							21751,
							23069,
							1379,
							1394,
							7545,
							24768,
							7624,
							7556,
							7603,
							23374,
							26495,
							26496,
							26497,
							26494,
							26490,
							26491,
							26492,
							26489,
							26493,
							26498,
							4636,
							24202,
							4658,
							8399,
							26562,
							26332,
							26331,
							26335,
							26334,
							26333,
							2019,
							8045,
							74,
							63,
							3895,
							3894,
							3996,
							3893,
							32915,
							4564,
							6182,
							4567,
							31145,
							23052
						],
						'start': '2025-03-08T23:00:00.000Z',
						'end': '2025-03-22T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '8487a0c3-2bbb-42d0-a475-327ece75801d',
							'name': {
								'nl': 'Folder 06 - W11-12',
								'fr': 'Dépliant 06 - S11-12'
							},
							'start': '2025-03-08T23:00:00.000Z',
							'end': '2025-03-22T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 06',
										'fr': 'Dépliant 06'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 06',
										'fr': 'Dépliant 06'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									1324,
									26504,
									2122,
									24213,
									24214,
									24229,
									24217,
									24218,
									24216,
									24226,
									24227,
									24228,
									24215,
									24221,
									24225,
									24219,
									24223,
									24220,
									24224,
									24222,
									24197,
									24199,
									24196,
									24198,
									23479,
									23658,
									23660,
									23974,
									23973,
									23976,
									24504,
									24722,
									24921,
									24723,
									24800,
									24931,
									25872,
									25916,
									26161,
									26257,
									24319,
									22235,
									7049,
									23078,
									1422,
									234,
									19558,
									21989,
									1287,
									183,
									184,
									8738,
									166,
									2127,
									2280,
									7567,
									4562,
									4563,
									22560,
									2516,
									18666,
									21944,
									21945,
									31177,
									8708,
									2372,
									31558,
									2362,
									31563,
									2363,
									2357,
									2393,
									2355,
									2356,
									2359,
									3268,
									26506,
									25544,
									33015,
									33051,
									21547,
									3231,
									3055,
									26310,
									111,
									185,
									112,
									566,
									314,
									305,
									106,
									107,
									156,
									157,
									1571,
									1575,
									1573,
									1564,
									1563,
									24478,
									1372,
									1340,
									23088,
									8470,
									8479,
									21751,
									23069,
									1379,
									1394,
									7545,
									24768,
									7624,
									7556,
									7603,
									23374,
									26495,
									26496,
									26497,
									26494,
									26490,
									26491,
									26492,
									26489,
									26493,
									26498,
									4636,
									24202,
									4658,
									8399,
									26562,
									26332,
									26331,
									26335,
									26334,
									26333,
									2019,
									8045,
									74,
									63,
									3895,
									3894,
									3996,
									3893,
									32915,
									4564,
									6182,
									4567,
									31145,
									23052
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/8487a0c3-2bbb-42d0-a475-327ece75801d/zjgoebwfuiksaqvypxrm53675.Charles_Folder_06 cover portal.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'Ontdek onze folderpromoties hier',
									'fr': 'Découvrez nos promotions ici'
								},
								'items': [
									{
										'id': '5dcbc6f5-f2f4-462b-96b0-7240a8622118',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/8487a0c3-2bbb-42d0-a475-327ece75801d/ngymuwschvezpaodirxl14155.Charles_Folder_06.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': '492d6b1b-70c8-4e1d-b9b0-d8e6655aefd5',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/8487a0c3-2bbb-42d0-a475-327ece75801d/jfohmyzbcaliuvnksrdx91659.Charles_Folder_06_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': '629d3e0c-7b50-417a-b63c-7ed36e62cfc0',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/8487a0c3-2bbb-42d0-a475-327ece75801d/hlxwdunzjvypmbsqacfk07682.Banners_Folder_06 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/8487a0c3-2bbb-42d0-a475-327ece75801d/tcpbmyogudezlnirshqk56853.Banners_Folder_06 FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': '849c0954-45c5-45a4-a27a-125c274b6b09',
						'badge': {
							'nl': 'Nieuw in assortiment',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26002
						],
						'start': '2024-04-29T22:00:00.000Z',
						'end': '2024-05-09T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '849c0954-45c5-45a4-a27a-125c274b6b09',
							'name': {
								'nl': 'Varkensgrillworsten',
								'fr': ''
							},
							'start': '2024-04-29T22:00:00.000Z',
							'end': '2024-05-09T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'Nieuw in assortiment'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26002
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '894641a0-f98f-4866-9d0d-c206a20d214a',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25910
						],
						'start': '2024-04-16T22:00:00.000Z',
						'end': '2024-04-25T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '894641a0-f98f-4866-9d0d-c206a20d214a',
							'name': {
								'nl': 'Chicken kebab',
								'fr': ''
							},
							'start': '2024-04-16T22:00:00.000Z',
							'end': '2024-04-25T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25910
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '8cbfe32d-9169-4638-9d2a-90d58c5503ef',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26388
						],
						'start': '2024-11-24T23:00:00.000Z',
						'end': '2024-11-30T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '8cbfe32d-9169-4638-9d2a-90d58c5503ef',
							'name': {
								'nl': 'Mini desserts ',
								'fr': ''
							},
							'start': '2024-11-24T23:00:00.000Z',
							'end': '2024-11-30T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26388
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '907095f9-cea5-4042-9151-c14c47709174',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							4795,
							4626,
							23980,
							4710
						],
						'start': '2025-01-26T23:00:00.000Z',
						'end': '2025-01-29T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '907095f9-cea5-4042-9151-c14c47709174',
							'name': {
								'nl': 'Overstock eindejaargerechten',
								'fr': ''
							},
							'start': '2025-01-26T23:00:00.000Z',
							'end': '2025-01-29T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4795,
									4626,
									23980,
									4710
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '90feaf55-1684-4ab1-9c69-b48af2e0c97b',
						'badge': {
							'nl': 'Nieuwigheden',
							'fr': 'Nouveauté',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Nieuwigheden',
							'fr': 'Nouveauté'
						},
						'articles': [
							26842,
							26843,
							26844,
							26845,
							26846,
							26847,
							26848,
							26850,
							26852,
							26853,
							27065,
							27066,
							27067,
							27068,
							27069,
							27070,
							25563,
							3129,
							24573,
							32565,
							193,
							27089,
							26211,
							26720,
							27072,
							27073,
							27074,
							26869,
							27079,
							27080,
							27081,
							27082,
							27083,
							27084,
							27085,
							27086,
							27087,
							26147,
							27181,
							27182,
							27183,
							27129,
							27130,
							27177,
							26889,
							26890,
							26891,
							26892,
							26893,
							26931,
							26932,
							26933,
							27178,
							27179,
							27180,
							27113,
							27125,
							27126,
							27127,
							27105,
							27112,
							26819,
							26820,
							26822,
							27092,
							27093,
							27094,
							27095,
							27096,
							27097,
							27098,
							27099,
							27100,
							27101,
							27102,
							27103,
							27104,
							27106,
							27107,
							27108,
							27109,
							27110,
							27111,
							27075,
							27076,
							27077,
							27078,
							26839,
							26840,
							27165,
							27166,
							27167,
							27168,
							27169,
							27170,
							27171,
							27172,
							27173,
							27174,
							27175,
							27176,
							27128,
							27143,
							27144,
							27145,
							27146,
							27147,
							27148,
							27149,
							27150,
							27151,
							27152,
							27153,
							27154,
							27155,
							27156,
							27157,
							27158,
							27159,
							27160,
							27161,
							27162,
							27163,
							27164,
							27215,
							27216,
							27217,
							27218,
							27219,
							27220,
							27222,
							27223,
							27224,
							27226,
							26830,
							27256,
							26823,
							27236,
							26877,
							27185,
							27233,
							27120,
							27121,
							27122,
							27123,
							27124,
							27088,
							26975,
							27234,
							27235,
							27238,
							27239,
							27240,
							27241,
							27237,
							27090,
							27091,
							27255,
							27253,
							27189,
							27190,
							27193,
							27195,
							27197,
							27198,
							27199,
							27201,
							27202,
							27191,
							27192,
							27194,
							27259,
							27254,
							27114,
							27115,
							27116,
							27117,
							27118,
							27119,
							27051,
							27052,
							27053,
							27054,
							27055,
							27056,
							27057,
							27058,
							27196,
							27257,
							27258,
							24263,
							30534,
							21482,
							33003
						],
						'start': '2025-05-31T22:00:00.000Z',
						'end': '2025-08-30T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '90feaf55-1684-4ab1-9c69-b48af2e0c97b',
							'name': {
								'nl': 'Nieuwigheden',
								'fr': 'Nouveauté'
							},
							'start': '2025-05-31T22:00:00.000Z',
							'end': '2025-08-30T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Nieuwigheden',
										'fr': 'Nouveauté'
									}
								},
								'badge': {
									'text': {
										'nl': 'Nieuwigheden',
										'fr': 'Nouveauté'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									26842,
									26843,
									26844,
									26845,
									26846,
									26847,
									26848,
									26850,
									26852,
									26853,
									27065,
									27066,
									27067,
									27068,
									27069,
									27070,
									25563,
									3129,
									24573,
									32565,
									193,
									27089,
									26211,
									26720,
									27072,
									27073,
									27074,
									26869,
									27079,
									27080,
									27081,
									27082,
									27083,
									27084,
									27085,
									27086,
									27087,
									26147,
									27181,
									27182,
									27183,
									27129,
									27130,
									27177,
									26889,
									26890,
									26891,
									26892,
									26893,
									26931,
									26932,
									26933,
									27178,
									27179,
									27180,
									27113,
									27125,
									27126,
									27127,
									27105,
									27112,
									26819,
									26820,
									26822,
									27092,
									27093,
									27094,
									27095,
									27096,
									27097,
									27098,
									27099,
									27100,
									27101,
									27102,
									27103,
									27104,
									27106,
									27107,
									27108,
									27109,
									27110,
									27111,
									27075,
									27076,
									27077,
									27078,
									26839,
									26840,
									27165,
									27166,
									27167,
									27168,
									27169,
									27170,
									27171,
									27172,
									27173,
									27174,
									27175,
									27176,
									27128,
									27143,
									27144,
									27145,
									27146,
									27147,
									27148,
									27149,
									27150,
									27151,
									27152,
									27153,
									27154,
									27155,
									27156,
									27157,
									27158,
									27159,
									27160,
									27161,
									27162,
									27163,
									27164,
									27215,
									27216,
									27217,
									27218,
									27219,
									27220,
									27222,
									27223,
									27224,
									27226,
									26830,
									27256,
									26823,
									27236,
									26877,
									27185,
									27233,
									27120,
									27121,
									27122,
									27123,
									27124,
									27088,
									26975,
									27234,
									27235,
									27238,
									27239,
									27240,
									27241,
									27237,
									27090,
									27091,
									27255,
									27253,
									27189,
									27190,
									27193,
									27195,
									27197,
									27198,
									27199,
									27201,
									27202,
									27191,
									27192,
									27194,
									27259,
									27254,
									27114,
									27115,
									27116,
									27117,
									27118,
									27119,
									27051,
									27052,
									27053,
									27054,
									27055,
									27056,
									27057,
									27058,
									27196,
									27257,
									27258,
									24263,
									30534,
									21482,
									33003
								]
							}
						}
					},
					{
						'id': '91724ff2-571a-4655-afb0-7dbb941dc8e8',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25710,
							25709
						],
						'start': '2024-09-12T22:00:00.000Z',
						'end': '2024-09-19T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '91724ff2-571a-4655-afb0-7dbb941dc8e8',
							'name': {
								'nl': 'Kaas en Garnaalkroketten',
								'fr': ''
							},
							'start': '2024-09-12T22:00:00.000Z',
							'end': '2024-09-19T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25710,
									25709
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '9556668a-c047-49f6-b652-94819bbfc1c8',
						'badge': {
							'nl': 'Folder 08',
							'fr': 'Dépliant 08',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 08',
							'fr': 'Dépliant 08'
						},
						'articles': [
							446,
							26002,
							11,
							10,
							1515,
							1638,
							1074,
							26378,
							311,
							317,
							346,
							26541,
							1301,
							2139,
							25910,
							2167,
							4633,
							4681,
							351,
							574,
							26694,
							568,
							1532,
							21665,
							1579,
							21502,
							21870,
							398,
							30364,
							8066,
							24393,
							8549,
							26264,
							2049,
							25054,
							25055,
							8087,
							8742,
							31697,
							3566,
							19914,
							25033,
							25034,
							24963,
							24965,
							19384,
							24490,
							2569,
							26678,
							25986,
							25985,
							25987,
							24952,
							25514,
							26718,
							6572,
							8398,
							24580,
							1132,
							2517,
							6592,
							26029,
							26031,
							26032,
							26033,
							26243,
							26715,
							26716,
							3016,
							3142,
							3146,
							3372,
							3376,
							5537,
							5538,
							19241,
							3279,
							3555,
							22661,
							24426,
							3119,
							26291,
							19237,
							26300,
							7545,
							7525,
							7532,
							7524,
							7526,
							7529,
							7528,
							7527,
							24768,
							7544,
							7581,
							23645,
							7604,
							26199,
							26142,
							23372,
							7522,
							26689,
							26690,
							4574,
							4652
						],
						'start': '2025-04-05T22:00:00.000Z',
						'end': '2025-04-19T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '9556668a-c047-49f6-b652-94819bbfc1c8',
							'name': {
								'nl': 'Folder 08- W15-16',
								'fr': 'Depliant S15-16'
							},
							'start': '2025-04-05T22:00:00.000Z',
							'end': '2025-04-19T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 08',
										'fr': 'Dépliant 08'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 08',
										'fr': 'Dépliant 08'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									446,
									26002,
									11,
									10,
									1515,
									1638,
									1074,
									26378,
									311,
									317,
									346,
									26541,
									1301,
									2139,
									25910,
									2167,
									4633,
									4681,
									351,
									574,
									26694,
									568,
									1532,
									21665,
									1579,
									21502,
									21870,
									398,
									30364,
									8066,
									24393,
									8549,
									26264,
									2049,
									25054,
									25055,
									8087,
									8742,
									31697,
									3566,
									19914,
									25033,
									25034,
									24963,
									24965,
									19384,
									24490,
									2569,
									26678,
									25986,
									25985,
									25987,
									24952,
									25514,
									26718,
									6572,
									8398,
									24580,
									1132,
									2517,
									6592,
									26029,
									26031,
									26032,
									26033,
									26243,
									26715,
									26716,
									3016,
									3142,
									3146,
									3372,
									3376,
									5537,
									5538,
									19241,
									3279,
									3555,
									22661,
									24426,
									3119,
									26291,
									19237,
									26300,
									7545,
									7525,
									7532,
									7524,
									7526,
									7529,
									7528,
									7527,
									24768,
									7544,
									7581,
									23645,
									7604,
									26199,
									26142,
									23372,
									7522,
									26689,
									26690,
									4574,
									4652
								]
							},
							'documents': {
								'cover': {
									'weight': '100',
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/9556668a-c047-49f6-b652-94819bbfc1c8/zfjbuynctkqgsomieavw19166.Charles_Folder_08 portal.jpg'
								},
								'copy': {
									'fr': 'Découvrez nos promotions ici',
									'nl': 'Ontdek hier onze folderpromoties'
								},
								'items': [
									{
										'id': 'ba0b04f9-7c08-4267-b5e8-76531fbe89b1',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/9556668a-c047-49f6-b652-94819bbfc1c8/qrpjztsafhioyldwumex34029.Charles_Folder_08.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': 'd5cc6c54-8e1f-4373-8aac-181ec68abcdf',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/9556668a-c047-49f6-b652-94819bbfc1c8/vfzyljwgihsneodtxbcp63141.Charles_Folder_08_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': 'a17e90b9-7c77-4240-aff5-3fd3ffe016f7',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/9556668a-c047-49f6-b652-94819bbfc1c8/lihtvrsopujzmcygdfxb79643.Banners_Folder_08 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/9556668a-c047-49f6-b652-94819bbfc1c8/xkywgtcvbqidaruehjmp52066.Banners_Folder_08_FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': '97af6b98-5f4f-4bba-af77-5c86688b3183',
						'badge': {
							'nl': 'Nieuw in assortiment',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							27181,
							27182,
							27183
						],
						'start': '2025-07-13T22:00:00.000Z',
						'end': '2025-07-24T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '97af6b98-5f4f-4bba-af77-5c86688b3183',
							'name': {
								'nl': 'Poke Bowls',
								'fr': ''
							},
							'start': '2025-07-13T22:00:00.000Z',
							'end': '2025-07-24T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'Nieuw in assortiment'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									27181,
									27182,
									27183
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '97c27bfd-5da5-418c-ac14-b8c2eb33e061',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							21716,
							23816
						],
						'start': '2022-05-08T22:00:00.000Z',
						'end': '2022-05-12T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '97c27bfd-5da5-418c-ac14-b8c2eb33e061',
							'name': {
								'nl': 'BBQ',
								'fr': 'BBQ'
							},
							'start': '2022-05-08T22:00:00.000Z',
							'end': '2022-05-12T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									21716,
									23816
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '9af4faa4-8a93-4379-9536-ebddf51d7dbf',
						'badge': {
							'nl': 'Folder 11',
							'fr': 'Dépliant 11',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 11',
							'fr': 'Dépliant 11'
						},
						'articles': [
							446,
							1615,
							26174,
							1623,
							23656,
							1013,
							26538,
							456,
							1258,
							1269,
							26533,
							23986,
							2111,
							2134,
							2344,
							24844,
							2154,
							2010,
							4634,
							26658,
							26659,
							26660,
							26661,
							26662,
							26663,
							26664,
							26665,
							26666,
							26667,
							26668,
							26669,
							26670,
							26671,
							26321,
							26322,
							26323,
							26324,
							26325,
							26326,
							26376,
							22196,
							25016,
							8380,
							19114,
							25193,
							26239,
							24685,
							24686,
							1097,
							1280,
							1283,
							581,
							132,
							129,
							133,
							8663,
							709,
							2296,
							30915,
							2031,
							2043,
							25062,
							25222,
							2293,
							8555,
							24483,
							2295,
							30916,
							30902,
							30903,
							8550,
							24484,
							24485,
							24486,
							24487,
							25053,
							23102,
							26503,
							25434,
							21783,
							2563,
							2564,
							2583,
							2586,
							2588,
							2589,
							5256,
							6407,
							6411,
							6408,
							26205,
							26206,
							26207,
							26208,
							26209,
							26210,
							1131,
							22137,
							4627,
							1176,
							3142,
							3372,
							3548,
							3511,
							26430,
							25305,
							25287,
							3151,
							3426,
							3531,
							26402,
							26397,
							26398,
							26400,
							93,
							64,
							21382,
							1128,
							1111,
							1118,
							1081,
							1604,
							1591,
							1560,
							1582,
							7527,
							24768,
							7344,
							7554,
							7616,
							7516,
							164,
							161,
							187,
							165,
							26766,
							26767,
							24455,
							169,
							30533,
							163,
							2335,
							2388,
							2389,
							2390,
							2391,
							2394,
							25352,
							26795,
							31539,
							31546,
							32916,
							3896,
							3998,
							19261
						],
						'start': '2025-05-16T22:00:00.000Z',
						'end': '2025-05-31T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '9af4faa4-8a93-4379-9536-ebddf51d7dbf',
							'name': {
								'nl': 'Folder 11 - W21-22',
								'fr': 'Dépliant 11 - S21-22'
							},
							'start': '2025-05-16T22:00:00.000Z',
							'end': '2025-05-31T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 11',
										'fr': 'Dépliant 11'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 11',
										'fr': 'Dépliant 11'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									446,
									1615,
									26174,
									1623,
									23656,
									1013,
									26538,
									456,
									1258,
									1269,
									26533,
									23986,
									2111,
									2134,
									2344,
									24844,
									2154,
									2010,
									4634,
									26658,
									26659,
									26660,
									26661,
									26662,
									26663,
									26664,
									26665,
									26666,
									26667,
									26668,
									26669,
									26670,
									26671,
									26321,
									26322,
									26323,
									26324,
									26325,
									26326,
									26376,
									22196,
									25016,
									8380,
									19114,
									25193,
									26239,
									24685,
									24686,
									1097,
									1280,
									1283,
									581,
									132,
									129,
									133,
									8663,
									709,
									2296,
									30915,
									2031,
									2043,
									25062,
									25222,
									2293,
									8555,
									24483,
									2295,
									30916,
									30902,
									30903,
									8550,
									24484,
									24485,
									24486,
									24487,
									25053,
									23102,
									26503,
									25434,
									21783,
									2563,
									2564,
									2583,
									2586,
									2588,
									2589,
									5256,
									6407,
									6411,
									6408,
									26205,
									26206,
									26207,
									26208,
									26209,
									26210,
									1131,
									22137,
									4627,
									1176,
									3142,
									3372,
									3548,
									3511,
									26430,
									25305,
									25287,
									3151,
									3426,
									3531,
									26402,
									26397,
									26398,
									26400,
									93,
									64,
									21382,
									1128,
									1111,
									1118,
									1081,
									1604,
									1591,
									1560,
									1582,
									7527,
									24768,
									7344,
									7554,
									7616,
									7516,
									164,
									161,
									187,
									165,
									26766,
									26767,
									24455,
									169,
									30533,
									163,
									2335,
									2388,
									2389,
									2390,
									2391,
									2394,
									25352,
									26795,
									31539,
									31546,
									32916,
									3896,
									3998,
									19261
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/9af4faa4-8a93-4379-9536-ebddf51d7dbf/bkvxwmuhjdloaqyfigpr75852.Charles_Folder_11 cover portal.jpg',
									'weight': '100'
								},
								'copy': {
									'fr': 'Découvrez nos promotions ici',
									'nl': 'Ontdek onze folderpromoties hier'
								},
								'items': [
									{
										'id': 'b034fe9f-6618-4462-a920-0448f808c2a5',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/9af4faa4-8a93-4379-9536-ebddf51d7dbf/obkyudhrzlpnxfjcatmw49439.Charles_Folder_11.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': '397e886d-00c6-46a4-aeda-c049b5e0b28c',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/9af4faa4-8a93-4379-9536-ebddf51d7dbf/nzhoviybqatdrjswempk07056.Charles_Folder_11_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': 'a7243d03-9d62-4f98-b157-4c6182628db7',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/9af4faa4-8a93-4379-9536-ebddf51d7dbf/glczfapydoukimhejvws41450.Banners_Folder_11 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/9af4faa4-8a93-4379-9536-ebddf51d7dbf/qtapwkmsdnvgxzbufyej31065.Banners_Folder_11 FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': '9b196efb-94d4-4ae3-984b-f1464bd7c587',
						'badge': {
							'nl': 'Folder 13',
							'fr': 'Dépliant 13',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 13',
							'fr': 'Dépliant 13'
						},
						'articles': [
							26571,
							26572,
							26573,
							26574,
							26575,
							16,
							17,
							5522,
							1519,
							1521,
							24528,
							26519,
							1253,
							26157,
							1311,
							1076,
							24318,
							26537,
							23977,
							2128,
							2175,
							2108,
							4693,
							1674,
							1675,
							1676,
							1677,
							24375,
							24376,
							24377,
							25663,
							7275,
							7276,
							18059,
							1632,
							23123,
							8912,
							84,
							200,
							26694,
							8366,
							1028,
							26435,
							26436,
							26437,
							26438,
							26439,
							26440,
							2081,
							8506,
							18539,
							30877,
							7749,
							26788,
							26789,
							25210,
							25211,
							25212,
							25214,
							25215,
							25216,
							25217,
							25471,
							25472,
							25473,
							19710,
							24490,
							23880,
							25026,
							25027,
							25028,
							26037,
							26038,
							25524,
							26041,
							26042,
							24897,
							8428,
							25546,
							25547,
							25548,
							25549,
							25550,
							4920,
							1155,
							8365,
							1116,
							26899,
							25874,
							26029,
							26031,
							26032,
							26033,
							26243,
							3516,
							26012,
							26011,
							25544,
							26506,
							3251,
							25952,
							26397,
							26398,
							26400,
							1589,
							1630,
							23014,
							111,
							185,
							112,
							566,
							314,
							305,
							106,
							107,
							156,
							157,
							7783,
							19424,
							25291,
							22185,
							24012,
							26894,
							2209,
							5601,
							2161,
							5611,
							2217,
							2227,
							7529,
							7545,
							23647,
							7567,
							26142,
							26199,
							7034,
							23372,
							7510,
							26751,
							26752,
							26753,
							26489,
							26490,
							26491,
							26492,
							26493,
							26494,
							26495,
							26496,
							26497,
							26498,
							26754,
							4636,
							4572,
							8971
						],
						'start': '2025-06-14T22:00:00.000Z',
						'end': '2025-06-28T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '9b196efb-94d4-4ae3-984b-f1464bd7c587',
							'name': {
								'nl': 'Folder 13 - W25-26',
								'fr': 'Dépliant 13 - S25-26'
							},
							'start': '2025-06-14T22:00:00.000Z',
							'end': '2025-06-28T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 13',
										'fr': 'Dépliant 13'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 13',
										'fr': 'Dépliant 13'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									26571,
									26572,
									26573,
									26574,
									26575,
									16,
									17,
									5522,
									1519,
									1521,
									24528,
									26519,
									1253,
									26157,
									1311,
									1076,
									24318,
									26537,
									23977,
									2128,
									2175,
									2108,
									4693,
									1674,
									1675,
									1676,
									1677,
									24375,
									24376,
									24377,
									25663,
									7275,
									7276,
									18059,
									1632,
									23123,
									8912,
									84,
									200,
									26694,
									8366,
									1028,
									26435,
									26436,
									26437,
									26438,
									26439,
									26440,
									2081,
									8506,
									18539,
									30877,
									7749,
									26788,
									26789,
									25210,
									25211,
									25212,
									25214,
									25215,
									25216,
									25217,
									25471,
									25472,
									25473,
									19710,
									24490,
									23880,
									25026,
									25027,
									25028,
									26037,
									26038,
									25524,
									26041,
									26042,
									24897,
									8428,
									25546,
									25547,
									25548,
									25549,
									25550,
									4920,
									1155,
									8365,
									1116,
									26899,
									25874,
									26029,
									26031,
									26032,
									26033,
									26243,
									3516,
									26012,
									26011,
									25544,
									26506,
									3251,
									25952,
									26397,
									26398,
									26400,
									1589,
									1630,
									23014,
									111,
									185,
									112,
									566,
									314,
									305,
									106,
									107,
									156,
									157,
									7783,
									19424,
									25291,
									22185,
									24012,
									26894,
									2209,
									5601,
									2161,
									5611,
									2217,
									2227,
									7529,
									7545,
									23647,
									7567,
									26142,
									26199,
									7034,
									23372,
									7510,
									26751,
									26752,
									26753,
									26489,
									26490,
									26491,
									26492,
									26493,
									26494,
									26495,
									26496,
									26497,
									26498,
									26754,
									4636,
									4572,
									8971
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/rcjxyiztksldohfpqema05196.Charles_Folder_13 cover portal.jpg',
									'weight': '100'
								},
								'copy': {
									'fr': 'Découvrez nos promotions ici',
									'nl': 'Ontdek onze folderpromoties hier'
								},
								'items': [
									{
										'id': '979eec30-298e-47f8-baea-b19cfd35d539',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/jwarhmcungtevzbykids48068.Charles_Folder_13.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': 'e25705e4-a4c9-43b3-a0af-67ef8a680924',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/cflugkjevzpnwxsbqhio83615.Charles_Folder_13_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': 'be570aaf-fe34-4d23-97f0-f7b832bac6bf',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/vmcnpqyrkeguhjawfblo61718.Banners_Folder_13 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/tsfqvxwbocanpgjleyzr61441.Banners_Folder_13 FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								},
								{
									'id': '2a45d297-54fb-404e-802e-6dbc8ec06fbc',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/pgwtdenyociqklrabmfs15914.Banners_Folder_13 snijpalen NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/scnrfijqdglwmubetkop57126.Banners_Folder_13 snijpalen FR.jpg'
									},
									'action': {
										'type': 'none'
									}
								},
								{
									'id': '85fba9bc-7e70-4aa0-901f-98cb58524087',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/dwizrtagcnpluskveyqf68187.Banners_Folder_13 maatjes NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/9b196efb-94d4-4ae3-984b-f1464bd7c587/bxpvqsdufaimwhcleogn29563.Banners_Folder_13 maatjes FR.jpg'
									},
									'action': {
										'type': 'none'
									}
								}
							]
						}
					},
					{
						'id': '9b3b3f3e-c4a1-4544-8f7d-23964ce3c1ba',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24441,
							26095,
							25455
						],
						'start': '2024-05-05T22:00:00.000Z',
						'end': '2024-05-16T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '9b3b3f3e-c4a1-4544-8f7d-23964ce3c1ba',
							'name': {
								'nl': 'Ek campagne',
								'fr': ''
							},
							'start': '2024-05-05T22:00:00.000Z',
							'end': '2024-05-16T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24441,
									26095,
									25455
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '9c4d2134-dfeb-488d-bfd2-27f4eca5a22b',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26431
						],
						'start': '2025-06-15T22:00:00.000Z',
						'end': '2025-06-19T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '9c4d2134-dfeb-488d-bfd2-27f4eca5a22b',
							'name': {
								'nl': 'Biloute Biere',
								'fr': ''
							},
							'start': '2025-06-15T22:00:00.000Z',
							'end': '2025-06-19T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26431
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '9c6f9a36-db38-4cb0-8442-634f26bb0e49',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							4574
						],
						'start': '2024-04-02T22:00:00.000Z',
						'end': '2024-04-13T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '9c6f9a36-db38-4cb0-8442-634f26bb0e49',
							'name': {
								'nl': 'Nasi Goreng ham',
								'fr': ''
							},
							'start': '2024-04-02T22:00:00.000Z',
							'end': '2024-04-13T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4574
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': '9e4b4453-00e7-4f28-aecb-de8fb403f4b5',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							23661,
							24904,
							2123
						],
						'start': '2022-06-07T22:00:00.000Z',
						'end': '2022-06-16T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': '9e4b4453-00e7-4f28-aecb-de8fb403f4b5',
							'name': {
								'nl': 'Zuiderse bacon',
								'fr': ''
							},
							'start': '2022-06-07T22:00:00.000Z',
							'end': '2022-06-16T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									23661,
									24904,
									2123
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'a0c6c362-3681-4e8e-b876-b8aa609c9ac2',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							21809,
							25696,
							25697,
							25698,
							25710,
							25709
						],
						'start': '2024-04-04T22:00:00.000Z',
						'end': '2024-04-12T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'a0c6c362-3681-4e8e-b876-b8aa609c9ac2',
							'name': {
								'nl': 'Overstock diepvries',
								'fr': ''
							},
							'start': '2024-04-04T22:00:00.000Z',
							'end': '2024-04-12T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									21809,
									25696,
									25697,
									25698,
									25710,
									25709
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'a2e94f32-3efa-462f-98b4-dca720aef1f0',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-06-14T22:00:00.000Z',
						'end': '2025-11-29T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'a2e94f32-3efa-462f-98b4-dca720aef1f0',
							'name': {
								'nl': 'De palen van Charles',
								'fr': 'Les piquets de Charles'
							},
							'start': '2025-06-14T22:00:00.000Z',
							'end': '2025-11-29T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/a2e94f32-3efa-462f-98b4-dca720aef1f0/dvckxuglqpmozhtrwjfi89718.Folder cover palen.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'De palen van Charles',
									'fr': 'Les piquets de Charles'
								},
								'items': [
									{
										'id': '20bd3f12-41e7-463b-8c9d-8f2d6b9bc880',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/a2e94f32-3efa-462f-98b4-dca720aef1f0/gveyxjbpnaizhqwscolt02695.Charles_folder_palen_05_2025.pdf'
										},
										'description': {
											'nl': 'Download hier de folder.',
											'fr': 'Télécharger le dépliant ici.'
										}
									}
								]
							}
						}
					},
					{
						'id': 'a38f63e0-8793-4a71-a8cd-12821c7a10bc',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							4710,
							24231,
							24201,
							25261,
							24200
						],
						'start': '2022-09-27T22:00:00.000Z',
						'end': '2022-10-04T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'a38f63e0-8793-4a71-a8cd-12821c7a10bc',
							'name': {
								'nl': 'Wildgerechten',
								'fr': ''
							},
							'start': '2022-09-27T22:00:00.000Z',
							'end': '2022-10-04T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									4710,
									24231,
									24201,
									25261,
									24200
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'a553e3d1-af47-42de-914c-d7b22e1156d1',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-06-13T22:00:00.000Z',
						'end': '2025-06-28T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'a553e3d1-af47-42de-914c-d7b22e1156d1',
							'name': {
								'nl': 'Affiche gratis zonnebril',
								'fr': 'Affiche gratis zonnebril'
							},
							'start': '2025-06-13T22:00:00.000Z',
							'end': '2025-06-28T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'nl': 'https://portal.charles.eu/resources/campaigns/a553e3d1-af47-42de-914c-d7b22e1156d1/bzvqkpmslcnidufejtyo37134.Affiche cover zonnebril.jpg',
									'fr': 'https://portal.charles.eu/resources/campaigns/a553e3d1-af47-42de-914c-d7b22e1156d1/wvgtraxlqbjhfyciuone70866.Affiches cover stoofvlees.jpg',
									'weight': '100',
									'multilingual': true
								},
								'copy': {
									'nl': 'Download hier de affiche en hang ze op in uw zaak.',
									'fr': "Téléchargez l'affiche ici et accrochez-la dans votre entreprise."
								},
								'items': [
									{
										'id': '9aab5d34-308b-4642-af15-3067b6644efc',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/a553e3d1-af47-42de-914c-d7b22e1156d1/cdozpuxjsnlmtfwahgbi05245.Affiche gratis zonnebril NL.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/a553e3d1-af47-42de-914c-d7b22e1156d1/lwktfdbcjsmoxngqvrhz34364.Affiche gratis zonnebril FR.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche en hang ze op in uw zaak',
											'fr': "Téléchargez l'affiche ici et accrochez-la dans votre entreprise."
										}
									}
								]
							}
						}
					},
					{
						'id': 'a63fff35-c1e0-4f7a-a6fd-6348ae0f5541',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							25373
						],
						'start': '2022-11-29T23:00:00.000Z',
						'end': '2022-12-06T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'a63fff35-c1e0-4f7a-a6fd-6348ae0f5541',
							'name': {
								'nl': 'Foie gras',
								'fr': 'Foie gras'
							},
							'start': '2022-11-29T23:00:00.000Z',
							'end': '2022-12-06T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25373
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'a669fc5a-82d5-4eec-8318-fc733bc54c8b',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							19710,
							23986
						],
						'start': '2023-06-21T22:00:00.000Z',
						'end': '2023-06-29T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'a669fc5a-82d5-4eec-8318-fc733bc54c8b',
							'name': {
								'nl': 'Maatjes',
								'fr': ''
							},
							'start': '2023-06-21T22:00:00.000Z',
							'end': '2023-06-29T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									19710,
									23986
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'a6797714-569f-4ac6-85f2-7abbcf679855',
						'badge': {
							'nl': 'Nu vast op stock',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25025,
							25026,
							25027,
							25030,
							25031,
							25035,
							25036
						],
						'start': '2023-10-29T23:00:00.000Z',
						'end': '2023-11-04T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'a6797714-569f-4ac6-85f2-7abbcf679855',
							'name': {
								'nl': 'Pietercil',
								'fr': ''
							},
							'start': '2023-10-29T23:00:00.000Z',
							'end': '2023-11-04T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'Nu vast op stock'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25025,
									25026,
									25027,
									25030,
									25031,
									25035,
									25036
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'a96c4eac-d22b-4c0a-9baa-e0fa4eee08bf',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							49,
							1258,
							2128,
							4790
						],
						'start': '2022-10-13T22:00:00.000Z',
						'end': '2022-10-20T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'a96c4eac-d22b-4c0a-9baa-e0fa4eee08bf',
							'name': {
								'nl': 'Extra promo week 42',
								'fr': ''
							},
							'start': '2022-10-13T22:00:00.000Z',
							'end': '2022-10-20T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									49,
									1258,
									2128,
									4790
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'aa5caa3f-9e24-42c5-a63a-19ef4621d7ad',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'start': '2023-10-08T22:00:00.000Z',
						'end': '2023-10-19T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'aa5caa3f-9e24-42c5-a63a-19ef4621d7ad',
							'name': {
								'nl': 'Halloweenpate',
								'fr': ''
							},
							'start': '2023-10-08T22:00:00.000Z',
							'end': '2023-10-19T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								}
							},
							'inThePicture': true
						}
					},
					{
						'id': 'ac882cf5-b1cb-4ee5-98c8-7bc97ba2e257',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							24704,
							24703,
							1371,
							23985
						],
						'start': '2022-11-13T23:00:00.000Z',
						'end': '2022-11-17T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'ac882cf5-b1cb-4ee5-98c8-7bc97ba2e257',
							'name': {
								'nl': 'Kerst en feestsalade',
								'fr': ''
							},
							'start': '2022-11-13T23:00:00.000Z',
							'end': '2022-11-17T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24704,
									24703,
									1371,
									23985
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'ad736c0a-c95f-43c5-8601-0d6012e7921d',
						'badge': {
							'nl': 'Super Deals',
							'fr': 'Super Deals',
							'color': {
								'text': '#ffffff',
								'bg': '#C1222F'
							}
						},
						'filter': {
							'nl': 'Super Deals',
							'fr': 'Super Deals'
						},
						'articles': [
							1311,
							1332,
							723,
							728,
							1519,
							1521,
							24528,
							26239,
							1502,
							1538,
							1550,
							1253,
							1257,
							1267,
							24527,
							26157,
							1029,
							1030,
							25429,
							26158,
							1028,
							1174,
							464,
							14,
							15,
							44,
							5522,
							120,
							1013,
							26538,
							23697,
							1130,
							24919,
							2010,
							2154,
							24899,
							2051,
							19384,
							24490,
							4724,
							4739,
							4776,
							4630,
							4693,
							4646,
							1098,
							1131,
							3161,
							26012,
							3508,
							3118,
							1513,
							1517,
							1567,
							1570,
							8405,
							450,
							459,
							7458,
							4408,
							4409,
							4541,
							7544,
							1380,
							1458,
							1471,
							26539,
							1514,
							1610,
							1615,
							26174,
							26549,
							1258,
							1269,
							26533,
							1027,
							1194,
							8444,
							376,
							1,
							3,
							18,
							19,
							26543,
							26544,
							24318,
							26537,
							1093,
							26282,
							1057,
							2132,
							2140,
							2174,
							2175,
							2343,
							8452,
							2069,
							2163,
							4524,
							4707,
							7564,
							2342,
							1090,
							1133,
							25458,
							25459,
							3044,
							3107,
							3121,
							3123,
							3124,
							3126,
							21901,
							26226,
							3479,
							403,
							421,
							1464,
							1496,
							23552,
							387,
							84,
							21493,
							1127,
							7763
						],
						'start': '2025-02-20T23:00:00.000Z',
						'end': '2025-03-08T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'ad736c0a-c95f-43c5-8601-0d6012e7921d',
							'name': {
								'nl': 'Super Deals',
								'fr': 'Super Deals'
							},
							'start': '2025-02-20T23:00:00.000Z',
							'end': '2025-03-08T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Super Deals',
										'fr': 'Super Deals'
									}
								},
								'badge': {
									'text': {
										'nl': 'Super Deals',
										'fr': 'Super Deals'
									},
									'color': {
										'text': '#ffffff',
										'background': '#C1222F'
									}
								},
								'ids': [
									1311,
									1332,
									723,
									728,
									1519,
									1521,
									24528,
									26239,
									1502,
									1538,
									1550,
									1253,
									1257,
									1267,
									24527,
									26157,
									1029,
									1030,
									25429,
									26158,
									1028,
									1174,
									464,
									14,
									15,
									44,
									5522,
									120,
									1013,
									26538,
									23697,
									1130,
									24919,
									2010,
									2154,
									24899,
									2051,
									19384,
									24490,
									4724,
									4739,
									4776,
									4630,
									4693,
									4646,
									1098,
									1131,
									3161,
									26012,
									3508,
									3118,
									1513,
									1517,
									1567,
									1570,
									8405,
									450,
									459,
									7458,
									4408,
									4409,
									4541,
									7544,
									1380,
									1458,
									1471,
									26539,
									1514,
									1610,
									1615,
									26174,
									26549,
									1258,
									1269,
									26533,
									1027,
									1194,
									8444,
									376,
									1,
									3,
									18,
									19,
									26543,
									26544,
									24318,
									26537,
									1093,
									26282,
									1057,
									2132,
									2140,
									2174,
									2175,
									2343,
									8452,
									2069,
									2163,
									4524,
									4707,
									7564,
									2342,
									1090,
									1133,
									25458,
									25459,
									3044,
									3107,
									3121,
									3123,
									3124,
									3126,
									21901,
									26226,
									3479,
									403,
									421,
									1464,
									1496,
									23552,
									387,
									84,
									21493,
									1127,
									7763
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/ad736c0a-c95f-43c5-8601-0d6012e7921d/ozywfpclxnibkavtmqud55446.Charles_SuperDeals_A4 portal.jpg',
									'weight': '100'
								},
								'copy': {
									'fr': 'Découvrez nos promotions ici',
									'nl': 'Ontdek onze folderpromoties hier'
								},
								'items': [
									{
										'id': '9a7a2762-0975-4324-ab1f-e1cbedd7bf48',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/ad736c0a-c95f-43c5-8601-0d6012e7921d/rpfavyohndcijqxzuwsk89836.Charles_SuperDeals_A4.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/ad736c0a-c95f-43c5-8601-0d6012e7921d/hkjfdlcyugqxvsepwbzm81879.Charles_SuperDeals_A4_W43-45_FR.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									}
								]
							},
							'banners': [
								{
									'id': 'aaaf8662-f2fc-474b-a41a-c15ac7b438a9',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/ad736c0a-c95f-43c5-8601-0d6012e7921d/lotcihmxrbfpujwegvas43972.Banners_SuperDeals NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/ad736c0a-c95f-43c5-8601-0d6012e7921d/evcihfxmzokwuyqbgnda61636.Banners_SuperDeals FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': 'ae0da17e-e78b-4832-adf9-cbad53fe1f33',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'start': '2024-12-08T23:00:00.000Z',
						'end': '2024-12-12T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'ae0da17e-e78b-4832-adf9-cbad53fe1f33',
							'name': {
								'nl': 'Fleur De Charles',
								'fr': ''
							},
							'start': '2024-12-08T23:00:00.000Z',
							'end': '2024-12-12T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								}
							},
							'inThePicture': true
						}
					},
					{
						'id': 'ae7894ef-393c-4ab9-af03-c168b928708b',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							1370
						],
						'start': '2024-12-29T23:00:00.000Z',
						'end': '2025-01-11T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'ae7894ef-393c-4ab9-af03-c168b928708b',
							'name': {
								'nl': 'EJ paté',
								'fr': ''
							},
							'start': '2024-12-29T23:00:00.000Z',
							'end': '2025-01-11T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									1370
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'af0a27b0-d2b3-47d7-bc28-10da864aeeb7',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24346
						],
						'start': '2025-05-21T22:00:00.000Z',
						'end': '2025-05-28T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'af0a27b0-d2b3-47d7-bc28-10da864aeeb7',
							'name': {
								'nl': 'Aanmaakblokjes',
								'fr': ''
							},
							'start': '2025-05-21T22:00:00.000Z',
							'end': '2025-05-28T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24346
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'afa1474d-388b-43a0-a8d0-83750ca3d06d',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							24258
						],
						'start': '2022-07-10T22:00:00.000Z',
						'end': '2022-07-14T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'afa1474d-388b-43a0-a8d0-83750ca3d06d',
							'name': {
								'nl': 'Overstock EP week 28',
								'fr': ''
							},
							'start': '2022-07-10T22:00:00.000Z',
							'end': '2022-07-14T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24258
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b075e983-d91b-493a-b851-bb1135cd3e50',
						'badge': {
							'nl': 'Ideaal bij het warm weer',
							'fr': 'Idéal par beau temps',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							21774,
							33146
						],
						'start': '2022-06-17T22:00:00.000Z',
						'end': '2022-06-23T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b075e983-d91b-493a-b851-bb1135cd3e50',
							'name': {
								'nl': 'Sangria',
								'fr': 'Sangria'
							},
							'start': '2022-06-17T22:00:00.000Z',
							'end': '2022-06-23T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'Idéal par beau temps',
										'nl': 'Ideaal bij het warm weer'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									21774,
									33146
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b09cf167-56fa-4f09-b685-b483fb96dbd5',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2230,
							24629,
							1980,
							2164,
							23476,
							24628
						],
						'start': '2023-10-22T22:00:00.000Z',
						'end': '2023-10-26T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b09cf167-56fa-4f09-b685-b483fb96dbd5',
							'name': {
								'nl': 'Vitello Tonato',
								'fr': ''
							},
							'start': '2023-10-22T22:00:00.000Z',
							'end': '2023-10-26T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2230,
									24629,
									1980,
									2164,
									23476,
									24628
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b0f84035-800e-4937-b183-0a2bfd4970c4',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24812
						],
						'start': '2024-01-23T23:00:00.000Z',
						'end': '2024-02-01T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b0f84035-800e-4937-b183-0a2bfd4970c4',
							'name': {
								'nl': 'Valentijnsalade ',
								'fr': ''
							},
							'start': '2024-01-23T23:00:00.000Z',
							'end': '2024-02-01T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24812
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b1f6c3db-6dcd-47a8-bf17-41b2a2042e65',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24105,
							24106,
							24107,
							24164
						],
						'start': '2023-12-17T23:00:00.000Z',
						'end': '2023-12-21T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b1f6c3db-6dcd-47a8-bf17-41b2a2042e65',
							'name': {
								'nl': 'Wildpatés VVP',
								'fr': ''
							},
							'start': '2023-12-17T23:00:00.000Z',
							'end': '2023-12-21T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24105,
									24106,
									24107,
									24164
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b30546f7-71f3-4474-89c7-c1d28a51fa95',
						'badge': {
							'nl': 'Terug beschi',
							'fr': 'Retour en assortiment',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							129,
							130
						],
						'start': '2025-01-07T23:00:00.000Z',
						'end': '2025-01-16T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b30546f7-71f3-4474-89c7-c1d28a51fa95',
							'name': {
								'nl': 'Viva Italia',
								'fr': ''
							},
							'start': '2025-01-07T23:00:00.000Z',
							'end': '2025-01-16T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'Retour en assortiment',
										'nl': 'Terug beschi'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									129,
									130
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b39d3813-519d-4b0f-9b89-86ab51ba4d4b',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2151
						],
						'start': '2023-07-30T22:00:00.000Z',
						'end': '2023-08-03T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b39d3813-519d-4b0f-9b89-86ab51ba4d4b',
							'name': {
								'nl': '',
								'fr': ''
							},
							'start': '2023-07-30T22:00:00.000Z',
							'end': '2023-08-03T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2151
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b77116ce-ef0d-4e47-b55e-caebd6ac23de',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							3196,
							1287
						],
						'start': '2024-02-22T23:00:00.000Z',
						'end': '2024-03-07T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b77116ce-ef0d-4e47-b55e-caebd6ac23de',
							'name': {
								'nl': 'La brique de brie',
								'fr': ''
							},
							'start': '2024-02-22T23:00:00.000Z',
							'end': '2024-03-07T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									3196,
									1287
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b77f7606-fda3-417e-82b5-b44adaeda229',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							413,
							2125,
							23980,
							18,
							1513
						],
						'start': '2022-11-10T23:00:00.000Z',
						'end': '2022-11-17T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b77f7606-fda3-417e-82b5-b44adaeda229',
							'name': {
								'nl': 'Extra promo week 46',
								'fr': ''
							},
							'start': '2022-11-10T23:00:00.000Z',
							'end': '2022-11-17T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									413,
									2125,
									23980,
									18,
									1513
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'b7f8eaa7-0afa-4311-abb9-e5b76a793760',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-06-15T22:00:00.000Z',
						'end': '2025-08-30T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'b7f8eaa7-0afa-4311-abb9-e5b76a793760',
							'name': {
								'nl': 'Charles nieuwigheden',
								'fr': 'Charles nouveautés'
							},
							'start': '2025-06-15T22:00:00.000Z',
							'end': '2025-08-30T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/b7f8eaa7-0afa-4311-abb9-e5b76a793760/pvwbmuhadkrznxyioteg71412.Boekje nieuwigheden cover portal.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'Nieuw in het Charles assortiment',
									'fr': 'Nouveau dans la gamme Charles'
								},
								'items': [
									{
										'id': 'c76ca00f-d220-49ce-ab9e-679c571a9441',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/b7f8eaa7-0afa-4311-abb9-e5b76a793760/myctsfoblxqeuijpzdag02858.Boekje nieuwigheden.pdf'
										},
										'description': {
											'nl': 'Nieuw in het Charles assortiment',
											'fr': 'Nouveau dans la gamme Charles'
										}
									}
								]
							}
						}
					},
					{
						'id': 'bbb84896-c480-4d51-b1bb-a3c2c84c50ad',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							25872,
							25915
						],
						'start': '2024-02-15T23:00:00.000Z',
						'end': '2024-02-19T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'bbb84896-c480-4d51-b1bb-a3c2c84c50ad',
							'name': {
								'nl': 'Nieuwe dagschotels ',
								'fr': ''
							},
							'start': '2024-02-15T23:00:00.000Z',
							'end': '2024-02-19T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25872,
									25915
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'bfb698b5-d8d2-40c8-858d-012a47aad3c5',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							25016,
							24358
						],
						'start': '2022-06-02T22:00:00.000Z',
						'end': '2022-06-09T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'bfb698b5-d8d2-40c8-858d-012a47aad3c5',
							'name': {
								'nl': 'Salgiano en Braaiworst',
								'fr': ''
							},
							'start': '2022-06-02T22:00:00.000Z',
							'end': '2022-06-09T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25016,
									24358
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'c02e9b24-341f-4df1-8b18-fe68d99b2b14',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							8575,
							2164,
							2230,
							4522,
							2151
						],
						'start': '2022-10-19T22:00:00.000Z',
						'end': '2022-10-20T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'c02e9b24-341f-4df1-8b18-fe68d99b2b14',
							'name': {
								'nl': 'Overstock week 42',
								'fr': ''
							},
							'start': '2022-10-19T22:00:00.000Z',
							'end': '2022-10-20T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									8575,
									2164,
									2230,
									4522,
									2151
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'c1d43148-bb8e-47f8-8cd0-86dfd2f81cba',
						'badge': {
							'nl': 'Terug beschikbaar',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24105,
							24106,
							24107,
							24164
						],
						'start': '2023-09-17T22:00:00.000Z',
						'end': '2023-09-21T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'c1d43148-bb8e-47f8-8cd0-86dfd2f81cba',
							'name': {
								'nl': 'Wildpaté',
								'fr': ''
							},
							'start': '2023-09-17T22:00:00.000Z',
							'end': '2023-09-21T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'Terug beschikbaar'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24105,
									24106,
									24107,
									24164
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'c2a68929-118a-45da-9482-be241588a64a',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							23982
						],
						'start': '2022-10-26T22:00:00.000Z',
						'end': '2022-11-03T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'c2a68929-118a-45da-9482-be241588a64a',
							'name': {
								'nl': 'Charlesberry overstock',
								'fr': ''
							},
							'start': '2022-10-26T22:00:00.000Z',
							'end': '2022-11-03T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									23982
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'c366c233-c62e-4440-8112-9d791c984f0e',
						'badge': {
							'nl': 'Terug beschikbaar',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							23917
						],
						'start': '2024-11-18T23:00:00.000Z',
						'end': '2024-11-28T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'c366c233-c62e-4440-8112-9d791c984f0e',
							'name': {
								'nl': 'Jungle burgers',
								'fr': ''
							},
							'start': '2024-11-18T23:00:00.000Z',
							'end': '2024-11-28T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'Terug beschikbaar'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									23917
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'c38c804e-f624-40ac-8a7c-8f05c6835afc',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26002
						],
						'start': '2024-10-22T22:00:00.000Z',
						'end': '2024-10-31T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'c38c804e-f624-40ac-8a7c-8f05c6835afc',
							'name': {
								'nl': 'Varkensgrillworsten',
								'fr': ''
							},
							'start': '2024-10-22T22:00:00.000Z',
							'end': '2024-10-31T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26002
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'c44f4457-a005-4078-9223-eb7475cb199a',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							24582
						],
						'start': '2024-10-20T22:00:00.000Z',
						'end': '2024-10-24T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'c44f4457-a005-4078-9223-eb7475cb199a',
							'name': {
								'nl': 'Balletjes in tomaat 6x150gr',
								'fr': ''
							},
							'start': '2024-10-20T22:00:00.000Z',
							'end': '2024-10-24T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									24582
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'c521e349-a612-4c20-bbe1-3ddf110dec99',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': [],
						'articles': [
							25016,
							10
						],
						'start': '2022-06-23T22:00:00.000Z',
						'end': '2022-06-30T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'c521e349-a612-4c20-bbe1-3ddf110dec99',
							'name': {
								'nl': 'Salgiano en Zuiderse bacon',
								'fr': 'Salgiano en Gebakken natuurham'
							},
							'start': '2022-06-23T22:00:00.000Z',
							'end': '2022-06-30T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									25016,
									10
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'cd8a013f-9690-4949-8ee6-011809ab40b3',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26429
						],
						'start': '2025-04-13T22:00:00.000Z',
						'end': '2025-04-17T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'cd8a013f-9690-4949-8ee6-011809ab40b3',
							'name': {
								'nl': 'Mosterdspek VVP',
								'fr': ''
							},
							'start': '2025-04-13T22:00:00.000Z',
							'end': '2025-04-17T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26429
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'cdf22561-d167-46e7-95af-c9b6f82a7791',
						'badge': {
							'nl': 'Overstock',
							'fr': 'Overstock',
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26587,
							26588
						],
						'start': '2025-05-25T22:00:00.000Z',
						'end': '2025-06-01T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'cdf22561-d167-46e7-95af-c9b6f82a7791',
							'name': {
								'nl': 'Paté',
								'fr': ''
							},
							'start': '2025-05-25T22:00:00.000Z',
							'end': '2025-06-01T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': 'Overstock',
										'nl': 'Overstock'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26587,
									26588
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'cec6e12d-1a8c-4cb0-a002-a480f6aca260',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26002
						],
						'start': '2024-06-30T22:00:00.000Z',
						'end': '2024-07-13T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'cec6e12d-1a8c-4cb0-a002-a480f6aca260',
							'name': {
								'nl': 'in de kijker',
								'fr': ''
							},
							'start': '2024-06-30T22:00:00.000Z',
							'end': '2024-07-13T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26002
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'd32eba12-2926-44b1-9ecc-131365126711',
						'badge': {
							'nl': 'Folder 14',
							'fr': 'Dépliant 14',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 14',
							'fr': 'Dépliant 14'
						},
						'articles': [
							18,
							19,
							20,
							26544,
							26574,
							22377,
							1610,
							26549,
							26587,
							1457,
							1327,
							401,
							402,
							422,
							403,
							421,
							456,
							26871,
							26157,
							1253,
							385,
							413,
							26154,
							26851,
							2154,
							2010,
							25193,
							26239,
							21487,
							21665,
							368,
							1202,
							1028,
							1334,
							355,
							1089,
							23899,
							7007,
							21382,
							24692,
							182,
							185,
							8035,
							26108,
							2294,
							2064,
							2065,
							27060,
							27061,
							27062,
							27063,
							27064,
							26877,
							2072,
							25291,
							7783,
							24897,
							8675,
							8905,
							21897,
							23392,
							26523,
							8386,
							26755,
							2563,
							2564,
							2583,
							26254,
							4627,
							1135,
							2501,
							22660,
							22659,
							3103,
							3247,
							26400,
							26316,
							26317,
							3016,
							3142,
							3146,
							3372,
							3376,
							19241,
							26894,
							26526,
							24252,
							2133,
							26524,
							2102,
							22185,
							24012,
							22559,
							25493,
							23817,
							25062,
							7458,
							23196,
							24393,
							24018,
							19473,
							25422,
							7116,
							6634,
							2674,
							7524,
							7527,
							25492,
							7624,
							25491,
							7034,
							23647,
							23372,
							7520,
							4574,
							4636,
							26489,
							26490,
							26491,
							26492,
							26493,
							26494,
							26495,
							26496,
							26497,
							26498
						],
						'start': '2025-08-10T22:00:00.000Z',
						'end': '2025-08-22T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'd32eba12-2926-44b1-9ecc-131365126711',
							'name': {
								'nl': 'Folder 14 - W33-34',
								'fr': 'Dépliant 14 - S33-34'
							},
							'start': '2025-08-10T22:00:00.000Z',
							'end': '2025-08-22T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 14',
										'fr': 'Dépliant 14'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 14',
										'fr': 'Dépliant 14'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									18,
									19,
									20,
									26544,
									26574,
									22377,
									1610,
									26549,
									26587,
									1457,
									1327,
									401,
									402,
									422,
									403,
									421,
									456,
									26871,
									26157,
									1253,
									385,
									413,
									26154,
									26851,
									2154,
									2010,
									25193,
									26239,
									21487,
									21665,
									368,
									1202,
									1028,
									1334,
									355,
									1089,
									23899,
									7007,
									21382,
									24692,
									182,
									185,
									8035,
									26108,
									2294,
									2064,
									2065,
									27060,
									27061,
									27062,
									27063,
									27064,
									26877,
									2072,
									25291,
									7783,
									24897,
									8675,
									8905,
									21897,
									23392,
									26523,
									8386,
									26755,
									2563,
									2564,
									2583,
									26254,
									4627,
									1135,
									2501,
									22660,
									22659,
									3103,
									3247,
									26400,
									26316,
									26317,
									3016,
									3142,
									3146,
									3372,
									3376,
									19241,
									26894,
									26526,
									24252,
									2133,
									26524,
									2102,
									22185,
									24012,
									22559,
									25493,
									23817,
									25062,
									7458,
									23196,
									24393,
									24018,
									19473,
									25422,
									7116,
									6634,
									2674,
									7524,
									7527,
									25492,
									7624,
									25491,
									7034,
									23647,
									23372,
									7520,
									4574,
									4636,
									26489,
									26490,
									26491,
									26492,
									26493,
									26494,
									26495,
									26496,
									26497,
									26498
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/d32eba12-2926-44b1-9ecc-131365126711/vbjgczuosfwqiktrdnax61558.Charles_Folder_14 portal.jpg',
									'weight': '100'
								},
								'copy': {
									'fr': 'Découvrez nos promotions ici',
									'nl': 'Ontdek onze folderpromoties hier'
								},
								'items': [
									{
										'id': 'c405e517-0c09-4d4f-b178-9fa3b9f279e5',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/d32eba12-2926-44b1-9ecc-131365126711/nousxgcklejvyptrzdim00597.Charles_Folder_14.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/d32eba12-2926-44b1-9ecc-131365126711/rfclykmjhbsdwutxgzpa24470.Banners_Folder_14 FR.jpg'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': 'f2d44d4c-15a0-432f-b350-5a953ca5b48a',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/d32eba12-2926-44b1-9ecc-131365126711/vsumgtfnphacrdqylezx23069.Charles_Folder_14_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': '78f1370a-708f-4146-8482-6e70f6ee9cb4',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/d32eba12-2926-44b1-9ecc-131365126711/luehfridwcxogvjnzpms13628.Banners_Folder_14 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/d32eba12-2926-44b1-9ecc-131365126711/vfodczrbanmqtsypuwix01787.Banners_Folder_14 FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': 'd58734c4-0643-4107-a8a4-6860693696f3',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2032
						],
						'start': '2025-08-19T22:00:00.000Z',
						'end': '2025-09-04T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'd58734c4-0643-4107-a8a4-6860693696f3',
							'name': {
								'nl': 'Pastasala mediteraans',
								'fr': ''
							},
							'start': '2025-08-19T22:00:00.000Z',
							'end': '2025-09-04T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2032
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'd7283988-ec05-4745-ba7a-d4a995c5d2cb',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							19710
						],
						'start': '2025-06-16T22:00:00.000Z',
						'end': '2025-06-26T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'd7283988-ec05-4745-ba7a-d4a995c5d2cb',
							'name': {
								'nl': 'Maatjes',
								'fr': ''
							},
							'start': '2025-06-16T22:00:00.000Z',
							'end': '2025-06-26T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									19710
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'dcdeccde-ac1c-4618-8242-87495c0446a8',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							23981,
							2164
						],
						'start': '2024-11-03T23:00:00.000Z',
						'end': '2024-11-14T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'dcdeccde-ac1c-4618-8242-87495c0446a8',
							'name': {
								'nl': 'Feestpate',
								'fr': ''
							},
							'start': '2024-11-03T23:00:00.000Z',
							'end': '2024-11-14T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									23981,
									2164
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'dea6fe83-0d1d-4c13-84a4-503be8665cef',
						'badge': {
							'color': {}
						},
						'filter': {
							'nl': 'Folder 09',
							'fr': 'Dépliant 09'
						},
						'articles': [
							1080,
							1075,
							26328,
							1259,
							26534,
							1637,
							1611,
							42,
							49,
							23472,
							2192,
							2142,
							2123,
							1959,
							1961,
							1962,
							1963,
							1964,
							1965,
							1966,
							1967,
							1968,
							1969,
							1971,
							1972,
							1974,
							1975,
							1976,
							1977,
							1979,
							1982,
							23473,
							23475,
							24195,
							24845,
							24900,
							25868,
							25911,
							24245,
							4521,
							6570,
							8018,
							19944,
							23899,
							1174,
							24915,
							368,
							21716,
							22367,
							19603,
							19604,
							2233,
							25500,
							2078,
							2079,
							2080,
							2082,
							18399,
							2032,
							2033,
							26681,
							26682,
							26683,
							26684,
							26685,
							26686,
							26687,
							26688,
							26707,
							26691,
							26692,
							26693,
							21802,
							25894,
							31734,
							31735,
							31736,
							31738,
							8386,
							26755,
							6412,
							1135,
							4625,
							6305,
							25596,
							23783,
							26770,
							26779,
							26701,
							26006,
							26700,
							25284,
							25285,
							3103,
							26408,
							3532,
							6537,
							7375,
							6536,
							24790,
							24791,
							19976,
							19977,
							19979,
							24173,
							24451,
							19981,
							19978,
							24725,
							24789,
							387,
							26080,
							25888,
							24692,
							7007,
							1124,
							7524,
							7526,
							22078,
							23367,
							7607,
							7520,
							8583,
							3895,
							3894,
							3996,
							3893,
							32915,
							22257,
							26721,
							26722,
							26723,
							26724,
							26725,
							26726,
							26727,
							26728,
							26729,
							26730,
							26731,
							26732,
							26733,
							26734,
							26735,
							26736,
							26737,
							26738,
							26739,
							26740,
							26741,
							26742,
							26743,
							26744
						],
						'start': '2025-04-19T22:00:00.000Z',
						'end': '2025-05-03T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'dea6fe83-0d1d-4c13-84a4-503be8665cef',
							'name': {
								'nl': 'Folder 09 - W17-18',
								'fr': 'Dépliant 09 - S17-18'
							},
							'start': '2025-04-19T22:00:00.000Z',
							'end': '2025-05-03T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 09',
										'fr': 'Dépliant 09'
									}
								},
								'ids': [
									1080,
									1075,
									26328,
									1259,
									26534,
									1637,
									1611,
									42,
									49,
									23472,
									2192,
									2142,
									2123,
									1959,
									1961,
									1962,
									1963,
									1964,
									1965,
									1966,
									1967,
									1968,
									1969,
									1971,
									1972,
									1974,
									1975,
									1976,
									1977,
									1979,
									1982,
									23473,
									23475,
									24195,
									24845,
									24900,
									25868,
									25911,
									24245,
									4521,
									6570,
									8018,
									19944,
									23899,
									1174,
									24915,
									368,
									21716,
									22367,
									19603,
									19604,
									2233,
									25500,
									2078,
									2079,
									2080,
									2082,
									18399,
									2032,
									2033,
									26681,
									26682,
									26683,
									26684,
									26685,
									26686,
									26687,
									26688,
									26707,
									26691,
									26692,
									26693,
									21802,
									25894,
									31734,
									31735,
									31736,
									31738,
									8386,
									26755,
									6412,
									1135,
									4625,
									6305,
									25596,
									23783,
									26770,
									26779,
									26701,
									26006,
									26700,
									25284,
									25285,
									3103,
									26408,
									3532,
									6537,
									7375,
									6536,
									24790,
									24791,
									19976,
									19977,
									19979,
									24173,
									24451,
									19981,
									19978,
									24725,
									24789,
									387,
									26080,
									25888,
									24692,
									7007,
									1124,
									7524,
									7526,
									22078,
									23367,
									7607,
									7520,
									8583,
									3895,
									3894,
									3996,
									3893,
									32915,
									22257,
									26721,
									26722,
									26723,
									26724,
									26725,
									26726,
									26727,
									26728,
									26729,
									26730,
									26731,
									26732,
									26733,
									26734,
									26735,
									26736,
									26737,
									26738,
									26739,
									26740,
									26741,
									26742,
									26743,
									26744
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/dea6fe83-0d1d-4c13-84a4-503be8665cef/vrkgusndepazmoqbtwjf84438.Charles_Folder_09 cover.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'Ontdek onze folderpromoties hier',
									'fr': 'Découvrez nos promotions ici'
								},
								'items': [
									{
										'id': 'd78d834a-fa4d-4e56-9e97-bd2034ebecf2',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/dea6fe83-0d1d-4c13-84a4-503be8665cef/zsafgqylixpvmenjtowb39911.Charles_Folder_09.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken ',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': '5d6d0ff2-ff8f-4b28-8c22-80fe52b39c29',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/dea6fe83-0d1d-4c13-84a4-503be8665cef/nikumpgreqjfvycxsaoh06880.Charles_Folder_09_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': '664dfa33-569a-4532-afd9-f1d2567895e1',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/dea6fe83-0d1d-4c13-84a4-503be8665cef/vsqkapyxnoduhmriwjgt71530.Banners_Folder_09 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/dea6fe83-0d1d-4c13-84a4-503be8665cef/vzpetlmfrgbqhxdcwoan21945.Banners_Folder_09 FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': 'e2445490-3415-4e7d-ac34-bcef1b718b57',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2123,
							25456
						],
						'start': '2024-04-24T22:00:00.000Z',
						'end': '2024-05-02T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'e2445490-3415-4e7d-ac34-bcef1b718b57',
							'name': {
								'nl': 'Asperge ham salade',
								'fr': ''
							},
							'start': '2024-04-24T22:00:00.000Z',
							'end': '2024-05-02T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2123,
									25456
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'e4fabdfd-e9c7-44f2-ae01-9848b42b05f7',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							23986
						],
						'start': '2025-03-25T23:00:00.000Z',
						'end': '2025-04-03T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'e4fabdfd-e9c7-44f2-ae01-9848b42b05f7',
							'name': {
								'nl': 'Limoncello pate',
								'fr': ''
							},
							'start': '2025-03-25T23:00:00.000Z',
							'end': '2025-04-03T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									23986
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'e7c6b000-b8fb-4a8e-a8de-8cec6a66ea81',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							2122,
							1324
						],
						'start': '2025-03-02T23:00:00.000Z',
						'end': '2025-03-07T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'e7c6b000-b8fb-4a8e-a8de-8cec6a66ea81',
							'name': {
								'nl': 'Paas artikelen',
								'fr': ''
							},
							'start': '2025-03-02T23:00:00.000Z',
							'end': '2025-03-07T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									2122,
									1324
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'ea0048f7-623e-41ef-9b3a-99caa9120f43',
						'badge': {
							'nl': 'SPAANSE WEKEN',
							'fr': 'SEMAINES ESPAGNOLES',
							'color': {
								'text': '#ff0000',
								'bg': '#fde918'
							}
						},
						'filter': {
							'nl': 'SPAANSE WEKEN',
							'fr': 'SEMAINES ESPAGNOLES'
						},
						'articles': [
							183,
							25074,
							184,
							8738,
							1666,
							1667,
							22336,
							22943,
							25494
						],
						'start': '2023-06-02T22:00:00.000Z',
						'end': '2023-06-15T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'ea0048f7-623e-41ef-9b3a-99caa9120f43',
							'name': {
								'nl': 'Spaanse Weken bij Charles - W23-24',
								'fr': 'Semaines espagnoles à Charles - S 23-24'
							},
							'start': '2023-06-02T22:00:00.000Z',
							'end': '2023-06-15T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'SPAANSE WEKEN',
										'fr': 'SEMAINES ESPAGNOLES'
									}
								},
								'badge': {
									'text': {
										'nl': 'SPAANSE WEKEN',
										'fr': 'SEMAINES ESPAGNOLES'
									},
									'color': {
										'text': '#ff0000',
										'background': '#fde918'
									}
								},
								'ids': [
									183,
									25074,
									184,
									8738,
									1666,
									1667,
									22336,
									22943,
									25494
								]
							},
							'documents': {
								'cover': {
									'multilingual': false,
									'nl': 'https://portal.charles.eu/resources/campaigns/ea0048f7-623e-41ef-9b3a-99caa9120f43/hfykvuacoxtqngrpdlwz25718.Spaanse weken portal.jpg',
									'weight': '100'
								},
								'copy': {
									'nl': 'ACTIE: Karton cava gratis bij aankoop van deze deelnemende producten',
									'fr': "ACTION : Carton de cava offert à l'achat de ces produits participants"
								},
								'items': [
									{
										'id': 'c677e0c0-84d3-4035-99b1-246e1428bfaf',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/ea0048f7-623e-41ef-9b3a-99caa9120f43/ipcnbjwfzekxathqmgdv02335.Charles_Folder_12_spaanse_weken.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/ea0048f7-623e-41ef-9b3a-99caa9120f43/yxojzrudtlnfvkqegcib68466.Charles de beer affiche ballenactie FR.pdf'
										},
										'description': {
											'nl': 'ACTIE: Karton cava gratis bij aankoop van deze deelnemende producten',
											'fr': "ACTION : Carton de cava offert a l'achat de ces produits participants"
										}
									}
								]
							},
							'banners': [
								{
									'id': '2814d6ee-6249-414e-b1aa-dbd53a471675',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/ea0048f7-623e-41ef-9b3a-99caa9120f43/jfmcrqpgolwdshziaetn97518.Banners_Folders_12_spaanse_weken_NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/ea0048f7-623e-41ef-9b3a-99caa9120f43/qftawoixjmlekyvhzrds81153.Banners_Folders_12_spaanse_weken_FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': 'eda7044b-c0b3-43e7-a952-421c07f7d4f4',
						'badge': {
							'color': {}
						},
						'filter': {},
						'start': '2025-06-11T22:00:00.000Z',
						'end': '2025-07-30T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'eda7044b-c0b3-43e7-a952-421c07f7d4f4',
							'name': {
								'nl': 'Affiche kriekepot',
								'fr': 'Affiche kriekepot'
							},
							'start': '2025-06-11T22:00:00.000Z',
							'end': '2025-07-30T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/eda7044b-c0b3-43e7-a952-421c07f7d4f4/dhltuosqkmbyficzrpev38812.Affiche cover kriekepot.jpg'
								},
								'copy': {
									'nl': 'Affiche Kriekepot - Ambachtelijk gekookte krieken',
									'fr': 'Affiche Kriekepot - Cerises cuites artisanalement'
								},
								'items': [
									{
										'id': '62a84896-6375-4555-b916-2900ac5352c8',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/eda7044b-c0b3-43e7-a952-421c07f7d4f4/qnoyfdxsizwcubgketha34686.Affiche kriekepot.pdf',
											'fr': 'https://portal.charles.eu/resources/campaigns/eda7044b-c0b3-43e7-a952-421c07f7d4f4/ylnijkcoaqrxztfdwvgm51418.Affiche kriekepot FR.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche en hang ze op in uw zaak - 1',
											'fr': "Téléchargez l'affiche ici et accrochez-la dans votre entreprise - 1"
										}
									},
									{
										'id': '9e0d64e8-6e79-4af4-94b9-e75a7c0b0d40',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/eda7044b-c0b3-43e7-a952-421c07f7d4f4/jngaqopirmwlhuszbcde35473.kriekepot-poster_Part1.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche en hang ze op in uw zaak - 2',
											'fr': ''
										}
									},
									{
										'id': '293f1ca0-ca9a-4fc2-a06b-07edac64025a',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/eda7044b-c0b3-43e7-a952-421c07f7d4f4/bupedmtoyjqivxhlwrfc96038.kriekepot-poster_Part2.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche en hang ze op in uw zaak - 3',
											'fr': ''
										}
									},
									{
										'id': '621db194-1e34-4b47-9fe4-e548dd3e2d38',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/eda7044b-c0b3-43e7-a952-421c07f7d4f4/spxfakidtvubzwymjhor17358.kriekepot-poster_Part3.pdf'
										},
										'description': {
											'nl': 'Download hier de affiche en hang ze op in uw zaak - 4',
											'fr': ''
										}
									}
								]
							}
						}
					},
					{
						'id': 'f4c7530b-0bd4-466b-ad33-f7051d5d5c9d',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							1370
						],
						'start': '2024-12-11T23:00:00.000Z',
						'end': '2024-12-19T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'f4c7530b-0bd4-466b-ad33-f7051d5d5c9d',
							'name': {
								'nl': 'Eindejaarsartikelen',
								'fr': ''
							},
							'start': '2024-12-11T23:00:00.000Z',
							'end': '2024-12-19T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									1370
								]
							},
							'inThePicture': true
						}
					},
					{
						'id': 'f706d820-1268-439b-ba09-16b458785f66',
						'badge': {
							'nl': 'Folder 15',
							'fr': 'Dépliant 15',
							'color': {
								'text': '#000000',
								'bg': '#C1AD76'
							}
						},
						'filter': {
							'nl': 'Folder 15',
							'fr': 'Dépliant 15'
						},
						'articles': [
							14,
							15,
							5522,
							26572,
							1258,
							1269,
							26533,
							26281,
							1513,
							1517,
							1637,
							1524,
							1075,
							26328,
							1080,
							25867,
							2108,
							4753,
							24213,
							24214,
							24229,
							24217,
							24218,
							24216,
							24226,
							24227,
							24228,
							24215,
							24221,
							24225,
							24219,
							24223,
							24220,
							24224,
							24222,
							24197,
							24199,
							24196,
							24198,
							23479,
							23658,
							23660,
							23974,
							23973,
							23976,
							24504,
							24722,
							24921,
							24723,
							24800,
							24931,
							25872,
							25916,
							26161,
							26257,
							26658,
							26659,
							26660,
							26661,
							26662,
							26663,
							26664,
							26665,
							26666,
							26667,
							26668,
							26669,
							26670,
							26671,
							26152,
							27090,
							27091,
							26282,
							1172,
							1049,
							1145,
							705,
							723,
							728,
							1496,
							30258,
							8008,
							26825,
							26826,
							120,
							130,
							26240,
							419,
							435,
							21469,
							2069,
							8513,
							8549,
							26872,
							2567,
							25577,
							23273,
							25524,
							26041,
							26042,
							2362,
							31563,
							2363,
							31567,
							26776,
							4911,
							4913,
							4914,
							8688,
							23786,
							1133,
							22137,
							1090,
							1137,
							21645,
							2502,
							26721,
							26722,
							26723,
							26724,
							26725,
							26726,
							26727,
							26728,
							26729,
							26730,
							26731,
							26732,
							26733,
							26734,
							26735,
							26736,
							26737,
							26738,
							26740,
							26741,
							26742,
							26743,
							26744,
							26029,
							26031,
							26032,
							26033,
							26243,
							26780,
							26781,
							26782,
							26783,
							26784,
							26321,
							26324,
							26322,
							26323,
							26377,
							33140,
							26006,
							26081,
							3210,
							33003,
							26312,
							26389,
							26391,
							26392,
							387,
							26080,
							1527,
							1566,
							1567,
							1570,
							1584,
							1580,
							1579,
							1581,
							8018,
							8021,
							19211,
							8020,
							6570,
							7008,
							8731,
							8732,
							8730,
							398,
							8417,
							1094,
							1095,
							1097,
							1537,
							1550,
							1552,
							4563,
							7525,
							7532,
							7524,
							7526,
							7529,
							7528,
							7527,
							7544,
							24768,
							7545,
							23367,
							7558,
							26142,
							7603,
							26199,
							7517,
							2391,
							2390,
							31539,
							2394,
							26795,
							2388,
							2389,
							25352,
							2335,
							31546,
							161,
							164,
							165,
							187,
							26767,
							26766,
							27112,
							169,
							163,
							30533,
							88,
							7261,
							27254,
							2383,
							1027,
							21456,
							6586,
							22438,
							22511,
							2254,
							5604,
							19252,
							24124,
							30866,
							21526,
							23742,
							8611,
							19677,
							6594,
							26332,
							26331,
							26335,
							26334,
							26333,
							7100,
							19709,
							23204,
							32205,
							32256,
							4331,
							4309,
							4301,
							4302,
							26372,
							21896,
							21722,
							7300,
							7301,
							7302,
							7303,
							7304,
							7821,
							7819,
							7820,
							7845,
							7852,
							7833,
							7854,
							7809,
							7811,
							7810,
							7830,
							7829,
							7843,
							7824,
							7835,
							7873,
							7801,
							7804,
							7803,
							7834,
							2056,
							7814,
							7815,
							7816,
							2055,
							7817,
							7838,
							7825,
							7806,
							7807,
							7297,
							7832,
							7812,
							7813
						],
						'start': '2025-08-23T22:00:00.000Z',
						'end': '2025-09-06T22:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'f706d820-1268-439b-ba09-16b458785f66',
							'name': {
								'nl': 'Folder 15 - W35-36',
								'fr': 'Dépliant 15 - S35-36'
							},
							'start': '2025-08-23T22:00:00.000Z',
							'end': '2025-09-06T22:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'filter': {
									'text': {
										'nl': 'Folder 15',
										'fr': 'Dépliant 15'
									}
								},
								'badge': {
									'text': {
										'nl': 'Folder 15',
										'fr': 'Dépliant 15'
									},
									'color': {
										'text': '#000000',
										'background': '#C1AD76'
									}
								},
								'ids': [
									14,
									15,
									5522,
									26572,
									1258,
									1269,
									26533,
									26281,
									1513,
									1517,
									1637,
									1524,
									1075,
									26328,
									1080,
									25867,
									2108,
									4753,
									24213,
									24214,
									24229,
									24217,
									24218,
									24216,
									24226,
									24227,
									24228,
									24215,
									24221,
									24225,
									24219,
									24223,
									24220,
									24224,
									24222,
									24197,
									24199,
									24196,
									24198,
									23479,
									23658,
									23660,
									23974,
									23973,
									23976,
									24504,
									24722,
									24921,
									24723,
									24800,
									24931,
									25872,
									25916,
									26161,
									26257,
									26658,
									26659,
									26660,
									26661,
									26662,
									26663,
									26664,
									26665,
									26666,
									26667,
									26668,
									26669,
									26670,
									26671,
									26152,
									27090,
									27091,
									26282,
									1172,
									1049,
									1145,
									705,
									723,
									728,
									1496,
									30258,
									8008,
									26825,
									26826,
									120,
									130,
									26240,
									419,
									435,
									21469,
									2069,
									8513,
									8549,
									26872,
									2567,
									25577,
									23273,
									25524,
									26041,
									26042,
									2362,
									31563,
									2363,
									31567,
									26776,
									4911,
									4913,
									4914,
									8688,
									23786,
									1133,
									22137,
									1090,
									1137,
									21645,
									2502,
									26721,
									26722,
									26723,
									26724,
									26725,
									26726,
									26727,
									26728,
									26729,
									26730,
									26731,
									26732,
									26733,
									26734,
									26735,
									26736,
									26737,
									26738,
									26740,
									26741,
									26742,
									26743,
									26744,
									26029,
									26031,
									26032,
									26033,
									26243,
									26780,
									26781,
									26782,
									26783,
									26784,
									26321,
									26324,
									26322,
									26323,
									26377,
									33140,
									26006,
									26081,
									3210,
									33003,
									26312,
									26389,
									26391,
									26392,
									387,
									26080,
									1527,
									1566,
									1567,
									1570,
									1584,
									1580,
									1579,
									1581,
									8018,
									8021,
									19211,
									8020,
									6570,
									7008,
									8731,
									8732,
									8730,
									398,
									8417,
									1094,
									1095,
									1097,
									1537,
									1550,
									1552,
									4563,
									7525,
									7532,
									7524,
									7526,
									7529,
									7528,
									7527,
									7544,
									24768,
									7545,
									23367,
									7558,
									26142,
									7603,
									26199,
									7517,
									2391,
									2390,
									31539,
									2394,
									26795,
									2388,
									2389,
									25352,
									2335,
									31546,
									161,
									164,
									165,
									187,
									26767,
									26766,
									27112,
									169,
									163,
									30533,
									88,
									7261,
									27254,
									2383,
									1027,
									21456,
									6586,
									22438,
									22511,
									2254,
									5604,
									19252,
									24124,
									30866,
									21526,
									23742,
									8611,
									19677,
									6594,
									26332,
									26331,
									26335,
									26334,
									26333,
									7100,
									19709,
									23204,
									32205,
									32256,
									4331,
									4309,
									4301,
									4302,
									26372,
									21896,
									21722,
									7300,
									7301,
									7302,
									7303,
									7304,
									7821,
									7819,
									7820,
									7845,
									7852,
									7833,
									7854,
									7809,
									7811,
									7810,
									7830,
									7829,
									7843,
									7824,
									7835,
									7873,
									7801,
									7804,
									7803,
									7834,
									2056,
									7814,
									7815,
									7816,
									2055,
									7817,
									7838,
									7825,
									7806,
									7807,
									7297,
									7832,
									7812,
									7813
								]
							},
							'documents': {
								'cover': {
									'multilingual': true,
									'nl': 'https://portal.charles.eu/resources/campaigns/f706d820-1268-439b-ba09-16b458785f66/bgswjfexalionkptrumh11448.Charles_Folder_15 cover.jpg',
									'weight': '100'
								},
								'copy': {
									'fr': 'Découvrez nos promotions ici',
									'nl': 'Ondek onze folderpromoties hier'
								},
								'items': [
									{
										'id': '075be870-90ee-4996-921d-dbd62a105458',
										'type': 'file',
										'file': {
											'multilingual': true,
											'nl': 'https://portal.charles.eu/resources/campaigns/f706d820-1268-439b-ba09-16b458785f66/xkyzdourahgjebiqtlps92788.Charles_Folder_15.pdf'
										},
										'description': {
											'nl': 'Klik hier om de folder te bekijken',
											'fr': 'Cliquez ici pour consulter le dépliant'
										}
									},
									{
										'id': '8bf1666c-b8c9-4662-b80f-ee37425050bb',
										'type': 'file',
										'file': {
											'multilingual': false,
											'nl': 'https://portal.charles.eu/resources/campaigns/f706d820-1268-439b-ba09-16b458785f66/fiowjyrlazmcexnkqutb12122.Charles_Folder_15_spread.pdf'
										},
										'description': {
											'nl': '',
											'fr': ''
										}
									}
								]
							},
							'banners': [
								{
									'id': 'ad072c8f-7f24-4025-a2c2-e85e7250440e',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/f706d820-1268-439b-ba09-16b458785f66/jonsgkvybiulptehmzaf31363.Banners_Folder_15 NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/f706d820-1268-439b-ba09-16b458785f66/lqofbcsauxzktpwderij77442.Banners_Folder_15 FR.jpg'
									},
									'action': {
										'type': 'filter'
									},
									'weight': '80'
								},
								{
									'id': '29d77c1e-4613-44f8-9a13-f3a73f42c085',
									'image': {
										'multilingual': false,
										'nl': 'https://portal.charles.eu/resources/campaigns/f706d820-1268-439b-ba09-16b458785f66/bltfugirmkqsdcajnwep37169.Banners_Folder_15 CP NL.jpg',
										'fr': 'https://portal.charles.eu/resources/campaigns/f706d820-1268-439b-ba09-16b458785f66/ihatrkoypfsjqgvxdnze45271.Banners_Folder_15 CP FR.jpg'
									},
									'action': {
										'type': 'none'
									},
									'weight': '100'
								}
							]
						}
					},
					{
						'id': 'fbd88e70-b4ee-4a63-8d2d-d37200ad6ede',
						'badge': {
							'nl': 'In de kijker',
							'fr': "À l'honneur",
							'color': {
								'text': '#ffffff',
								'bg': '#675583'
							}
						},
						'filter': {},
						'articles': [
							26404
						],
						'start': '2024-11-19T23:00:00.000Z',
						'end': '2024-11-26T23:00:00.000Z',
						'active': true,
						'weight': 0,
						'version': '2.1.0',
						'version2': {
							'id': 'fbd88e70-b4ee-4a63-8d2d-d37200ad6ede',
							'name': {
								'nl': 'Kaasschilfers',
								'fr': ''
							},
							'start': '2024-11-19T23:00:00.000Z',
							'end': '2024-11-26T23:00:00.000Z',
							'version': '2.1.0',
							'active': true,
							'articles': {
								'badge': {
									'text': {
										'fr': "À l'honneur",
										'nl': 'In de kijker'
									},
									'color': {
										'text': '#ffffff',
										'background': '#675583'
									}
								},
								'ids': [
									26404
								]
							},
							'inThePicture': true
						}
					}
				]
			),
		);
	}),
];
